var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "3.47in",
    height: "4.86in",
    viewBox: "0 0 250 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 350,
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.82,175.68h1.57v-.15h-1.56A.76.76,0,0,1,137.82,175.68Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.83,174.48h1.56v-.15h-1.57A.76.76,0,0,1,137.83,174.48Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.71,174.33h-1.56v.15h1.56Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,175.53h-1.56v.15h1.56Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,175h0v-.53h-1.56V175Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,175h-1.56v.52h1.56Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.68,175h-1.56v.52h1.56A4.51,4.51,0,0,0,112.68,175Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.86,175h1.56v-.53h-1.56A4.68,4.68,0,0,0,137.86,175Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,172.25h-1.6a14.56,14.56,0,0,0-.24,2.08h1.56A13.17,13.17,0,0,1,113,172.25Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,172.25a13.17,13.17,0,0,1,.28,2.08h1.57a14.56,14.56,0,0,0-.24-2.08Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,168.08h-1.83a14.24,14.24,0,0,0-1.29,3.13h1.62A12.89,12.89,0,0,1,114.77,168.08Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.76,168.08a12.19,12.19,0,0,1,1.5,3.13h1.63a14.27,14.27,0,0,0-1.3-3.13Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.48,162.88h4a14.45,14.45,0,0,0-2.15-1H120.21a14.11,14.11,0,0,0-2.16,1h4a12.27,12.27,0,0,1,6.42,0Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,177.76a13.17,13.17,0,0,1-.28-2.08h-1.56a12.16,12.16,0,0,0,.24,2.08Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,177.76h1.61a14.56,14.56,0,0,0,.24-2.08h-1.57A11.19,11.19,0,0,1,137.54,177.76Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77,181.92a12,12,0,0,1-1.5-3.12h-1.62a14,14,0,0,0,1.29,3.12Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,181.92a14,14,0,0,0,1.29-3.12h-1.62a12.63,12.63,0,0,1-1.5,3.12Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,187.13h-4a15.42,15.42,0,0,0,2.14,1h10.17a14.45,14.45,0,0,0,2.15-1h-4a12.08,12.08,0,0,1-6.48,0Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.65,171.21c-.1.34-.19.68-.26,1H113a8,8,0,0,1,.28-1Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,172.25h1.61a10.32,10.32,0,0,0-.26-1h-1.63A8,8,0,0,1,137.54,172.25Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4,167.33c-.16.24-.31.49-.46.75h1.83c.18-.26.37-.51.56-.75Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.21,167.33c.19.24.38.49.55.75h1.83c-.14-.26-.3-.51-.46-.75Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.06,162.88h-4a14.38,14.38,0,0,0-3.89,3.4h2.08A12.53,12.53,0,0,1,122.06,162.88Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48,162.88h-4a12.56,12.56,0,0,1,5.82,3.4h2.08A14.11,14.11,0,0,0,132.48,162.88Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.16,166.28a12.7,12.7,0,0,0-.76,1.05h1.93a10.07,10.07,0,0,1,.91-1.05Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.3,166.28a11.42,11.42,0,0,1,.91,1.05h1.92a12.57,12.57,0,0,0-.75-1.05Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21,161.83h10.12A14.12,14.12,0,0,0,120.21,161.83Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,178.8c-.11-.34-.2-.69-.28-1h-1.6a8.55,8.55,0,0,0,.26,1Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.27,178.8h1.62c.09-.34.19-.69.26-1h-1.61C137.46,178.11,137.38,178.46,137.27,178.8Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.32,182.68c-.19-.25-.38-.5-.55-.76h-1.83c.14.26.3.51.46.76Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.51,187.13h4a14.19,14.19,0,0,0,3.88-3.4h-2.07A12.62,12.62,0,0,1,128.51,187.13Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,187.13h4a12.58,12.58,0,0,1-5.8-3.4h-2.08A14.34,14.34,0,0,0,118,187.13Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.14,182.68c.16-.25.31-.5.46-.76h-1.83c-.18.26-.36.51-.56.76Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,183.73c.27-.34.52-.69.76-1h-1.93a12.12,12.12,0,0,1-.9,1Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,183.73c-.32-.33-.62-.69-.91-1H113.4a7.9,7.9,0,0,0,.75,1Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.35,188.17H120.18A14,14,0,0,0,130.35,188.17Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.27 172.2 60.83 171.77 60.39 172.2 58.11 174.48 57.59 175 58.13 175.53 60.41 177.81 60.83 178.23 61.25 177.81 63.53 175.53 64.07 175 63.55 174.48 61.27 172.2",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.88 174.48 189.6 172.2 189.16 171.77 188.73 172.2 186.44 174.48 185.92 175 186.46 175.53 188.74 177.81 189.16 178.23 189.58 177.81 191.87 175.53 192.4 175 191.88 174.48",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,90.52a13,13,0,0,0,1.49-.5,15.77,15.77,0,0,0-4.06-1,2,2,0,0,1,0,2.09A16.22,16.22,0,0,0,129.42,90.52Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.86,90a2,2,0,0,1,.28-1,16,16,0,0,0-2.07.38,14.19,14.19,0,0,0-2,.66,15.38,15.38,0,0,0,4.06,1A2.12,2.12,0,0,1,122.86,90Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.93,259.43a2.13,2.13,0,0,1,.21-.49,15,15,0,0,0-4.06,1,15,15,0,0,0,4.06,1,2,2,0,0,1-.28-1A1.79,1.79,0,0,1,122.93,259.43Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.14,260a2.07,2.07,0,0,1-.29,1,14.5,14.5,0,0,0,2.07-.38,14.19,14.19,0,0,0,2-.66,15,15,0,0,0-4.06-1A2.1,2.1,0,0,1,127.14,260Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.17,65.87l9.77,9.75A54.24,54.24,0,0,1,87.11,67a29.52,29.52,0,0,1-6.56.74A29.91,29.91,0,0,1,70.17,65.87Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.18,284.13A29.5,29.5,0,0,1,87.11,283a54.56,54.56,0,0,1-7.17-8.59Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.45,67.64a29.68,29.68,0,0,1-6.57-.74,54.24,54.24,0,0,1,7.18,8.6l9.76-9.74A30.1,30.1,0,0,1,169.45,67.64Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.88,282.88A29.69,29.69,0,0,1,179.81,284l-9.76-9.73A53.73,53.73,0,0,1,162.88,282.88Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,305V307l2.07-2.06a7,7,0,0,1-1.11.11Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,313.27v.52h1.48l-1.59-1.59A6.36,6.36,0,0,1,204.87,313.27Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.72,45h1V43l-2.08,2.08A5.61,5.61,0,0,1,212.72,45Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,313.79v-.52a5.69,5.69,0,0,1,.08-.83l-1.36,1.35Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.7 313.79 213.7 312.29 212.19 313.79 213.7 313.79",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.96 36.21 213.57 37.81 213.57 37.81 213.7 37.94 213.7 36.21 211.96 36.21",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.34,304.81l1.21,1.21h.1v.08l.92.92h0l.13.13V305h-1A6.28,6.28,0,0,1,211.34,304.81Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5,46.72l-.74-.74a7.14,7.14,0,0,0-2.29,5.24V298.79a7.2,7.2,0,0,0,2.16,5.14l.75-.74a6.12,6.12,0,0,1-1.86-4.4V51.22A6.12,6.12,0,0,1,208.5,46.72Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14,36.21H43.63l1.61,1.6h0a6.59,6.59,0,0,1-.1-1.09Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,36.21v.52a5.56,5.56,0,0,1-.09.82l1.35-1.34Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.42 312.2 36.3 312.07 36.3 313.79 38.02 313.79 36.42 312.2 36.42 312.2",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.3 36.21 36.3 37.71 37.8 36.21 36.3 36.21",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.66,42.92H51.34a6.17,6.17,0,0,1-4.18-1.64l-.75.76a7.18,7.18,0,0,0,4.93,2H198.66a7.23,7.23,0,0,0,5-2l-.74-.74A6.23,6.23,0,0,1,198.66,42.92Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.34,306a7.25,7.25,0,0,0-5.05,2.05l.75.75a6.16,6.16,0,0,1,4.3-1.75H198.66a6.13,6.13,0,0,1,4.17,1.64l.76-.76a7.16,7.16,0,0,0-4.93-1.93Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.52,51.22a7.2,7.2,0,0,0-2.17-5.14l-.74.74a6.17,6.17,0,0,1,1.85,4.4V298.79a6.12,6.12,0,0,1-2,4.5l.74.74a7.14,7.14,0,0,0,2.29-5.24Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45,44h-.1v-.1l-.93-.9-.12-.13V45h1a6,6,0,0,1,1.4.17l-.42-.42Z",
    style: {
      fill: "#ed2c2a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.55 328.51 21.55 291.01 19.79 289.25 19.79 330.26 60.9 330.26 59.14 328.51 21.55 328.51",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.1 19.74 190.86 21.49 228.45 21.49 228.45 21.49 228.45 59.01 230.21 60.76 230.21 19.74 189.1 19.74",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.45 328.51 228.45 328.51 190.86 328.51 189.1 330.26 230.21 330.26 230.21 289.25 228.45 291.01 228.45 328.51",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.55 21.49 59.14 21.49 60.9 19.74 19.79 19.74 19.79 60.76 21.55 59.01 21.55 21.49",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.4 61.5 227.92 61.5 228.45 61.5 229.46 61.5 228.45 60.49 227.92 59.97 227.7 59.75 227.4 59.75 221.27 59.75 221.27 290.26 227.4 290.26 227.7 290.26 227.92 290.04 228.45 289.52 229.46 288.51 228.45 288.51 227.92 288.51 227.4 288.51 223.03 288.51 223.03 61.5 227.4 61.5",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.6 288.51 22.08 288.51 21.55 288.51 20.54 288.51 21.55 289.52 22.08 290.05 22.3 290.26 22.6 290.26 28.71 290.26 28.71 59.75 22.6 59.75 22.3 59.75 22.08 59.97 21.55 60.49 20.54 61.5 21.55 61.5 22.08 61.5 22.6 61.5 26.96 61.5 26.96 288.51 22.6 288.51",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.64 22.02 61.64 21.49 61.64 20.48 60.63 21.49 60.1 22.02 59.88 22.24 59.88 22.55 59.88 28.21 190.12 28.21 190.12 22.55 190.12 22.24 189.9 22.02 189.37 21.49 188.36 20.48 188.36 21.49 188.36 22.02 188.36 22.55 188.36 26.45 61.64 26.45 61.64 22.55 61.64 22.02",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.36 327.98 188.36 328.51 188.36 329.51 189.37 328.51 189.9 327.98 190.12 327.76 190.12 327.45 190.12 321.79 59.88 321.79 59.88 327.45 59.88 327.76 60.1 327.98 60.63 328.51 61.64 329.51 61.64 328.51 61.64 327.98 61.64 327.45 61.64 323.55 188.36 323.55 188.36 327.45 188.36 327.98",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,232.83a3.45,3.45,0,0,0,.88-2.29,3.52,3.52,0,0,0-.88-2.29,3.45,3.45,0,0,0,0,4.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.67,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,71.67,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,235.23a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A5.06,5.06,0,0,1,33.32,235.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,174.94h-.77a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.8Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,244.24a4.31,4.31,0,0,1-.88.09H36a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55v1.34a3.57,3.57,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a4,4,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,258.57a3.44,3.44,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,258.57Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,252.57a4.14,4.14,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A4.21,4.21,0,0,1,33.32,252.57Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,36.61h4.07a3.55,3.55,0,0,0,.08-.73v-.31A4.58,4.58,0,0,1,60.94,31H61a4.54,4.54,0,0,1,3,1.14,3.57,3.57,0,0,0,.54-1.88H65.9a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0A3.47,3.47,0,0,0,73,30.26V30a4.17,4.17,0,0,1,.06-.71H59.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.46 35.87 58.83 28.51 58.83 23.29 51.46 30.64 51.46 35.87",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,217.89a4.64,4.64,0,0,1,.87-.49,5.06,5.06,0,0,1-.88-.49,4.64,4.64,0,0,1-.87.49A5.06,5.06,0,0,1,33.32,217.89Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,223.9a3.44,3.44,0,0,0,0-4.59,3.46,3.46,0,0,0,0,4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5,30v.26a3.49,3.49,0,0,0,.56,1.9,4.5,4.5,0,0,1,6,0,3.55,3.55,0,0,0,.54-1.88H83a3.56,3.56,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0,3.4,3.4,0,0,0,.5-1.89V30a4.17,4.17,0,0,1,.06-.71H74.44A4.52,4.52,0,0,1,74.5,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.69,30v.26a3.57,3.57,0,0,0,.56,1.9,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.34a3.56,3.56,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88V30a4.17,4.17,0,0,1,.06-.71H108.63A4.49,4.49,0,0,1,108.69,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,30v.26a3.48,3.48,0,0,0,.55,1.9,4.61,4.61,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88H100a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88V30a4.17,4.17,0,0,1,.06-.71H91.54C91.57,29.53,91.59,29.76,91.6,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,215.5a3.43,3.43,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,215.5Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,241.23a3.43,3.43,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,241.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,226.9a4.31,4.31,0,0,1-.88.09H36a3.58,3.58,0,0,0-1.91.56,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.32a6,6,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.35 58.7 29.02 58.7 36.4 51.34 30.72 51.34 23.35 58.7",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,275.91a3.44,3.44,0,0,0,0-4.59,3.46,3.46,0,0,0,0,4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,287.24a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A4.21,4.21,0,0,1,33.32,287.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,269.9a4.64,4.64,0,0,1,.87-.49,5.06,5.06,0,0,1-.88-.49,4.64,4.64,0,0,1-.87.49A5.06,5.06,0,0,1,33.32,269.9Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.72 29.9 50.71 29.9 58.09 22.55 23.35 22.55 30.72 29.9",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29,294.5a6,6,0,0,1,.85.1V278.91a4.31,4.31,0,0,1-.88.09H36a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.63,3.63,0,0,0-1.87.54,4.45,4.45,0,0,1,0,6,3.48,3.48,0,0,0,1.88.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,267.5a3.44,3.44,0,0,0,.88-2.28,3.54,3.54,0,0,0-.88-2.3,3.59,3.59,0,0,0-.87,2.3A3.48,3.48,0,0,0,33.31,267.5Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,209.56a4.32,4.32,0,0,1-.88.1H36a3.48,3.48,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a4,4,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.19,290.94a3.58,3.58,0,0,0-.87-2.29,3.47,3.47,0,0,0-.88,2.3,3.58,3.58,0,0,0,.87,2.29A3.54,3.54,0,0,0,34.19,290.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,59.44v11.4a5.81,5.81,0,0,1,.59,0h.26a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54V62.37a3.47,3.47,0,0,0,1.88-.55,4.55,4.55,0,0,1-1.15-3,4.83,4.83,0,0,1,.18-1.19Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.6 57.96 29.98 50.6 29.98 30.64 22.6 23.29 22.6 57.96",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,250.17a3.45,3.45,0,0,0,.88-2.29,3.54,3.54,0,0,0-.88-2.3,3.59,3.59,0,0,0-.87,2.3A3.51,3.51,0,0,0,33.31,250.17Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,105h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54V96.5a3.56,3.56,0,0,0,1.88-.5,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a3.53,3.53,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.29,277.16h0a4,4,0,0,1,.84.1V261.57a4.31,4.31,0,0,1-.88.09H36a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,280.26a3.45,3.45,0,0,0,0,4.58,3.45,3.45,0,0,0,.88-2.29A3.52,3.52,0,0,0,33.31,280.26Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,122a5.81,5.81,0,0,1,.59,0h.26a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a5.23,5.23,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,87.92a5.81,5.81,0,0,1,.59,0h.26a3.57,3.57,0,0,0,1.91-.55,4.49,4.49,0,0,1,0-6,3.65,3.65,0,0,0-1.88-.55V79.45a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a5.23,5.23,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,314.4v-.31a4.14,4.14,0,0,1,.06-.7H57.35c0,.24,0,.49.06.73v.25a3.57,3.57,0,0,0,.55,1.91,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0A3.56,3.56,0,0,0,72.93,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,54.1a3.72,3.72,0,0,0,1,.14h.31a4.6,4.6,0,0,1,1.16.18L212.84,52Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,131.77a4.1,4.1,0,0,1,.87-.48,5.11,5.11,0,0,1-.88-.5,4.14,4.14,0,0,1-.87.49A5.06,5.06,0,0,1,33.32,131.77Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,140.5a4.31,4.31,0,0,1-.88.09H36a3.58,3.58,0,0,0-1.91.56,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55V149a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.32a6,6,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,129.38a3.45,3.45,0,0,0,.88-2.29,3.54,3.54,0,0,0-.88-2.3,3.59,3.59,0,0,0-.87,2.3A3.51,3.51,0,0,0,33.31,129.38Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,154.83a3.43,3.43,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,154.83Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,146.43a3.45,3.45,0,0,0,.88-2.29,3.52,3.52,0,0,0-.88-2.29,3.45,3.45,0,0,0,0,4.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.02 30.64 220.02 50.6 227.4 57.96 227.4 57.96 227.4 23.29 227.4 23.29 220.02 30.64",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,148.83a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A5.06,5.06,0,0,1,33.32,148.83Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,137.78a3.44,3.44,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,137.78Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,106.39a4.31,4.31,0,0,1-.88.09H36a3.48,3.48,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3A3.54,3.54,0,0,0,36,122h.32a6,6,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,72.21a4.56,4.56,0,0,1,1.22-.63,4.62,4.62,0,0,1-1.23-.63,4.28,4.28,0,0,1-1.22.63A4.77,4.77,0,0,1,216.76,72.21Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,120.72a3.43,3.43,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,120.72Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,95.27A3.47,3.47,0,0,0,34.19,93a3.54,3.54,0,0,0-.88-2.3,3.59,3.59,0,0,0-.87,2.3A3.51,3.51,0,0,0,33.31,95.27Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,112.32a3.45,3.45,0,0,0,.88-2.29,3.52,3.52,0,0,0-.88-2.29A3.45,3.45,0,0,0,33.31,112.32Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,114.72a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A5.06,5.06,0,0,1,33.32,114.72Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,123.44a4.32,4.32,0,0,1-.88.1H36a3.48,3.48,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.57,3.57,0,0,0,1.88.54V132a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6A3.37,3.37,0,0,0,36,139h.31a4,4,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,157.55a4.32,4.32,0,0,1-.88.1H36a3.48,3.48,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.57,3.57,0,0,0,1.88.54v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a4,4,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,200.56a4.14,4.14,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A4.21,4.21,0,0,1,33.32,200.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,189.23a3.45,3.45,0,0,0,0-4.6A3.48,3.48,0,0,0,33.31,189.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,290.65V279h-.77a3.57,3.57,0,0,0-1.91.55,4.43,4.43,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55v1.34a3.57,3.57,0,0,0-1.88.54,4.37,4.37,0,0,1,.86,4.51Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.29 29.9 219.28 29.9 226.65 22.55 191.91 22.55 199.29 29.9",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,183.22a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A5.06,5.06,0,0,1,33.32,183.22Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,180.82a3.44,3.44,0,0,0,.88-2.28,3.54,3.54,0,0,0-.88-2.3,3.45,3.45,0,0,0,0,4.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,206.56a3.44,3.44,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,206.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,198.16a3.45,3.45,0,0,0,.88-2.29,3.54,3.54,0,0,0-.88-2.3,3.59,3.59,0,0,0-.87,2.3A3.51,3.51,0,0,0,33.31,198.16Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.79,30v.26a3.48,3.48,0,0,0,.55,1.9,4.66,4.66,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88V30a4.17,4.17,0,0,1,.06-.71H125.73A4.17,4.17,0,0,1,125.79,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,192.23a4.31,4.31,0,0,1-.88.09H36a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.56,3.56,0,0,0,1.88.55v1.34a3.57,3.57,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a5.17,5.17,0,0,1,.85.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,165.88a4.64,4.64,0,0,1,.87-.49,5.06,5.06,0,0,1-.88-.49,4.64,4.64,0,0,1-.87.49A5.06,5.06,0,0,1,33.32,165.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.17 28.51 198.54 35.87 198.54 30.65 191.17 23.29 191.17 28.51",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,30v.26a3.56,3.56,0,0,0,.55,1.9,4.66,4.66,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88V30a4.17,4.17,0,0,1,.06-.71H159.92A4.17,4.17,0,0,1,160,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,171.89a3.44,3.44,0,0,0,0-4.59,3.46,3.46,0,0,0,0,4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,29.26a4.49,4.49,0,0,1,.06.73v.26a3.48,3.48,0,0,0,.55,1.9,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.58,4.58,0,0,1,7.59,3.45v.25a3.22,3.22,0,0,0,.09.76h4.05l-7.38-7.35Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,174.89a4.31,4.31,0,0,1-.88.09L36,175a3.48,3.48,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.31a4,4,0,0,1,.85.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,163.49a3.43,3.43,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,163.49Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,30v.26a3.48,3.48,0,0,0,.55,1.9,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.34a3.56,3.56,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88V30a4.17,4.17,0,0,1,.06-.71H142.82A4.49,4.49,0,0,1,142.88,30Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.42,62.37v1.34a3.69,3.69,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.8V59.36l-1.71-1.71a4.83,4.83,0,0,1,.18,1.19,4.55,4.55,0,0,1-1.15,3A3.47,3.47,0,0,0,219.42,62.37Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.28 51.34 213.67 51.34 221.05 58.7 226.65 58.7 219.28 51.34",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.83 321.49 51.46 314.13 51.46 319.35 58.83 326.71 58.83 321.49",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,320.74a4.49,4.49,0,0,1-.06-.73v-.26a3.49,3.49,0,0,0-.56-1.9,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88H64.49a3.57,3.57,0,0,0-.54-1.88,4.58,4.58,0,0,1-7.58-3.45v-.25a3.84,3.84,0,0,0-.08-.76H52.2l7.38,7.35Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.23,320v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88h-1.34a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88v.3a4.17,4.17,0,0,1-.06.71h15.66A4.49,4.49,0,0,1,124.23,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,209.62h-.77a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,227h-.77a3.58,3.58,0,0,0-1.91.56,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.32a3.84,3.84,0,0,1,.48,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,320v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88H98.69a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14,3.47,3.47,0,0,0-.55,1.88v.3a4.21,4.21,0,0,1,0,.71h15.65A4.43,4.43,0,0,1,107.13,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.67,317.07a4.25,4.25,0,0,1,.5.88,5.15,5.15,0,0,1,.49-.89,4.64,4.64,0,0,1-.49-.87A4.25,4.25,0,0,1,64.67,317.07Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.65,287.42v-1.34a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.87v11.61l1.91,1.9a4.42,4.42,0,0,1-.3-1.52,4.6,4.6,0,0,1,1.15-3A3.53,3.53,0,0,0,30.65,287.42Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,317.07a3.67,3.67,0,0,0,4.58,0A3.67,3.67,0,0,0,186.76,317.07Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.34,317.06a4.32,4.32,0,0,1,.5.89,5.06,5.06,0,0,1,.49-.88,5.06,5.06,0,0,1-.49-.88A4.18,4.18,0,0,1,184.34,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,314.37a3.48,3.48,0,0,0,.55,1.91,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0,3.55,3.55,0,0,0,.54-1.88v-.31a4.14,4.14,0,0,1,.06-.7H177a4.49,4.49,0,0,1,.06.73Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.98 299.41 22.6 292.06 22.6 326.71 29.98 319.35 29.98 299.41",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.71 320.1 30.72 320.1 23.35 327.45 58.09 327.45 50.71 320.1",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,182.92,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.72 298.67 36.4 298.67 29.02 291.31 23.35 291.31 30.72 298.67",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,261.62h-.77a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.5,4.5,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.32a3.84,3.84,0,0,1,.48,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,313.39h-4.05a3,3,0,0,0-.09.73v.31a4.58,4.58,0,0,1-7.55,3.48l0,0a3.69,3.69,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88v.3a4.17,4.17,0,0,1-.06.71h13.41Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,97.67a4.14,4.14,0,0,1,.87-.49,5.11,5.11,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A4.21,4.21,0,0,1,33.32,97.67Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,123.5a4.34,4.34,0,0,1-.51,0h-.26a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.57,3.57,0,0,0,1.88.54V132a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.54 314.13 191.17 321.49 191.17 326.71 198.54 319.35 198.54 314.13",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,157.61h-.77a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.57,3.57,0,0,0,1.88.54v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,140.55h-.77a3.58,3.58,0,0,0-1.91.56,4.43,4.43,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55V149a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.8Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,72.33a4.34,4.34,0,0,1-.51,0h-.26a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.32a3.84,3.84,0,0,1,.48,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.65 291.31 221.05 291.31 213.67 298.67 219.28 298.67 226.65 291.31",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.28 320.1 199.29 320.1 191.91 327.45 226.65 327.45 219.28 320.1",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,244.29a4.34,4.34,0,0,1-.51,0h-.26a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.56,3.56,0,0,0,1.88.55v1.34a3.57,3.57,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,106.44a4.34,4.34,0,0,1-.51,0h-.26a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.32a3.84,3.84,0,0,1,.48,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,89.39a4.34,4.34,0,0,1-.51,0h-.26a3.57,3.57,0,0,0-1.91.55,4.49,4.49,0,0,1,0,6,3.57,3.57,0,0,0,1.88.54v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a3.84,3.84,0,0,1,.48,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32,320v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14,3.47,3.47,0,0,0-.55,1.88v.3a4.17,4.17,0,0,1-.06.71h15.65A4.48,4.48,0,0,1,141.32,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.82,317.06a3.68,3.68,0,0,0-4.57,0A3.65,3.65,0,0,0,165.82,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.51,320v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14,3.47,3.47,0,0,0-.55,1.88v.3a4.17,4.17,0,0,1-.06.71h15.65A4.48,4.48,0,0,1,175.51,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,320v-.26a3.57,3.57,0,0,0-.56-1.9,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88H150a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88v.3a4.17,4.17,0,0,1-.06.71H158.5A4.41,4.41,0,0,1,158.42,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,320v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.69,3.69,0,0,0-.54,1.88H81.59a3.57,3.57,0,0,0-.54-1.88,4.5,4.5,0,0,1-6,0,3.48,3.48,0,0,0-.56,1.88v.3a4.17,4.17,0,0,1-.06.71H90.1A4.42,4.42,0,0,1,90,320Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,105.86,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,317.06a5.06,5.06,0,0,1,.49.88,5.06,5.06,0,0,1,.49-.88,4.64,4.64,0,0,1-.49-.87A4.64,4.64,0,0,1,98.87,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,190.53a3.92,3.92,0,0,1,.59-.05h.26a3.57,3.57,0,0,0,1.91-.55,4.49,4.49,0,0,1,0-6,3.65,3.65,0,0,0-1.88-.55V182a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.12,314.4v-.31a4.14,4.14,0,0,1,.06-.7H91.54c0,.24,0,.49.06.73v.25a3.48,3.48,0,0,0,.55,1.91,4.61,4.61,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88H100a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0A3.5,3.5,0,0,0,107.12,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21,314.4v-.31a4.14,4.14,0,0,1,.06-.7H108.63a4.49,4.49,0,0,1,.06.73v.25a3.58,3.58,0,0,0,.56,1.91,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.34a3.47,3.47,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0A3.46,3.46,0,0,0,124.21,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,317.06a3.71,3.71,0,0,0-4.59,0A3.68,3.68,0,0,0,123,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,97.44,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.22,192.28h-.77a3.57,3.57,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.56,3.56,0,0,0,1.88.55v1.34a3.57,3.57,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31l.49.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.77,317.06a3.71,3.71,0,0,0-4.59,0A3.68,3.68,0,0,0,88.77,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.25,317.06a5.06,5.06,0,0,1,.49.88,5.06,5.06,0,0,1,.49-.88,4.64,4.64,0,0,1-.49-.87A4.64,4.64,0,0,1,167.25,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,314.4v-.31a4.14,4.14,0,0,1,.06-.7H74.44a4.49,4.49,0,0,1,.06.73v.25a3.49,3.49,0,0,0,.56,1.91,4.5,4.5,0,0,1,6,0,3.55,3.55,0,0,0,.54-1.88H83a3.47,3.47,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0A3.47,3.47,0,0,0,90,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,173.19h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.57,3.57,0,0,0,1.88-.54,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a5.29,5.29,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,139.08h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.57,3.57,0,0,0,1.88-.54,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a5.29,5.29,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.25,317.07a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,63.25,317.07Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,156.14h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.55,4.55,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.55,3.55,0,0,0-1.88-.54h-.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.35,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,80.35,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.77,317.06a4.25,4.25,0,0,1,.5.88,4.21,4.21,0,0,1,.49-.88,4.14,4.14,0,0,1-.49-.87A4.18,4.18,0,0,1,81.77,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,207.86h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54V199.4a3.56,3.56,0,0,0,1.88-.55,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,317.06a4.25,4.25,0,0,1,.5.88,5.06,5.06,0,0,1,.49-.88,4.64,4.64,0,0,1-.49-.87A4.18,4.18,0,0,1,150.15,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,314.4v-.31a4.14,4.14,0,0,1,.06-.7H142.82a4.49,4.49,0,0,1,.06.73v.25a3.48,3.48,0,0,0,.55,1.91,4.5,4.5,0,0,1,6,0,3.47,3.47,0,0,0,.55-1.88h1.34a3.47,3.47,0,0,0,.55,1.88,4.5,4.5,0,0,1,6,0A3.47,3.47,0,0,0,158.4,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,317.06a4.25,4.25,0,0,1,.5.88,4.21,4.21,0,0,1,.49-.88,4.14,4.14,0,0,1-.49-.87A4.18,4.18,0,0,1,116,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.73,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,148.73,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,259.87h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.56,3.56,0,0,0,1.88-.55,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a3.53,3.53,0,0,1-.56-.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,277.21h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,314.4v-.31a4.14,4.14,0,0,1,.06-.7H159.92a4.49,4.49,0,0,1,.06.73v.25a3.57,3.57,0,0,0,.55,1.91,4.66,4.66,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0A3.47,3.47,0,0,0,175.5,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.25,317.06a3.71,3.71,0,0,0-4.59,0A3.68,3.68,0,0,0,174.25,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.15,317.06a3.71,3.71,0,0,0-4.59,0A3.68,3.68,0,0,0,157.15,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,225.2h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31,314.4v-.31a4.14,4.14,0,0,1,.06-.7H125.73a4.49,4.49,0,0,1,.06.73v.25a3.48,3.48,0,0,0,.55,1.91,4.61,4.61,0,0,1,3-1.14,4.54,4.54,0,0,1,3,1.14,3.47,3.47,0,0,0,.55-1.88h1.35a3.57,3.57,0,0,0,.54,1.88,4.5,4.5,0,0,1,6,0A3.56,3.56,0,0,0,141.31,314.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.54,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,114.54,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,140.05,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,317.06a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,131.63,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06,317.06a5.06,5.06,0,0,1,.49.88,5.06,5.06,0,0,1,.49-.88,4.64,4.64,0,0,1-.49-.87A4.64,4.64,0,0,1,133.06,317.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.77,242.54h.85a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a5.23,5.23,0,0,1-.56,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,318.24a4.75,4.75,0,0,1,.62-1.18,4.69,4.69,0,0,1-.62-1.17,4.69,4.69,0,0,1-.62,1.17A4.75,4.75,0,0,1,73.72,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,225.27a4.21,4.21,0,0,1,1-.12h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,210.91a3.44,3.44,0,0,0,0,4.59,3.51,3.51,0,0,0,.87-2.29A3.59,3.59,0,0,0,216.76,210.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,216.91a5.06,5.06,0,0,1-.88.49,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.64,4.64,0,0,1,216.76,216.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,219.31a3.44,3.44,0,0,0,0,4.59,3.59,3.59,0,0,0,.87-2.3A3.46,3.46,0,0,0,216.75,219.31Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,295.67a3.28,3.28,0,0,0-.88-.12H36a4.53,4.53,0,0,1-1.46-.26l2.65,2.65Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,236.64a3.59,3.59,0,0,0-.87,2.3,3.52,3.52,0,0,0,.88,2.29,3.44,3.44,0,0,0,0-4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,277.32a4.34,4.34,0,0,1-1.68.76,4.78,4.78,0,0,1,1.69.76,4.82,4.82,0,0,1,1.68-.76A4.61,4.61,0,0,1,33.31,277.32Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,261.5a4.55,4.55,0,0,1,1.68-.75,5,5,0,0,1-1.69-.76,4.55,4.55,0,0,1-1.68.75A5,5,0,0,1,33.32,261.5Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.82,318.24a4.41,4.41,0,0,1,.61-1.18,4.35,4.35,0,0,1-.61-1.17,4.69,4.69,0,0,1-.62,1.17A4.75,4.75,0,0,1,90.82,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,193.57a3.54,3.54,0,0,0-.88,2.3,3.45,3.45,0,0,0,.88,2.29,3.51,3.51,0,0,0,.87-2.29A3.59,3.59,0,0,0,216.76,193.57Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,207.93a4.79,4.79,0,0,1,1-.11h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54V199.4a3.56,3.56,0,0,0,1.88-.55,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a5.9,5.9,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,103.67a3.44,3.44,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,103.67Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,32.94a5.06,5.06,0,0,1-.49-.88,4.25,4.25,0,0,1-.5.88,4.18,4.18,0,0,1,.5.87A4.64,4.64,0,0,1,151.14,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,318.24a4.17,4.17,0,0,1,.62-1.18,4.69,4.69,0,0,1-.62-1.17,4.69,4.69,0,0,1-.62,1.17A4.75,4.75,0,0,1,159.2,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,244.17a4.34,4.34,0,0,1,1.68-.76,4.61,4.61,0,0,1-1.69-.76,4.66,4.66,0,0,1-1.68.76A4.61,4.61,0,0,1,33.32,244.17Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.91,318.24a4.75,4.75,0,0,1,.62-1.18,4.69,4.69,0,0,1-.62-1.17,4.69,4.69,0,0,1-.62,1.17A4.75,4.75,0,0,1,107.91,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,318.24a4.17,4.17,0,0,1,.62-1.18,4,4,0,0,1-.62-1.17,4.75,4.75,0,0,1-.62,1.18A4.69,4.69,0,0,1,125,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,226.83a4.82,4.82,0,0,1,1.68-.76,4.76,4.76,0,0,1-1.69-.75,4.55,4.55,0,0,1-1.68.75A4.78,4.78,0,0,1,33.32,226.83Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,254a3.44,3.44,0,0,0,0,4.59A3.44,3.44,0,0,0,216.75,254Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,89.27a4.69,4.69,0,0,1,1.17-.62A4.85,4.85,0,0,1,33.31,88a4.69,4.69,0,0,1-1.17.62A4.85,4.85,0,0,1,33.32,89.27Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,72.21a4.56,4.56,0,0,1,1.22-.63A4.62,4.62,0,0,1,33.31,71a4.56,4.56,0,0,1-1.22.63A4.62,4.62,0,0,1,33.32,72.21Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,106.32a4.69,4.69,0,0,1,1.17-.62,4.41,4.41,0,0,1-1.18-.61,4.35,4.35,0,0,1-1.17.61A4.75,4.75,0,0,1,33.32,106.32Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,245.58a3.59,3.59,0,0,0-.87,2.3,3.45,3.45,0,0,0,.88,2.29,3.44,3.44,0,0,0,0-4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,140.43a4.69,4.69,0,0,1,1.17-.62,4.41,4.41,0,0,1-1.18-.61,4.35,4.35,0,0,1-1.17.61A4.75,4.75,0,0,1,33.32,140.43Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,251.58a4.25,4.25,0,0,1-.88.5,4.21,4.21,0,0,1,.88.49,4.14,4.14,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,251.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,54.12v-2l-2.35,2.34A5,5,0,0,1,36,54.25h.26A3.74,3.74,0,0,0,37.14,54.12Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,157.48a4.35,4.35,0,0,1,1.17-.61,4.75,4.75,0,0,1-1.18-.62,4.69,4.69,0,0,1-1.17.62A4.41,4.41,0,0,1,33.32,157.48Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,199.57a4.25,4.25,0,0,1-.88.5,4.21,4.21,0,0,1,.88.49,4.14,4.14,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,199.57Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,209.49a4.55,4.55,0,0,1,1.68-.75,4.78,4.78,0,0,1-1.69-.76,4.82,4.82,0,0,1-1.68.76A4.76,4.76,0,0,1,33.32,209.49Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,192.16A4.34,4.34,0,0,1,35,191.4a4.61,4.61,0,0,1-1.69-.76,4.34,4.34,0,0,1-1.68.76A4.61,4.61,0,0,1,33.32,192.16Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,234.24a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,234.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,242.6a5.57,5.57,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,228.25a3.43,3.43,0,0,0,0,4.58,3.51,3.51,0,0,0,.87-2.29A3.58,3.58,0,0,0,216.76,228.25Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,174.82a4.82,4.82,0,0,1,1.68-.76,4.76,4.76,0,0,1-1.69-.75,4.55,4.55,0,0,1-1.68.75A5,5,0,0,1,33.32,174.82Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,99.08a3.44,3.44,0,0,0,0,4.59,3.59,3.59,0,0,0,.87-2.3A3.46,3.46,0,0,0,216.75,99.08Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,116.13a3.59,3.59,0,0,0-.87,2.3,3.52,3.52,0,0,0,.88,2.29,3.44,3.44,0,0,0,0-4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,113.73a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,113.73Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,167.3a3.44,3.44,0,0,0,0,4.59,3.59,3.59,0,0,0,.87-2.3A3.46,3.46,0,0,0,216.75,167.3Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,105a4.79,4.79,0,0,1,1-.11h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54V96.5A3.56,3.56,0,0,0,216,96a4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a4.92,4.92,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,164.9a5.06,5.06,0,0,1-.88.49,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.64,4.64,0,0,1,216.76,164.9Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,107.74a3.43,3.43,0,0,0,0,4.58,3.51,3.51,0,0,0,.87-2.29A3.58,3.58,0,0,0,216.76,107.74Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,158.9a3.44,3.44,0,0,0,0,4.59,3.51,3.51,0,0,0,.87-2.29A3.59,3.59,0,0,0,216.76,158.9Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,90.68a3.54,3.54,0,0,0-.88,2.3,3.45,3.45,0,0,0,.88,2.29,3.51,3.51,0,0,0,.87-2.29A3.59,3.59,0,0,0,216.76,90.68Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,130.79a4.21,4.21,0,0,1-.88.49,5.06,5.06,0,0,1,.88.49,4.59,4.59,0,0,1,.87-.48A4.18,4.18,0,0,1,216.76,130.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,141.85a3.43,3.43,0,0,0,0,4.58A3.45,3.45,0,0,0,216.76,141.85Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,139.15a4.79,4.79,0,0,1,1-.11h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54V130.6a3.57,3.57,0,0,0,1.88-.54,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31l-.94-.13Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,124.79a3.54,3.54,0,0,0-.88,2.3,3.45,3.45,0,0,0,.88,2.29,3.51,3.51,0,0,0,.87-2.29A3.59,3.59,0,0,0,216.76,124.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,147.84a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,147.84Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,133.19a3.44,3.44,0,0,0,0,4.59,3.59,3.59,0,0,0,.87-2.3A3.46,3.46,0,0,0,216.75,133.19Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,156.2a4.79,4.79,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.55,4.55,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.55,3.55,0,0,0-1.88-.54h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,122.09a4.79,4.79,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54v-1.34A3.47,3.47,0,0,0,216,113a4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,96.68a5.11,5.11,0,0,1-.88.5,4.21,4.21,0,0,1,.88.49,4.14,4.14,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,96.68Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,69.53a3.44,3.44,0,0,0,0-4.59,3.46,3.46,0,0,0,0,4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,58.85a3.48,3.48,0,0,0,.87,2.28,3.45,3.45,0,0,0,.88-2.29,3.58,3.58,0,0,0-.87-2.29A3.54,3.54,0,0,0,215.88,58.85Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,62.54a4.18,4.18,0,0,1-.87.5,4.21,4.21,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.25,4.25,0,0,1,216.75,62.54Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,182.23a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,182.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,173.26a4.79,4.79,0,0,1,1-.11h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.57,3.57,0,0,0,1.88-.54,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a4.83,4.83,0,0,1-.93-.12Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,176.24a3.42,3.42,0,0,0,0,4.58,3.48,3.48,0,0,0,.87-2.28A3.59,3.59,0,0,0,216.76,176.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,202a3.44,3.44,0,0,0,0,4.59A3.44,3.44,0,0,0,216.75,202Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,190.59a4.79,4.79,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.49,4.49,0,0,1,0-6,3.65,3.65,0,0,0-1.88-.55V182a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.29,318.24a4.75,4.75,0,0,1,.62-1.18,4.69,4.69,0,0,1-.62-1.17,4,4,0,0,1-.62,1.17A4.17,4.17,0,0,1,176.29,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.78,72.37h0a4.22,4.22,0,0,1-.93-.11V88a4.79,4.79,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.49,4.49,0,0,1,0-6,3.65,3.65,0,0,0-1.88-.55V79.45A3.46,3.46,0,0,0,216,78.9a4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.78,55.29a7.32,7.32,0,0,1-.94-.12V70.9a4.79,4.79,0,0,1,1-.11h.25a3.57,3.57,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54V62.37a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.48,3.48,0,0,0-1.88-.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,73.63a3.52,3.52,0,0,0-.88,2.29,3.45,3.45,0,0,0,.88,2.29,3.46,3.46,0,0,0,.87-2.29A3.58,3.58,0,0,0,216.76,73.63Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,259.94a4.79,4.79,0,0,1,1-.11h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.69,3.69,0,0,0-1.88-.54V251.4a3.47,3.47,0,0,0,1.88-.55,4.49,4.49,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.32a4.92,4.92,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,82a3.45,3.45,0,0,0,0,4.6,3.59,3.59,0,0,0,.87-2.3A3.48,3.48,0,0,0,216.75,82Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,184.63a3.45,3.45,0,0,0,0,4.6,3.59,3.59,0,0,0,.87-2.3A3.48,3.48,0,0,0,216.75,184.63Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,79.62a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.18,4.18,0,0,1,216.76,79.62Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,318.24a4.75,4.75,0,0,1,.62-1.18,4.69,4.69,0,0,1-.62-1.17,4.17,4.17,0,0,1-.62,1.18A4.69,4.69,0,0,1,142.1,318.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,32.94a4.21,4.21,0,0,1-.49-.88,4.25,4.25,0,0,1-.5.88,4.18,4.18,0,0,1,.5.87A4.14,4.14,0,0,1,117,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.76,32.94a4.21,4.21,0,0,1-.49-.88,4.25,4.25,0,0,1-.5.88,4.18,4.18,0,0,1,.5.87A4.14,4.14,0,0,1,82.76,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.37,32.94a3.71,3.71,0,0,0,4.59,0A3.68,3.68,0,0,0,118.37,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,32.94a5.06,5.06,0,0,1-.49-.88,5.06,5.06,0,0,1-.49.88,4.64,4.64,0,0,1,.49.87A4.64,4.64,0,0,1,99.85,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.61,35.6v.31a4.09,4.09,0,0,1,0,.7h15.65a4.49,4.49,0,0,1-.06-.73v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0A3.6,3.6,0,0,0,100,35.6H98.69a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14A3.47,3.47,0,0,0,91.61,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.35,32.94a3.67,3.67,0,0,0-4.58,0A3.7,3.7,0,0,0,80.35,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.51,35.6v.31a4.14,4.14,0,0,1-.06.7H90.1a4.49,4.49,0,0,1-.06-.73v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0A3.69,3.69,0,0,0,83,35.6H81.59a3.55,3.55,0,0,0-.54-1.88,4.5,4.5,0,0,1-6,0A3.38,3.38,0,0,0,74.51,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28,32.94a3.67,3.67,0,0,0,4.58,0A3.67,3.67,0,0,0,101.28,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.44,32.94a3.67,3.67,0,0,0-4.58,0A3.7,3.7,0,0,0,97.44,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,32.94a5.06,5.06,0,0,1-.49-.88,5.06,5.06,0,0,1-.49.88,4.64,4.64,0,0,1,.49.87A4.64,4.64,0,0,1,134,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.63,32.94a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,131.63,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,139.2a4.35,4.35,0,0,1-1.17.61,4.75,4.75,0,0,1,1.18.62,4.69,4.69,0,0,1,1.17-.62A4.41,4.41,0,0,1,216.75,139.2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,35.6v.3a4.17,4.17,0,0,1-.06.71h15.65a4.49,4.49,0,0,1-.06-.73v-.25a3.48,3.48,0,0,0-.55-1.91,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14A3.38,3.38,0,0,0,125.8,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,122.14a4.75,4.75,0,0,1-1.18.62,4.17,4.17,0,0,1,1.18.62,4.69,4.69,0,0,1,1.17-.62A4.69,4.69,0,0,1,216.76,122.14Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.54,32.94a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,114.54,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,32.94a3.67,3.67,0,0,0,4.58,0A3.67,3.67,0,0,0,135.47,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.71,35.6v.3a4.17,4.17,0,0,1-.06.71h15.66a4.49,4.49,0,0,1-.06-.73v-.25a3.48,3.48,0,0,0-.55-1.91,4.5,4.5,0,0,1-6,0,3.65,3.65,0,0,0-.55,1.88h-1.34a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0A3.47,3.47,0,0,0,108.71,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.09,32.94a3.67,3.67,0,0,0,4.58,0A3.67,3.67,0,0,0,67.09,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,88a4.69,4.69,0,0,1-1.17.62,4.75,4.75,0,0,1,1.18.62,4.69,4.69,0,0,1,1.17-.62A4.75,4.75,0,0,1,216.75,88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,105.09a4.35,4.35,0,0,1-1.17.61,4.75,4.75,0,0,1,1.18.62,4.69,4.69,0,0,1,1.17-.62A4.41,4.41,0,0,1,216.75,105.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,62.54a4.25,4.25,0,0,1-.88.5,5.06,5.06,0,0,1,.88.49,4.14,4.14,0,0,1,.87-.49A4.18,4.18,0,0,1,33.32,62.54Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.44,58.84a3.45,3.45,0,0,0,.88,2.29,3.43,3.43,0,0,0,0-4.58A3.52,3.52,0,0,0,32.44,58.84Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,86.62a3.45,3.45,0,0,0,0-4.6A3.48,3.48,0,0,0,33.31,86.62Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,89.33a4.32,4.32,0,0,1-.88.1H36a3.45,3.45,0,0,0-1.9.57,4.49,4.49,0,0,1,0,6,3.6,3.6,0,0,0,1.9.5v1.35a3.57,3.57,0,0,0-1.88.54,4.49,4.49,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31a4,4,0,0,1,.84.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,78.21a3.45,3.45,0,0,0,.88-2.29,3.52,3.52,0,0,0-.88-2.29,3.58,3.58,0,0,0-.87,2.29A3.46,3.46,0,0,0,33.31,78.21Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,80.61a4.64,4.64,0,0,1,.87-.49,4.25,4.25,0,0,1-.88-.5,4.18,4.18,0,0,1-.87.5A5.06,5.06,0,0,1,33.32,80.61Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,72.28a4.31,4.31,0,0,1-.88.09H36a3.48,3.48,0,0,0-1.91.55,4.6,4.6,0,0,1,1.15,3,4.55,4.55,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55v1.34a3.65,3.65,0,0,0-1.88.55,4.5,4.5,0,0,1,1.15,3,4.6,4.6,0,0,1-1.15,3,3.47,3.47,0,0,0,1.88.55h.31l.85.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.25,32.93a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,63.25,32.93Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,35.63a3.57,3.57,0,0,0-.55-1.91,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88H64.5a3.47,3.47,0,0,0-.5-1.88,4.5,4.5,0,0,1-6,0,3.47,3.47,0,0,0-.55,1.88v.31c0,.23,0,.47,0,.7H73a4.49,4.49,0,0,1-.06-.73Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.18,32.94a3.71,3.71,0,0,0,4.59,0A3.68,3.68,0,0,0,84.18,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.31,69.53a3.44,3.44,0,0,0,0-4.59A3.46,3.46,0,0,0,33.31,69.53Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66,32.94a5.15,5.15,0,0,1-.49-.89,4.25,4.25,0,0,1-.5.88,4.25,4.25,0,0,1,.5.88A4.64,4.64,0,0,1,65.66,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.25,58.85a4.5,4.5,0,0,1-1.15,3A3.47,3.47,0,0,0,36,62.4v1.34a3.69,3.69,0,0,0-1.88.54,4.45,4.45,0,0,1,0,6,3.47,3.47,0,0,0,1.88.55h.31l.85.11V55.2a4.31,4.31,0,0,1-.88.09H36a3.49,3.49,0,0,0-1.91.56A4.61,4.61,0,0,1,35.25,58.85Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.56,32.94a3.71,3.71,0,0,0,4.59,0A3.68,3.68,0,0,0,152.56,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,262.92a3.59,3.59,0,0,0-.87,2.3,3.44,3.44,0,0,0,.88,2.28,3.43,3.43,0,0,0,0-4.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.29,31.76a4.17,4.17,0,0,1-.62,1.18,4,4,0,0,1,.62,1.17,4.69,4.69,0,0,1,.62-1.17A4.75,4.75,0,0,1,176.29,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,291a3.54,3.54,0,0,0-.88-2.3,3.44,3.44,0,0,0,0,4.59A3.52,3.52,0,0,0,217.63,291Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,31.76a4.75,4.75,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4,4,0,0,1,.62-1.17A4.75,4.75,0,0,1,159.2,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,287.24a4.21,4.21,0,0,1,.88-.49,4.18,4.18,0,0,1-.87-.5,4.25,4.25,0,0,1-.88.5A4.14,4.14,0,0,1,216.75,287.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,295.69V298l2.75-2.73a4.78,4.78,0,0,1-1.5.26h-.26A3.66,3.66,0,0,0,212.84,295.69Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.84,277.28a4.21,4.21,0,0,1,1-.12h.25a3.48,3.48,0,0,0,1.91-.55,4.45,4.45,0,0,1,0-6,3.57,3.57,0,0,0-1.88-.54v-1.35a3.47,3.47,0,0,0,1.88-.55,4.5,4.5,0,0,1-1.15-3,4.6,4.6,0,0,1,1.15-3,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.82,290.94a4.66,4.66,0,0,1,1.14-3,3.63,3.63,0,0,0-1.87-.54v-1.34a3.47,3.47,0,0,0,1.88-.55,4.43,4.43,0,0,1,0-6,3.47,3.47,0,0,0-1.88-.55h-.31a4.22,4.22,0,0,1-.93-.11v15.72a4.79,4.79,0,0,1,1-.11h.25a3.53,3.53,0,0,0,1.92-.56A4.53,4.53,0,0,1,214.82,290.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.09,35.6v.3a4.17,4.17,0,0,1-.06.71h15.66a4.49,4.49,0,0,1-.06-.73v-.26a3.75,3.75,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.57,3.57,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0A3.47,3.47,0,0,0,177.09,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,31.76a4.17,4.17,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4.69,4.69,0,0,1,.62-1.17A4.75,4.75,0,0,1,142.1,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.82,31.76a4.75,4.75,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4.35,4.35,0,0,1,.61-1.17A4.41,4.41,0,0,1,90.82,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.72,31.76a4.75,4.75,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4.69,4.69,0,0,1,.62-1.17A4.75,4.75,0,0,1,73.72,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,277.33a4.59,4.59,0,0,1-1.69.75,4.78,4.78,0,0,1,1.69.76,4.82,4.82,0,0,1,1.68-.76A4.55,4.55,0,0,1,216.76,277.33Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.91,31.76a4.75,4.75,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4.69,4.69,0,0,1,.62-1.17A4.75,4.75,0,0,1,107.91,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,268.92a5.06,5.06,0,0,1-.88.49,5.06,5.06,0,0,1,.88.49,4.64,4.64,0,0,1,.87-.49A4.64,4.64,0,0,1,216.76,268.92Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,271.32a3.44,3.44,0,0,0,0,4.59,3.59,3.59,0,0,0,.87-2.3A3.46,3.46,0,0,0,216.75,271.32Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,31.76a4.75,4.75,0,0,1-.62,1.18,4.69,4.69,0,0,1,.62,1.17,4,4,0,0,1,.62-1.17A4.17,4.17,0,0,1,125,31.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,280.26a3.58,3.58,0,0,0-.87,2.29,3.45,3.45,0,0,0,.88,2.29,3.43,3.43,0,0,0,0-4.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,173.31a4.47,4.47,0,0,1-1.68.75,5,5,0,0,1,1.69.76,4.82,4.82,0,0,1,1.68-.76A4.76,4.76,0,0,1,216.75,173.31Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,156.25a4.69,4.69,0,0,1-1.17.62,4.41,4.41,0,0,1,1.18.61,4.35,4.35,0,0,1,1.17-.61A4.75,4.75,0,0,1,216.75,156.25Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,260a4.59,4.59,0,0,1-1.69.75,5,5,0,0,1,1.69.76,4.55,4.55,0,0,1,1.68-.75A4.82,4.82,0,0,1,216.76,260Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,35.6v.31a4.14,4.14,0,0,1-.06.7h15.65a4.49,4.49,0,0,1-.06-.73v-.26a3.56,3.56,0,0,0-.55-1.9,4.5,4.5,0,0,1-6,0,3.69,3.69,0,0,0-.54,1.88h-1.35a3.47,3.47,0,0,0-.55-1.88,4.54,4.54,0,0,1-3,1.14,4.61,4.61,0,0,1-3-1.14A3.55,3.55,0,0,0,160,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.82,32.94a3.63,3.63,0,0,0-4.57,0A3.68,3.68,0,0,0,165.82,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.92,32.94a3.67,3.67,0,0,0-4.58,0A3.7,3.7,0,0,0,182.92,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.33,32.93a5.06,5.06,0,0,1-.49-.88,4.6,4.6,0,0,1-.5.89,4.18,4.18,0,0,1,.5.87A5.06,5.06,0,0,1,185.33,32.93Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.76,32.93a3.67,3.67,0,0,0,4.58,0A3.67,3.67,0,0,0,186.76,32.93Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,32.94a5.06,5.06,0,0,1-.49-.88,5.06,5.06,0,0,1-.49.88,4.64,4.64,0,0,1,.49.87A4.64,4.64,0,0,1,168.23,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,225.32a4.47,4.47,0,0,1-1.68.75,4.78,4.78,0,0,1,1.69.76,4.82,4.82,0,0,1,1.68-.76A4.76,4.76,0,0,1,216.75,225.32Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.76,242.65a4.78,4.78,0,0,1-1.69.76,4.61,4.61,0,0,1,1.69.76,4.34,4.34,0,0,1,1.68-.76A4.34,4.34,0,0,1,216.76,242.65Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,208a4.74,4.74,0,0,1-1.68.76,4.76,4.76,0,0,1,1.69.75,4.55,4.55,0,0,1,1.68-.75A4.78,4.78,0,0,1,216.75,208Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,190.64a4.34,4.34,0,0,1-1.68.76,4.61,4.61,0,0,1,1.69.76,4.34,4.34,0,0,1,1.68-.76A4.61,4.61,0,0,1,216.75,190.64Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.66,32.94a3.71,3.71,0,0,0,4.59,0A3.68,3.68,0,0,0,169.66,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,35.6v.31a4.14,4.14,0,0,1-.06.7H158.5a4.49,4.49,0,0,1-.06-.73v-.26a3.57,3.57,0,0,0-.56-1.9,4.5,4.5,0,0,1-6,0,3.65,3.65,0,0,0-.55,1.88H150a3.47,3.47,0,0,0-.55-1.88,4.5,4.5,0,0,1-6,0A3.47,3.47,0,0,0,142.9,35.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.73,32.94a3.67,3.67,0,0,0-4.58,0A3.67,3.67,0,0,0,148.73,32.94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.32,123.38a4.69,4.69,0,0,1,1.17-.62,4.75,4.75,0,0,1-1.18-.62,4.69,4.69,0,0,1-1.17.62A4.17,4.17,0,0,1,33.32,123.38Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.75,150.24a3.59,3.59,0,0,0-.87,2.3,3.52,3.52,0,0,0,.88,2.29,3.44,3.44,0,0,0,0-4.59Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.4 326.71 227.4 292.06 227.4 292.06 220.02 299.41 220.02 319.35 227.4 326.71 227.4 326.71",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.97 319.05 218.97 300.46 217.21 302.22 217.21 317.3 202.1 317.3 200.34 319.05 218.97 319.05",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.03 301.47 216.47 301.47 218.22 299.72 211.79 299.72 211.79 50.29 218.22 50.29 216.47 48.54 210.03 48.54 210.03 301.47",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.1 32.7 217.21 32.7 217.21 47.8 218.97 49.55 218.97 30.95 200.34 30.95 202.1 32.7",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.66 30.95 31.03 30.95 31.03 49.55 32.79 47.8 32.79 32.7 47.9 32.7 49.66 30.95",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.4 31.7 48.65 33.45 48.65 39.42 201.35 39.42 201.35 33.45 199.6 31.7 199.6 37.67 50.4 37.67 50.4 31.7",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.6 318.3 201.35 316.55 201.35 310.58 48.65 310.58 48.65 316.55 50.4 318.3 50.4 312.33 199.6 312.33 199.6 318.3",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.95 48.54 33.53 48.54 31.78 50.29 38.2 50.29 38.2 299.72 31.78 299.72 33.53 301.47 39.95 301.47 39.95 48.54",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.9 317.3 32.79 317.3 32.79 302.22 31.03 300.46 31.03 319.05 49.66 319.05 47.9 317.3",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,172.25H82.52V105.74A42.13,42.13,0,0,1,92.23,78.8a42.9,42.9,0,0,1,12.54-10.31c.6-.33,1.21-.64,1.83-.94a42.38,42.38,0,0,1,36.79,0c.62.3,1.23.61,1.84.94A43,43,0,0,1,157.76,78.8a42.13,42.13,0,0,1,9.71,26.94v66.51H139.15a14.56,14.56,0,0,1,.24,2.08h30.17V105.74a44.57,44.57,0,0,0-89.13,0v68.59h30.72A14.56,14.56,0,0,1,111.39,172.25Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.43,171.21V105.74a41.41,41.41,0,0,0-27.2-38.82c-1.27-.46-2.57-.87-3.89-1.21s-2.67-.62-4-.83a42,42,0,0,0-4.18-.42H125a41.3,41.3,0,0,0-16.12,3.25c-1.24.52-2.44,1.11-3.62,1.74-.58.32-1.16.65-1.73,1-1.14.69-2.24,1.44-3.31,2.23a39.27,39.27,0,0,0-3.07,2.53A40,40,0,0,0,93,79.46a35.81,35.81,0,0,0-2.39,3.19,41,41,0,0,0-7.09,23.09v65.47h28.09a14.24,14.24,0,0,1,1.29-3.13H86.69V105.74a38,38,0,0,1,1.73-11.35c.24-.77.51-1.52.8-2.26a38.35,38.35,0,0,1,4-7.74c.69-1,1.43-2,2.21-2.94.39-.47.79-.93,1.21-1.39a38.73,38.73,0,0,1,4.3-4c.71-.57,1.45-1.12,2.2-1.65s1.31-.89,2-1.3a31.63,31.63,0,0,1,3.26-1.77c.55-.26,1.12-.52,1.69-.76a38.33,38.33,0,0,1,29.79,0c.57.24,1.14.5,1.7.76,1.11.54,2.2,1.13,3.25,1.77a39.16,39.16,0,0,1,8.5,7c.41.46.81.92,1.2,1.39.78.94,1.52,1.93,2.21,2.94a38.06,38.06,0,0,1,6.55,21.35v62.34h-25.7a14.27,14.27,0,0,1,1.3,3.13Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.08,162.88V105.74a33,33,0,0,0-13.3-26.44c-.85-.63-1.73-1.23-2.64-1.78a33.15,33.15,0,0,0-34.29,0c-.91.55-1.79,1.15-2.64,1.78-.65.49-1.28,1-1.89,1.54A34,34,0,0,0,100,84.2c-.43.5-.85,1-1.26,1.54-.16.21-.32.42-.47.64-.43.58-.83,1.17-1.21,1.78A32.75,32.75,0,0,0,92,105.74v57.14h26.14a14.11,14.11,0,0,1,2.16-1H93V105.74a31.6,31.6,0,0,1,2.52-12.43,32.8,32.8,0,0,1,2.12-4.13,32,32,0,0,1,2.68-3.76,33.31,33.31,0,0,1,3.18-3.33,32.26,32.26,0,0,1,4.93-3.68,33.76,33.76,0,0,1,4.15-2.12c1-.4,1.94-.76,2.94-1.07A32,32,0,0,1,157,105.74v56.09H130.33a14.45,14.45,0,0,1,2.15,1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,105.74v55.05h62V104.23H94Zm1.88,52.86V106.37h58.23V158.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,83a30.9,30.9,0,0,0-43.67,1.64,31.26,31.26,0,0,0-2.79,3.48A32.33,32.33,0,0,0,97.22,92a30.53,30.53,0,0,0-3.1,11.11h61.75A30.79,30.79,0,0,0,146,83Zm7.52,18H96.46l.12-.62A28.83,28.83,0,0,1,125,76.91a29.24,29.24,0,0,1,5.11.45,27.89,27.89,0,0,1,4.84,1.3,29.48,29.48,0,0,1,4.48,2.1,28.88,28.88,0,0,1,14,19.68Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.57,84.17a28.69,28.69,0,0,0-3.85-2.62,27.9,27.9,0,0,0-41,18.47h54.55A27.9,27.9,0,0,0,142.57,84.17ZM147,90.49a26.82,26.82,0,0,1,3.75,7.82L151,99H99l.19-.67a26.55,26.55,0,0,1,5-9.52,27.1,27.1,0,0,1,3-3.06q.81-.7,1.65-1.35a26.78,26.78,0,0,1,32.23,0c.56.43,1.12.88,1.65,1.35a27.1,27.1,0,0,1,3,3.06A17.31,17.31,0,0,1,147,90.49Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,90.54h-6.41c-.41.56-.8,1.13-1.16,1.71a25.71,25.71,0,0,0-2.37,5c-.08.25-.18.48-.26.73h8l5-5.13A20.71,20.71,0,0,1,110.63,90.54Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.18,87.4l-2.7-2.85c-.51.34-1,.71-1.49,1.09a26.48,26.48,0,0,0-4,3.86h5.59A20.85,20.85,0,0,1,113.18,87.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,94c-.41.21-.83.42-1.25.6a18.1,18.1,0,0,1-2.56,1c-.44.13-.88.25-1.32.35a21.44,21.44,0,0,1-4,.49h-.07V98h14.89l-4.53-4.67C135.49,93.52,135.08,93.75,134.68,94Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,84.67,137,87.53a19.6,19.6,0,0,1,2.37,2H145c-.38-.46-.78-.91-1.19-1.34A26.08,26.08,0,0,0,139.7,84.67Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.77,91.08a20.61,20.61,0,0,1-2,1.6l5.09,5.26h7.7a25.42,25.42,0,0,0-3.79-7.4h-6.41A6.21,6.21,0,0,1,138.77,91.08Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,85a21.07,21.07,0,0,1,5.32-1.21c.46,0,.91-.07,1.36-.08V80.05a25.55,25.55,0,0,0-6.89,1.09,24.77,24.77,0,0,0-4.75,2c-.5.27-1,.55-1.47.86l2.69,2.85A20.65,20.65,0,0,1,117.79,85Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,86.93l2.54-2.69.15-.16a26.14,26.14,0,0,0-8-3.37,27.87,27.87,0,0,0-3.51-.56c-.59-.05-1.19-.09-1.79-.1v3.63a8.16,8.16,0,0,1,1.39.08A20.53,20.53,0,0,1,136.13,86.93Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,93.38l-4.42,4.56h14.59V96.37a20.56,20.56,0,0,1-10.17-3Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.35,93.46a17.42,17.42,0,0,0,2.07-1.16,18.61,18.61,0,0,0,2.39-1.76h-1.62a18.41,18.41,0,0,1-22.39,0h-1.62a19.37,19.37,0,0,0,2.91,2.1,17.54,17.54,0,0,0,3.16,1.49,19.66,19.66,0,0,0,11.85.53A18.92,18.92,0,0,0,133.35,93.46Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,89.5a18.86,18.86,0,0,1,3.88-2.27,18.59,18.59,0,0,1,14.63,0,18.86,18.86,0,0,1,3.88,2.27h1.62a19.55,19.55,0,0,0-25.63,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.49,87a17.48,17.48,0,0,0-7.4.52,16,16,0,0,0-1.64.58,18.88,18.88,0,0,0-2.83,1.45h2.11a15.3,15.3,0,0,1,1.72-.73,16.49,16.49,0,0,1,11.09,0,15.3,15.3,0,0,1,1.72.73h2.11A17,17,0,0,0,127.49,87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.54,91.28a16.62,16.62,0,0,1-11.09,0,15.36,15.36,0,0,1-1.72-.74h-2.11a17.09,17.09,0,0,0,4.47,2,17.46,17.46,0,0,0,12.11-.86,16.25,16.25,0,0,0,2.17-1.18h-2.11A17.75,17.75,0,0,1,130.54,91.28Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,157.56h56.14V107.41H96.93Zm1-49.11H152v48.07H98Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.96 121.91 119.7 123.16 120.9 123.74 121.73 122.28 120.96 121.91",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.78,131.55l-1-1.36-1.43.69V131a4.37,4.37,0,0,1-.51,2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.93 126.99 116.87 125.99 115.59 127.26 118.02 128.44 118.36 127.9 118.93 126.99",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.7 129.72 132.74 131.09 136.43 129.29 135.18 128.04 131.7 129.72",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.38 130.48 137.33 131.91 137.93 131.62 138.49 131.34 137.22 130.07 136.38 130.48",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.85 132.81 134.93 134.23 135.97 135.69 140.6 133.45 139.27 132.12 137.85 132.81",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81,132a3.77,3.77,0,0,1-.14-1v-.12L114.81,128l-1.25,1.25,7.62,3.7A4.57,4.57,0,0,1,120.81,132Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 138.78 125.52 140.75 135.02 136.15 133.98 134.69 128.93 137.13 129.24 138.28 126.55 138.28 125.52 138.78",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.77 134.43 119.05 133.11 118.14 134.56 121.33 136.1 121.77 134.43",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.38 132.36 135.43 130.94 130.67 133.24 131.53 134.72 136.38 132.36",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.03 121.91 125.52 123.6 125.52 125.47 130.29 123.16 129.03 121.91",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.66 136.1 130.59 135.17 129.73 133.7 128.22 134.43 128.66 136.1",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.4,127a4.94,4.94,0,0,1,1.07-.27v-.11l-5.55-2.69-1.27,1.27,4.8,2.32A4.17,4.17,0,0,1,123.4,127Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.07 123.94 128.81 125.03 129.74 126.47 132.34 125.21 131.07 123.94",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,128.89l1.89.92a3.69,3.69,0,0,1,.51-1.08c.09-.14.17-.29.28-.43l-1.77-.85Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81,129a4.61,4.61,0,0,1,.32.8l5.27-2.55L133.12,126l-2.32,1.12-2.46,1.19A3.65,3.65,0,0,1,128.81,129Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.73 139.63 124.47 143.87 124.47 141.91 116.68 138.13 115.73 139.63",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.61 134.22 107.95 134.88 107.3 135.54 114.79 139.17 115.73 137.67 108.61 134.22",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.18 137.65 109.81 139.89 110.77 138.38 106.52 136.32 105.18 137.65",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.25 121.13 125.52 118.4 125.52 122.45 126.41 122.02 128.25 121.13",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.98 143.34 111.71 138.84 111.34 139.42 110.75 140.35 120.03 144.84 120.98 143.34",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 147 136.57 141.65 135.68 140.1 125.52 145.03 125.52 147",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 144.72 120.97 145.3 124.47 147 124.47 145.03 121.93 143.79 121.34 144.72",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.29 135.24 140.24 136.73 141.05 136.34 142.7 135.54 141.38 134.22 139.29 135.24",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.72 132.12 109.39 133.45 112.59 135 113.55 133.49 110.72 132.12",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.11 132.65 112.78 130.07 111.5 131.34 117.19 134.1 118.11 132.65",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.79 139.35 131.5 140.97 139.3 137.19 138.35 135.69 130.79 139.35",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 123.6 122.67 122.73 121.84 124.2 124.47 125.47 124.47 123.6",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 118.4 121.74 121.13 124.47 122.45 124.47 118.4",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 143.87 130.56 141.42 129.85 139.81 125.52 141.91 125.52 143.87",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.81 137.65 143.48 136.32 136.62 139.64 137.51 141.19 144.81 137.65",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.76 138.28 120.76 138.28 121 137.37 121.06 137.13 114.49 133.95 113.54 135.45 124.47 140.75 124.47 138.78 123.44 138.28 120.76 138.28",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.15,127.24l.64-.31-.92-1.44-2.35,1.14v.11a4.3,4.3,0,0,1,2,.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.03 121.43 130.03 121.43 138.21 129.59 138.21 129.59 142.37 133.74 142.37 133.74 142.37 133.74 142.37 133.74 144.47 135.84 144.47 135.84 146.59 137.95 136.36 142.9 125.52 148.15 125.52 149.31 137.27 143.62 148.36 138.25 125.69 115.63 125.52 115.45 125.52 116.93 125.69 117.1 130.03 121.43",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 155.48 124.47 154.44 100.05 154.44 100.05 154.44 100.05 110.53 100.05 110.53 124.47 110.53 124.47 109.49 124.47 109.49 99.01 109.49 99.01 155.48 124.47 155.48 124.47 155.48",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.52 135.84 105.52 135.84 107.62 133.74 107.62 133.74 107.62 133.74 107.62 133.74 111.78 129.59 111.78 129.59 119.97 121.43 119.97 121.43 119.97 121.43 124.47 116.93 124.47 115.46 101.63 138.25 124.47 149.31 124.47 148.15 103.4 137.95 105.52 135.84",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.94 154.44 125.52 154.44 125.52 155.48 125.52 155.48 150.98 155.48 150.98 109.49 125.52 109.49 125.52 109.49 125.52 110.53 149.94 110.53 149.94 154.44",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,152.66l1.92-1.91a11.58,11.58,0,0,1-1.92-2.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,139.15l-1.62.78-1.53.74v9.86c.24-.24.47-.48.69-.74a9.93,9.93,0,0,0,.82-1.11,12.53,12.53,0,0,0,.79-1.44,10.28,10.28,0,0,0,.84-4.06h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55,149.79c.22.26.45.5.69.74v-9.86l-3.14-1.52v4h0a10.12,10.12,0,0,0,.85,4.06A10.3,10.3,0,0,0,103.55,149.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.14 122.58 134.14 111.57 129.9 111.57 129.9 118.35 134.14 122.58",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.09 153.4 120.09 148.35 115.86 146.29 115.86 153.4 120.09 153.4",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,153.4v-7.61l-4.24-2v9.62h4.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.24,113.49l1.92-1.92h-4.8a12.56,12.56,0,0,1,1.52.85A11.63,11.63,0,0,1,146.24,113.49Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,152.66v-4.79a11.4,11.4,0,0,1-1.92,2.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.12,152.55a12.83,12.83,0,0,1-1.37-1.06l-1.91,1.91h4.8A12.56,12.56,0,0,1,105.12,152.55Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47,143.27v9.95a10.22,10.22,0,0,0,4.24-1.82V141.18l-4.32,2.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.86 111.57 115.86 122.58 120.09 118.35 120.09 111.57 115.86 111.57",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 111.57 121.14 111.57 121.14 117.31 124.47 113.98 124.47 111.57",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,143.27h.07l-4.31-2.09V151.4a10,10,0,0,0,4.24,1.82Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,111.57v12.05l4.24,4.23V111.62h-4.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.85 111.57 125.52 111.57 125.52 113.98 128.85 117.31 128.85 111.57",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,112.31h0l-1.9,1.91a11.58,11.58,0,0,1,1.92,2.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.9,121.79h0a10.06,10.06,0,0,0-1.3-5,9.94,9.94,0,0,0-1.15-1.65,9.58,9.58,0,0,0-.69-.73v19.72l3.15,3.14Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,117.1a11.58,11.58,0,0,1,1.92-2.88l-1.92-1.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.1,137.31l3.14-3.14V114.45a10.14,10.14,0,0,0-3.14,7.34h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,113.49a11.41,11.41,0,0,1,2-1.44c.28-.16.55-.34.85-.48h-4.8Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.14 153.4 124.47 153.4 124.47 150.47 121.14 148.85 121.14 153.4",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.34,111.57h-.73V127.8l4.24-4.23v-12Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.29,133.13l4.24-4.23V111.75a11.29,11.29,0,0,0-1.15.27,10,10,0,0,0-3.09,1.55Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47,111.75v17.14l4.24,4.23V113.57a10.31,10.31,0,0,0-3.09-1.55A11.29,11.29,0,0,0,140.47,111.75Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.75 146.97 129.9 148.35 129.9 153.4 134.14 153.4 134.14 146.29 132.75 146.97",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.14 149.68 125.52 150.47 125.52 153.4 128.85 153.4 128.85 148.85 127.14 149.68",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,153.36v-9.62l-4.24,2v7.61h3.47A4,4,0,0,0,139.42,153.36Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,153.4h4.8l-1.92-1.91a12.71,12.71,0,0,1-1.36,1.06A12.56,12.56,0,0,1,143.36,153.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56,128.07a3.3,3.3,0,0,0-.51.31,2.32,2.32,0,0,0-.44.39,3.3,3.3,0,0,0-.81,1.49,3.06,3.06,0,0,0-.09.74,2.73,2.73,0,0,0,.05.4,3.28,3.28,0,0,0,1,2l.24.21v.22l-.27,1-.44,1.68-.18.67h5.77l-.17-.67-.44-1.68-.27-1-.06-.22.24-.21a3.26,3.26,0,0,0,1.06-2V131a3.06,3.06,0,0,0-.09-.74,3.16,3.16,0,0,0-.81-1.49,3.12,3.12,0,0,0-1-.7,3.22,3.22,0,0,0-.91-.29,4.51,4.51,0,0,0-.52,0h0a2.26,2.26,0,0,0-.52,0c-.1,0-.19.07-.29.09A4.1,4.1,0,0,0,123.56,128.07Zm1,.76a3.47,3.47,0,0,1,.45-.06h0a2.25,2.25,0,0,1,.52.07,2.18,2.18,0,0,1,.45.16,2.11,2.11,0,0,1,.4.26,2.36,2.36,0,0,1,.57.65,2.45,2.45,0,0,1,.27.83,1.13,1.13,0,0,1,0,.26,2.31,2.31,0,0,1-.25,1,2.21,2.21,0,0,1-.51.66l-.63.57-.08.07.27,1,.27,1,.22.84h-3.07l.18-.67v-.17l.27-1,.27-1-.71-.63A2.32,2.32,0,0,1,123,132a2.17,2.17,0,0,1-.24-1,1.13,1.13,0,0,1,0-.26,2.15,2.15,0,0,1,.18-.61,1.29,1.29,0,0,1,.17-.33,2.25,2.25,0,0,1,1.34-1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.56,175.68H139.39a14.56,14.56,0,0,1-.24,2.08h28.32v66.5a42.13,42.13,0,0,1-9.71,26.94,42.73,42.73,0,0,1-12.53,10.32c-.61.32-1.22.64-1.84.93a41.53,41.53,0,0,1-7.79,2.85,42.56,42.56,0,0,1-21.21,0,41.53,41.53,0,0,1-7.79-2.85c-.62-.29-1.23-.61-1.83-.93A42.62,42.62,0,0,1,92.23,271.2a42.13,42.13,0,0,1-9.71-26.94v-66.5h28.87a12.16,12.16,0,0,1-.24-2.08H80.43v68.58a44.57,44.57,0,0,0,89.13,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.56,244.26a41.42,41.42,0,0,0,63.51,35c.76-.48,1.5-1,2.23-1.51.27-.2.54-.39.8-.6.88-.66,1.72-1.36,2.54-2.09.56-.5,1.11-1,1.64-1.54a41.19,41.19,0,0,0,12.15-29.22V178.8H138.89a14,14,0,0,1-1.29,3.12h25.7v62.34a38,38,0,0,1-1.73,11.35c-.18.6-.39,1.19-.6,1.78a38.47,38.47,0,0,1-4.22,8.22c-.69,1-1.43,2-2.21,2.95s-1.61,1.85-2.47,2.71a38.42,38.42,0,0,1-7.23,5.66c-1.05.64-2.14,1.23-3.25,1.77s-2.27,1-3.44,1.45a33.94,33.94,0,0,1-3.59,1.12,38.72,38.72,0,0,1-19.13,0c-1.22-.32-2.42-.69-3.59-1.12s-2.31-.91-3.43-1.45-2.21-1.13-3.26-1.77a38,38,0,0,1-7.22-5.66c-.87-.86-1.7-1.77-2.48-2.71s-1.52-1.93-2.21-2.95A38.55,38.55,0,0,1,89,257.39c-.21-.59-.41-1.18-.6-1.78a38,38,0,0,1-1.73-11.35V181.92h26.25a14,14,0,0,1-1.29-3.12H83.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.91,187.13v57.13a32.68,32.68,0,0,0,5.66,18.44c.6.88,1.23,1.73,1.91,2.55a33.2,33.2,0,0,0,4.48,4.47,31.23,31.23,0,0,0,2.55,1.9,33.05,33.05,0,0,0,37,0,31.23,31.23,0,0,0,2.55-1.9,31.57,31.57,0,0,0,2.35-2.13c.75-.75,1.46-1.53,2.14-2.34a29.59,29.59,0,0,0,1.9-2.55,32.68,32.68,0,0,0,5.66-18.44V187.13H132.5a14.45,14.45,0,0,1-2.15,1H157v56.09a32.06,32.06,0,0,1-41.56,30.53,30.39,30.39,0,0,1-2.94-1.08,31.18,31.18,0,0,1-4.15-2.12,31.9,31.9,0,0,1-12.91-14.89A31.59,31.59,0,0,1,93,244.26V188.17h27.22a15.42,15.42,0,0,1-2.14-1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,244.26v-55H94v56.57h62Zm-1.88-.62H95.88V191.4h58.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,265a30.54,30.54,0,0,0,4.14,3.82,31,31,0,0,0,37.73,0A30.46,30.46,0,0,0,148,265c.63-.69,1.23-1.42,1.79-2.17a30.68,30.68,0,0,0,6.08-15.92H94.12a30.68,30.68,0,0,0,6.08,15.92C100.76,263.54,101.36,264.27,102,265Zm-5.41-15.4-.12-.62h57.07l-.11.62a29,29,0,0,1-2.43,7.2,29.78,29.78,0,0,1-1.72,3,28.4,28.4,0,0,1-43.17,6.31A29.46,29.46,0,0,1,103,263c-.54-.62-1-1.27-1.53-1.94A29.14,29.14,0,0,1,99,256.8a28.44,28.44,0,0,1-2.42-7.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,265.83a27.76,27.76,0,0,0,34.35.6,27,27,0,0,0,6.95-7.58,27.87,27.87,0,0,0,1.84-3.56c.21-.48.4-1,.58-1.47a27.1,27.1,0,0,0,1.13-3.83H97.73a27.34,27.34,0,0,0,2.38,6.8c.36.7.74,1.39,1.16,2.06a27.75,27.75,0,0,0,4.4,5.44C106.23,264.83,106.82,265.34,107.42,265.83Zm-8.2-14.14L99,251h52l-.19.66a26.85,26.85,0,0,1-51.55,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,258.26c.46.37.91.78,1.34,1.2h6.41c.41-.55.8-1.12,1.16-1.71a24.64,24.64,0,0,0,2.63-5.68h-8l-5,5.12A12.79,12.79,0,0,1,138,258.26Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,262.6l2.7,2.86c.22-.15.42-.31.63-.46a24.64,24.64,0,0,0,2.26-1.82,26.31,26.31,0,0,0,2.6-2.68h-5.59A18.81,18.81,0,0,1,136.81,262.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.46,255.06l.69-.26a21.7,21.7,0,0,1,3.63-.92c.44-.07.89-.12,1.34-.16s.9-.07,1.35-.08v-1.57H109.58l4.53,4.67A21,21,0,0,1,117.46,255.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.5,263.1a26,26,0,0,0,2.79,2.23l2.71-2.86a19.6,19.6,0,0,1-2.37-2H105A27,27,0,0,0,107.5,263.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89,258.33c.44-.36.88-.69,1.34-1l-5.1-5.25h-7.7A26.07,26.07,0,0,0,102,256c.32.62.67,1.22,1,1.8a17.15,17.15,0,0,0,1.16,1.71h6.41A15.58,15.58,0,0,1,111.89,258.33Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9,265.47a20.06,20.06,0,0,1-4,.77c-.45,0-.91.07-1.36.08V270a26,26,0,0,0,6.89-1.09,26.71,26.71,0,0,0,4.75-2c.5-.27,1-.56,1.48-.86l-2.7-2.86A20.4,20.4,0,0,1,130.9,265.47Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.86,263.08l-2.69,2.84a25.8,25.8,0,0,0,3,1.67,25.2,25.2,0,0,0,5,1.7,25.79,25.79,0,0,0,3.5.57c.59.05,1.19.08,1.79.1v-3.64a8,8,0,0,1-1.38-.08A20.4,20.4,0,0,1,113.86,263.08Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.11,252.07H125.52v1.57a20.66,20.66,0,0,1,10.17,3Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.18,259.46h1.62a18.41,18.41,0,0,1,22.39,0h1.62A19.51,19.51,0,0,0,112.18,259.46Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.19,260.5a18.21,18.21,0,0,1-3.88,2.28,18.67,18.67,0,0,1-14.63,0,18.21,18.21,0,0,1-3.88-2.28h-1.62a19.55,19.55,0,0,0,25.63,0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,261.68a17.19,17.19,0,0,0,2.3.86,18.15,18.15,0,0,0,2.41.52,19,19,0,0,0,2.5.17,17.1,17.1,0,0,0,9.37-2.73h-2.11a15.36,15.36,0,0,1-1.72.74,16.62,16.62,0,0,1-11.09,0,15.36,15.36,0,0,1-1.72-.74h-2.1A16.14,16.14,0,0,0,117.79,261.68Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,258.73a16.44,16.44,0,0,1,12.81.73h2.11a17.09,17.09,0,0,0-4.47-2,17.28,17.28,0,0,0-4.9-.7,19,19,0,0,0-2.5.17,18.19,18.19,0,0,0-2.41.53,13.3,13.3,0,0,0-1.5.52,17.56,17.56,0,0,0-3,1.51h2.1A16.1,16.1,0,0,1,119.45,258.73Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,192.44H96.92V242.6h56.15Zm-1,49.12H98V193.48h54Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.03 228.1 130.29 226.85 129.09 226.26 128.26 227.73 129.03 228.1",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,217l-3,1.44,1,1.36.47-.23,1-.46V219a4.22,4.22,0,0,1,.13-1A4.47,4.47,0,0,1,121.18,217Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.12 224.02 133.76 223.38 134.4 222.74 131.97 221.57 131.06 223.02 133.12 224.02",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.29 220.28 117.26 218.92 113.56 220.71 114.81 221.97 118.29 220.28",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.62 219.53 112.66 218.1 111.5 218.66 112.78 219.94 113.62 219.53",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.06 215.78 114.02 214.32 109.39 216.56 110.72 217.88 115.06 215.78",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.32,219v.12l5.87,2.83,1.25-1.25-7.63-3.7A4.37,4.37,0,0,1,129.32,219Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 211.22 124.47 209.26 114.97 213.86 116.02 215.32 121.06 212.88 120.75 211.72 120.75 211.72 123.44 211.72 124.47 211.22",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.22 215.57 130.94 216.89 131.85 215.45 128.66 213.9 128.22 215.57",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.61 217.64 114.56 219.07 119.32 216.76 118.46 215.29 113.61 217.64",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.7 226.85 120.96 228.1 124.47 226.4 124.47 224.53 122.02 225.72 119.7 226.85",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.33 213.9 119.41 214.83 120.26 216.31 121.77 215.57 121.33 213.9",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,223a5,5,0,0,1-1.08.27v.1l5.55,2.7,1.27-1.27-4.79-2.33A4.63,4.63,0,0,1,126.6,223Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.92 226.07 121.18 224.97 120.25 223.53 117.65 224.8 118.92 226.07",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.69,221.65l.34-.54-1.9-.91a4.51,4.51,0,0,1-.32.79,4.16,4.16,0,0,1-.47.71l1.77.86Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,221a4.51,4.51,0,0,1-.32-.79l-5.27,2.54,1.28,1.28,4.78-2.32A4.16,4.16,0,0,1,121.18,221Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.26 210.37 125.52 206.13 125.52 208.1 133.31 211.88 134.26 210.37",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.38 215.78 142.69 214.47 135.2 210.83 134.84 211.41 134.26 212.33 141.38 215.78",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.81 212.35 140.18 210.11 139.23 211.63 143.48 213.69 144.81 212.35",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 231.6 124.47 227.56 121.74 228.88 124.47 231.6",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.01 206.67 138.28 211.17 139.24 209.65 129.96 205.16 129.01 206.67",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 203.01 113.42 208.36 114.31 209.91 121.15 206.59 124.47 204.98 124.47 203.01",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.02 204.7 125.52 203.01 125.52 204.98 128.06 206.21 129.02 204.7",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.7 214.77 109.75 213.28 107.3 214.47 108.61 215.78 110.7 214.77",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.27 217.88 140.6 216.56 137.4 215.01 136.45 216.51 139.27 217.88",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.88 217.35 137.21 219.94 138.49 218.66 132.8 215.91 131.88 217.35",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.2 210.66 118.49 209.04 110.69 212.82 111.64 214.31 119.2 210.66",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 226.4 127.32 227.27 128.15 225.81 125.52 224.53 125.52 226.4",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 228.78 125.69 228.78 125.69 231.43 128.25 228.88 125.52 227.56 125.52 228.78",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 231.6 125.54 231.58 125.52 231.58 125.52 231.6",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 206.13 119.43 208.58 120.14 210.2 124.47 208.1 124.47 206.13",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.18 212.35 106.51 213.69 113.37 210.36 112.48 208.81 105.18 212.35",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.24 211.72 128.93 212.88 135.5 216.06 136.09 215.13 136.45 214.55 125.52 209.26 125.52 211.22 126.55 211.72 129.24 211.72",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.81,222.78l-.61.3.92,1.43,1.58-.76.77-.38v-.11a4.3,4.3,0,0,1-2-.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.96 228.58 119.96 228.58 111.78 220.42 111.78 220.42 107.62 216.26 107.62 216.26 105.52 214.17 105.52 214.17 103.4 212.06 103.4 212.06 114.25 206.8 124.47 201.85 124.47 200.69 113.38 206.06 101.63 211.76 124.47 234.55 124.47 233.08 119.96 228.58 119.96 228.58",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.94 195.57 149.94 239.47 149.94 239.47 125.52 239.47 125.52 240.51 125.52 240.51 150.98 240.51 150.98 194.53 125.52 194.53 125.52 194.53 125.52 195.57 149.94 195.57 149.94 195.57",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.59 212.06 146.59 212.06 145.53 213.11 144.47 214.17 144.47 214.17 142.37 216.26 142.37 216.26 138.21 220.42 138.21 220.42 130.03 228.58 130.03 228.58 130.03 228.58 130.03 228.58 125.52 233.08 125.52 234.55 148.36 211.76 125.52 200.69 125.52 201.85 146.59 212.06 146.59 212.06",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 240.51 124.47 239.47 100.05 239.47 100.05 195.57 124.47 195.57 124.47 194.53 124.47 194.53 99.01 194.53 99.01 240.51 124.47 240.51 124.47 240.51",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,197.34,147,199.26a11.28,11.28,0,0,1,1.91,2.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09,210.86l1.53-.74,1.62-.79v-9.85c-.24.23-.47.48-.69.73a10.58,10.58,0,0,0-1.15,1.65,10.08,10.08,0,0,0-1.3,5h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,206.83h0a10.34,10.34,0,0,0-3.14-7.35v9.85l3.14,1.53Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.09 238.43 120.09 231.65 115.85 227.42 115.85 238.43 120.09 238.43",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.14 203.71 134.14 196.61 129.9 196.61 129.9 201.66 134.14 203.71",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18,196.61v7.61l4.24,2.05v-9.62h-4.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,236.52l-1.92,1.91h4.81A11.16,11.16,0,0,1,103.75,236.52Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09,202.14c.16-.34.36-.66.55-1a11.19,11.19,0,0,1,1.37-1.9l-1.92-1.92Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,196.61h-4.79a11.28,11.28,0,0,1,2.88,1.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.28,197.46a9.48,9.48,0,0,0-1,.52,9.35,9.35,0,0,0-1,.63v10.22l4.31-2.09h-.07v-10A9.92,9.92,0,0,0,107.28,197.46Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.02 229.54 129.9 231.65 129.9 238.43 134.14 238.43 134.14 227.42 132.02 229.54",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.52 236.02 125.52 238.43 128.85 238.43 128.85 232.69 125.52 236.02",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.46,196.78v10h-.07l4.31,2.09V198.61a9.7,9.7,0,0,0-2-1.15A10.34,10.34,0,0,0,140.46,196.78Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,238.43V226.38l-4.24-4.23v16.24h4.24Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.14 238.43 124.47 238.43 124.47 236.02 121.14 232.69 121.14 238.43",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.09,237.7l1-1,1-1a11.58,11.58,0,0,1-1.92-2.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.55,234.83c.22.25.45.5.69.73V215.84l-3.15-3.14v15.51h0a10.12,10.12,0,0,0,.85,4.06A10.33,10.33,0,0,0,103.55,234.83Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,235.78l1.91,1.92v-4.8a10.94,10.94,0,0,1-1.45,2.29C147.29,235.38,147.15,235.6,147,235.78Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,212.7l-3.14,3.14v19.72c.24-.23.47-.48.69-.73a10.37,10.37,0,0,0,.95-1.33,10.08,10.08,0,0,0,1.5-5.29h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.35,238.43h4.81l-1.92-1.91a11.29,11.29,0,0,1-2.22,1.54C143.8,238.18,143.59,238.32,143.35,238.43Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.85 196.61 125.52 196.61 125.52 199.54 128.85 201.15 128.85 196.61",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,238.39V222.15l-4.24,4.23v12.05h3.47C138.91,238.43,139.16,238.41,139.42,238.39Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.46,238.26a10.43,10.43,0,0,0,2.25-.68,9.64,9.64,0,0,0,1.41-.77,5.25,5.25,0,0,0,.58-.38V216.88l-4.24,4.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.53,238.26V221.11l-4.24-4.23v19.55a9.35,9.35,0,0,0,1,.63,10.2,10.2,0,0,0,3.28,1.2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.85 196.61 115.85 203.71 120.09 201.66 120.09 196.61 115.85 196.61",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.47 196.61 121.14 196.61 121.14 201.15 124.47 199.54 124.47 196.61",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.81,196.61h-4.24v9.62l4.24-2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,198.52a11.28,11.28,0,0,1,2.88-1.91h-4.79Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.68,212.76h-1.57l.18.68.43,1.67.27,1,.06.21h0l-.13.11-.11.1a3.28,3.28,0,0,0-1,2.05,2.73,2.73,0,0,0,0,.4,3,3,0,0,0,.09.73,3.13,3.13,0,0,0,1.81,2.19,3.22,3.22,0,0,0,.91.29,2.33,2.33,0,0,0,.53.06h0a2.31,2.31,0,0,0,.52-.06,3.22,3.22,0,0,0,.91-.29,2.62,2.62,0,0,0,.51-.3,3.31,3.31,0,0,0,.44-.39,3.43,3.43,0,0,0,.81-1.5,3,3,0,0,0,.09-.73,2.73,2.73,0,0,0,0-.4,3.28,3.28,0,0,0-1-2.05l-.24-.21h0v-.17l.27-1,.43-1.67.18-.68h-4.2Zm1.32,1h1.53l-.22.85-.27,1-.27,1,.71.64a2.17,2.17,0,0,1,.73,1.93,2.07,2.07,0,0,1-.1.43,2.87,2.87,0,0,1-.18.4,2.29,2.29,0,0,1-.55.65,2.14,2.14,0,0,1-.41.25,2.2,2.2,0,0,1-.45.17,2.24,2.24,0,0,1-.52.06h0a2.33,2.33,0,0,1-.53-.06A2.43,2.43,0,0,1,124,221a2.06,2.06,0,0,1-.4-.25,2.3,2.3,0,0,1-.74-1.05,2.07,2.07,0,0,1-.1-.43V219a2.21,2.21,0,0,1,.75-1.67l.71-.64-.27-1-.27-1-.22-.85H125Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,164.47a5,5,0,0,1,4.37,4l1.6-1.59V137H58.75a5,5,0,0,1-4.42,4.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,168.88h3.38a4,4,0,0,0-3.38-3.38Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,168.88V165.5A4,4,0,0,0,64,168.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.21 169.93 53.28 169.93 53.28 164.42 53.28 141.49 53.28 135.99 58.8 135.99 62.86 135.99 68.38 135.99 68.38 141.49 68.38 164.42 68.38 169.93 64.44 169.93 66.73 172.2 70.66 172.2 70.66 133.71 51 133.71 51 172.2 54.93 172.2 57.21 169.93",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,166.85l1.6,1.59a5,5,0,0,1,4.37-4v-11h-6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,137v3.37A3.94,3.94,0,0,0,57.71,137Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,140.41V137H64A3.94,3.94,0,0,0,67.33,140.41Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.36,137v15.39h6v-11a5,5,0,0,1-4.42-4.4Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,213v-3.4A3.94,3.94,0,0,0,64,213Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,181.14H64a4,4,0,0,0,3.38,3.36Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,198.84h-6V213h1.55a5,5,0,0,1,4.42-4.41Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,185.54a5,5,0,0,1-4.37-4l-1.6,1.59v14.64h6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,209.6V213h3.38A3.93,3.93,0,0,0,54.33,209.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,181.14v3.36a4,4,0,0,0,3.38-3.36Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.44 180.08 68.38 180.08 68.38 180.09 68.38 185.59 68.38 208.51 68.38 214.02 68.38 214.03 53.28 214.03 53.28 214.02 53.28 208.51 53.28 185.59 53.28 180.09 53.28 180.08 57.22 180.08 54.95 177.81 51 177.81 51 216.31 70.66 216.31 70.66 177.81 66.71 177.81 64.44 180.08",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3,213V183.15l-1.6-1.59a5,5,0,0,1-4.37,4v23A5,5,0,0,1,58.75,213Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,152.43h6V137h-1.49a5,5,0,0,1-4.48,4.41Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,137v3.37a3.94,3.94,0,0,0,3.38-3.37Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,164.47a5,5,0,0,1,4.43,3.91l1.54-1.53V153.48h-6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,165.5v3.38h3.38A4,4,0,0,0,182.73,165.5Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,168.88v-3.36a3.94,3.94,0,0,0-3.31,3.36Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.55 169.93 181.68 169.93 181.61 169.93 181.61 135.99 181.68 135.99 187.2 135.99 191.26 135.99 196.71 135.99 196.78 135.99 196.78 141.49 196.71 141.49 196.71 164.42 196.78 164.42 196.78 169.93 196.71 169.93 192.78 169.93 195.06 172.2 199 172.2 199 133.71 179.33 133.71 179.33 172.2 183.26 172.2 185.55 169.93",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,140.39V137h-3.31A3.94,3.94,0,0,0,195.66,140.39Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.69,137v29.81l1.66,1.65a5,5,0,0,1,4.31-4v-23a5,5,0,0,1-4.35-4.39Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,183.15l-1.54-1.53a5,5,0,0,1-4.43,3.92v12.25h6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,209.6V213h3.38A3.93,3.93,0,0,0,182.73,209.6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.77 180.08 196.78 180.08 196.78 185.59 196.71 185.59 196.71 208.51 196.78 208.51 196.78 214.02 196.71 214.02 196.71 214.03 181.61 214.03 181.61 180.09 181.68 180.09 181.68 180.08 185.55 180.08 183.28 177.81 179.33 177.81 179.33 216.31 199 216.31 199 177.81 195.05 177.81 192.77 180.08",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.73,181.14v3.36a3.94,3.94,0,0,0,3.38-3.36Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,185.53a5,5,0,0,1-4.31-4l-1.66,1.65V213h1.62a5,5,0,0,1,4.35-4.41Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.64,213V198.84h-6v9.72a5,5,0,0,1,4.48,4.42Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,181.14h-3.31a3.94,3.94,0,0,0,3.31,3.35Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,213v-3.35a3.94,3.94,0,0,0-3.31,3.35Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,54.1h-6.86l-3.63,5.76A25.87,25.87,0,0,0,186.92,54.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,54.1c1.66.82,3.29,1.73,4.86,2.7a26.75,26.75,0,0,0,3.61,1.86l1.82-4.56Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,57,195,50.77H127.73v.74a54.64,54.64,0,0,1,27.34,9.06A26.82,26.82,0,0,0,188.76,57ZM147.9,54l-2.26-1h43.87l-.9.9a27.08,27.08,0,0,1-19.19,7.94,27.74,27.74,0,0,1-14.64-4.2,57.54,57.54,0,0,0-6.88-3.58Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.89,54.1l-2,4.95a26.51,26.51,0,0,0,6.57,1.6l2.79-6.55Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,60.22l3.86-6.12h-8.39l-2.85,6.67A26.52,26.52,0,0,0,175,60.22Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.71,54.1l3.1,7.26a22.78,22.78,0,0,0,6.4-1.94L88.1,54.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,51.51v-.74H55L61.23,57a26.82,26.82,0,0,0,33.69,3.55A54.52,54.52,0,0,1,122.26,51.51ZM80.37,62.67a25,25,0,0,1-17.53-7.26l-2.36-2.36h43.84l-2.26,1a57.24,57.24,0,0,0-8.41,4.62A23.86,23.86,0,0,1,80.37,62.67Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.15,58.93a20.54,20.54,0,0,0,1.92-1.13,58.38,58.38,0,0,1,6.42-3.7H89.23Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,54.1l.57.57A24,24,0,0,0,74.1,60.75L69.93,54.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.18,54.1l4.42,7a22.41,22.41,0,0,0,7.12.37L79.57,54.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,298.5v.73H195L188.76,293a26.81,26.81,0,0,0-33.69-3.56A54.64,54.64,0,0,1,127.73,298.5Zm60.88-2.44.9.89H145.64l2.26-1a58,58,0,0,0,6.88-3.64A27.34,27.34,0,0,1,188.61,296.06Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.92,295.9a26,26,0,0,0-10.49-5.76l3.63,5.76Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.28,295.9l-2.79-6.54a26.06,26.06,0,0,0-6.57,1.59l2,4.95Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,295.9,175,289.78a26.51,26.51,0,0,0-7.38-.54l2.85,6.66Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.76,295.9l-1.82-4.56a26.81,26.81,0,0,0-3.61,1.87q-2.36,1.46-4.86,2.69Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.23,293,55,299.23h67.29v-.73A54.56,54.56,0,0,1,95,289.43,26.81,26.81,0,0,0,61.23,293Zm43.09,4H60.48l2.36-2.35a25,25,0,0,1,17.53-7.27,23.84,23.84,0,0,1,13.28,4,57.24,57.24,0,0,0,8.41,4.62Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.81,288.64l-3.1,7.26H88.1l2.11-5.31A22.8,22.8,0,0,0,83.81,288.64Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.37,288.38a23.92,23.92,0,0,0-4.77.5l-4.42,7h8.39l3.15-7.38A23.12,23.12,0,0,0,80.37,288.38Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.15,291.08l-1.92,4.82H99.49a56.81,56.81,0,0,1-6.42-3.7A20.44,20.44,0,0,0,91.15,291.08Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.59,295.34l-.57.56h6.91l4.19-6.64A23.94,23.94,0,0,0,63.59,295.34Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,47.49H47.59v255H202.41Zm-32,222.32a51.56,51.56,0,0,0,6.75-25.55V219.63H201.4v81.1ZM125,295.2a51,51,0,0,1-51.06-50.94V105.74a50.49,50.49,0,0,1,6.87-25.48l.19-.19h0a51.07,51.07,0,0,1,95.11,25.72V244.26A51.06,51.06,0,0,1,125,295.2ZM79.63,80.2a51.5,51.5,0,0,0-6.75,25.54v24.64H48.65V49.28ZM72.88,218.58H48.65V175.53h4l-.53-.53.52-.52h-4v-43H72.88v43H69l.52.52-.53.53h3.88v43.05Zm-24.23,1H72.88v24.63a51.44,51.44,0,0,0,6.76,25.55l-31,30.92Zm128.46-88.2h24.24v43h-4l.52.52-.53.53h4v43H177.11V175.53H181l-.53-.53.52-.52h-3.87Zm24.24-1H177.11V105.74a51.5,51.5,0,0,0-6.75-25.54l31-30.92ZM169.82,79.26a52.15,52.15,0,0,0-44.29-25.5V48.54h75.08ZM124.47,48.54v5.22A52.17,52.17,0,0,0,80.18,79.25L49.39,48.54ZM80.18,270.76a52.17,52.17,0,0,0,44.29,25.48v5.23H49.39Zm45.34,30.71v-5.23a52.14,52.14,0,0,0,44.29-25.49l30.8,30.72Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.51,175.53,68,175l-.52-.52L65.2,172.2,63,169.93l-.09-.1-1-1-1.07-1.07-1.07,1.07-1,1-.1.1-2.28,2.27-2.28,2.28-.52.52.53.53,2.28,2.28,2.28,2.27h0l.08.08,1,1,1.06,1.05,1.06-1.05,1-1,.08-.08h0l2.27-2.27Zm-6.68,4.19-1.91-1.91-2.28-2.28L56.1,175l.52-.52,2.28-2.28,1.93-1.92,1.93,1.92L65,174.48l.52.52-.54.53-2.28,2.28Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,174.48,182,175l.53.53,2.29,2.28,2.27,2.27h0l.15.15.9.9,1.06,1.05,1.06-1.05,1-1h0l2.28-2.27,2.28-2.28.53-.53-.52-.52-2.28-2.28L191.27,170h0l-1-1-1.07-1.07L188.13,169l-.89.88-.16.17-2.29,2.27Zm6.69-4.2,1.93,1.92,2.28,2.28.52.52-.53.53-2.29,2.28-1.91,1.91-1.91-1.91L185,175.53l-.54-.53.52-.52,2.29-2.28Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,96.09A49.38,49.38,0,0,0,61.3,72.26V106c.66-3.48,1.72-6.7,3.44-8.46A4.38,4.38,0,0,1,67.69,96.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.33,105.74c0-1.59.06-3.2.2-4.78.1-1.28.15-2.55.16-3.81a3.22,3.22,0,0,0-2.2,1.09c-3.56,3.64-4.12,14.74-4.19,19.63v6.9h6Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8,86.88a6.12,6.12,0,0,1,1.44,1.83V70.49a48.64,48.64,0,0,0-5.91-7.65V85.41A6.54,6.54,0,0,1,58.8,86.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.24,120.25V93.67h0c0-2.78-.71-4.79-2.11-6a5.59,5.59,0,0,0-3.79-1.22v38.31h5.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.66,105.74a54.1,54.1,0,0,1,3.51-19.17L73.9,87a5.83,5.83,0,0,1-.43-9.84L51,54.78V128.1H70.66Zm-2.08-4.69c-.13,1.55-.2,3.13-.2,4.69v20.09H53.28V60.28l.9.9A50.21,50.21,0,0,1,68.58,101.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,82a4.79,4.79,0,0,0,2.33,4.11,50.32,50.32,0,0,1,2.49-5.5l-3-3,.3.43A4.83,4.83,0,0,0,72,82Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,79.88v-17a48.42,48.42,0,0,0-5.9,7.63V83.35a6.35,6.35,0,0,1,1.53-2A6.59,6.59,0,0,1,195.66,79.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,105.74v19h6V109.35c-.26-5.48-1.15-13.62-4.1-16.64a3.39,3.39,0,0,0-2-1.08,51.92,51.92,0,0,0-.09,9.33C182.6,102.55,182.67,104.16,182.67,105.74Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,80.93A5.58,5.58,0,0,0,192,82.15c-1.4,1.2-2.11,3.21-2.11,6h-.1v21c.15,3.07.1,5.36.09,5.62h-.09v10h5.9Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,100V72.25a49.23,49.23,0,0,0-6,18.34A4.47,4.47,0,0,1,185.4,92C187,93.65,188,96.66,188.7,100Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.13,80.59a53.89,53.89,0,0,1,2.62,5.8,4.81,4.81,0,0,0,.39-8.61l.25-.45Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.68,82a5.89,5.89,0,0,1-3.53,5.39l-.24-.53a54,54,0,0,1,3.42,18.9V128.1H199V54.78L176.78,76.94A5.86,5.86,0,0,1,179.68,82Zm9-11.81v-.08h0a49.33,49.33,0,0,1,7.06-8.91l.9-.9v65.55h-15.1V105.74c0-1.56-.06-3.13-.2-4.7a50.65,50.65,0,0,1,7.31-30.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,268a5.83,5.83,0,0,1,2.92-5l.27.47a54.14,54.14,0,0,1-3.51-19.17V221.91H51v73.32l22.47-22.41A5.88,5.88,0,0,1,71,268ZM54.2,288.81l-.9.89V224.19H68.4v20.09c0,1.56.07,3.13.2,4.69a50.18,50.18,0,0,1-14.42,39.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.69,252.87c0-1.27-.06-2.54-.16-3.81-.14-1.59-.2-3.2-.2-4.78v-19h-6v6.91c.07,4.88.63,16,4.19,19.63A3.34,3.34,0,0,0,67.69,252.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.33,263.56a5.65,5.65,0,0,0,3.79-1.23c1.4-1.19,2.11-3.21,2.11-6h0V225.24h-5.9Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,269.43a55.44,55.44,0,0,1-2.49-5.5A4.77,4.77,0,0,0,74.1,272l-.3.43Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.55,264.61h-.22v22.56a48.1,48.1,0,0,0,5.91-7.64V261.31a6.38,6.38,0,0,1-1.44,1.83A6.62,6.62,0,0,1,54.55,264.61Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3,244.05v33.7a49.38,49.38,0,0,0,6.39-23.83,4.36,4.36,0,0,1-3-1.41C63,250.76,62,247.53,61.3,244.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,267.87a5.64,5.64,0,0,0,3.68,1.22V225.24h-5.9V235.3h.09c0,.26.06,2.55-.09,5.63v21h.1C189.86,264.66,190.57,266.67,192,267.87Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,268a4.81,4.81,0,0,0-2.87-4.41,53.17,53.17,0,0,1-2.62,5.81l3.26,3.25-.25-.44A4.82,4.82,0,0,0,178.62,268Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.66,270.14h-.11a6.64,6.64,0,0,1-4.26-1.47,6.24,6.24,0,0,1-1.53-2v12.88a47.39,47.39,0,0,0,5.9,7.63Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,250.05c-.66,3.3-1.71,6.32-3.34,8a4.34,4.34,0,0,1-2.7,1.38,49.28,49.28,0,0,0,6,18.35Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,240.66V225.24h-6v19c0,1.58-.07,3.19-.21,4.78a51.82,51.82,0,0,0,.09,9.32,3.32,3.32,0,0,0,2-1.07C187.55,254.29,188.44,246.14,188.7,240.66Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.33,244.28a53.91,53.91,0,0,1-3.42,18.89l.24-.53a5.86,5.86,0,0,1,.63,10.43L199,295.23V221.91H179.33Zm2.08,4.69c.14-1.56.2-3.14.2-4.69V224.19h15.1v65.54l-.9-.89a49.4,49.4,0,0,1-7.06-8.92h-.05v-.08A50.63,50.63,0,0,1,181.41,249Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.27,37.62l.2.19a4.6,4.6,0,0,1,.76-.55,4.48,4.48,0,0,1,.68-.29l-.77-.76L40.92,35l.16,1.23.15,1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.29,36.21l-.76.76a4,4,0,0,1,.67.29,4.1,4.1,0,0,1,.88.67l.31-.31v-.36l.15-1,.18-1.38h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.25,40.31l-2-2h0a3.73,3.73,0,0,1-.85,1.43l.2.2,1.34.18Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4,40.46l-1.15.15-1.64.23-.31.31a3.84,3.84,0,0,1,1,1.54l1.44-1.44.75-.75Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,38.09h0l-1,1-1.09,1.09h0l1-.14,1.09,0,.7-.09.31-.31A3.94,3.94,0,0,1,37.4,38.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.35,40.74,36.3,40.6l-.89-.12.89.89,1.05,1.05h0a3.86,3.86,0,0,1,.9-1.42l-.2-.19Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.59,42.86l-.32.31L41,45.06l-.1.94h0l.6-.6,1.6-1.59A3.8,3.8,0,0,1,41.59,42.86Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.19,43a3.88,3.88,0,0,1-1.44.84l.48.48,1.51,1.51-.13-1-.22-1.67Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.34 39.15 39.97 39.51 39.95 39.54 39.59 39.9 39.09 40.39 39.44 40.74 39.83 41.13 40.1 41.39 40.48 41.78 40.83 42.13 41.33 41.63 41.69 41.27 41.71 41.25 42.07 40.88 42.57 40.39 42.22 40.04 41.83 39.66 41.56 39.39 41.18 39.01 40.83 38.66 40.34 39.15",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.62,36.21l-.76.76a4,4,0,0,1,.67.29,4.1,4.1,0,0,1,.88.67l.31-.31.05-.36.14-1,.19-1.38h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.61,37.62l.2.19a4,4,0,0,1,.75-.55,4.48,4.48,0,0,1,.68-.29l-.77-.76L209.25,35l.16,1.23.15,1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,42.69l.06-.06,1-1.05,1.08-1.08h0l-1,.14-1,.14-.71.1-.31.31A3.83,3.83,0,0,1,212.59,42.69Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.7,40.19l.88.12-.88-.88-1-1-.06-.06a3.73,3.73,0,0,1-.85,1.43l.2.2.71.09Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.75,40.62l-1-.14.66.66,1.33,1.32a3.73,3.73,0,0,1,.85-1.43l-.2-.19Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.75,38.14h0L204,39.81l-.47.47h.17L205,40.1l1.33-.18.31-.31A3.8,3.8,0,0,1,205.75,38.14Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.52,43a3.8,3.8,0,0,1-1.44.84l1.49,1.49.5.5-.1-.74-.25-1.89Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.61,43.17l-.23,1.67L209.23,46h0l1.83-1.82.37-.37a3.77,3.77,0,0,1-1.55-1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.67 39.15 208.3 39.51 208.28 39.54 207.92 39.9 207.42 40.39 207.77 40.74 208.16 41.13 208.43 41.39 208.81 41.78 209.16 42.13 209.66 41.63 210.02 41.27 210.04 41.25 210.4 40.88 210.9 40.39 210.55 40.04 210.16 39.66 209.9 39.39 209.51 39.01 209.16 38.66 208.67 39.15",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.39,306.84l.22-1.67.15-1.12h0l-1.84,1.83-.35.35a4,4,0,0,1,1.55,1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.47,307a4,4,0,0,1,1.44-.85l-1.49-1.48-.5-.5.1.74.25,1.89Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25,311.88h0l1.75-1.7.46-.45-.05-.05H46.3l-1.34.19-1.34.18-.31.31A3.89,3.89,0,0,1,44.25,311.88Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25,309.39l1,.14-.66-.66-1.33-1.33a3.73,3.73,0,0,1-.85,1.43l.2.2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,307.31v.05l-1,1.05-1.09,1.09v.05l1-.14,1.05-.15.7-.09.31-.31A3.83,3.83,0,0,1,37.4,307.31Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,309.82l-.89-.12.89.89,1.05,1.05v.05a3.7,3.7,0,0,1,.85-1.44l-.2-.19-.7-.1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.37,313.79l.77-.76a3.48,3.48,0,0,1-.69-.29,3.71,3.71,0,0,1-.86-.66l-.32.31v.35l-.15,1.05-.18,1.38v.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.39,312.39l-.2-.2a3.78,3.78,0,0,1-.76.55,3.16,3.16,0,0,1-.68.29l.76.76L40.74,315l-.16-1.23-.15-1Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.33 310.85 41.69 310.49 41.71 310.47 42.07 310.11 42.57 309.61 42.22 309.26 41.83 308.88 41.56 308.61 41.18 308.23 40.83 307.88 40.34 308.37 39.97 308.74 39.95 308.76 39.59 309.12 39.09 309.61 39.44 309.96 39.83 310.35 40.1 310.61 40.48 311 40.83 311.35 41.33 310.85",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.41,307.15l.31-.31L209,305l.13-.9h0l-.61.6-1.58,1.58A4,4,0,0,1,208.41,307.15Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8,307a4,4,0,0,1,1.44-.85l-.46-.46-1.53-1.52.13,1,.23,1.66Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,311.91l.06-.06,1-1.05,1.08-1.07,0-.05-1,.14-1,.14-.71.1-.31.31A3.76,3.76,0,0,1,212.59,311.91Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.65,309.27l1,.14.88.12-.88-.88-1-1-.06-.06a3.73,3.73,0,0,1-.85,1.43l.2.2Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58,309.54h0l1.16-.16,1.63-.22.31-.31a3.88,3.88,0,0,1-1-1.55l-1.43,1.44-.75.75h0Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.74,309.7l2,2h0a3.7,3.7,0,0,1,.85-1.44l-.2-.19-1.33-.18Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.71,313.79l.76-.76a3.48,3.48,0,0,1-.69-.29,3.71,3.71,0,0,1-.86-.66l-.31.31-.05.35-.15,1.05-.18,1.38v.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,312.39l-.2-.2a4,4,0,0,1-.75.55,3.48,3.48,0,0,1-.69.29l.76.76,1.23,1.23-.16-1.23-.15-1.05Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.66 310.85 210.02 310.49 210.04 310.47 210.4 310.11 210.9 309.61 210.55 309.26 210.16 308.88 209.9 308.61 209.51 308.23 209.16 307.88 208.67 308.37 208.3 308.74 208.28 308.76 207.92 309.12 207.42 309.61 207.77 309.96 208.16 310.35 208.43 310.61 208.81 311 209.16 311.35 209.66 310.85",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.26,62.55V18.69H187.31v2.8H62.69v-2.8H18.74V62.55h2.81V287.46H18.74v43.85h44v-2.8H187.31v2.8h43.95V287.46h-2.81V62.55Zm-1,267.71H189.1l1.76-1.75h37.59V291l1.76-1.76Zm-41.85-1.75v-5H61.64v6l-1-1L60.1,328l-.22-.22v-6H190.12v6l-.22.22-.53.53-1,1ZM19.79,330.26v-41L21.55,291v37.5H59.14l1.76,1.75Zm1.76-41.75H27V61.5H20.54l1-1,.53-.52.22-.22H28.7v230.5H22.3l-.22-.22-.53-.52-1-1Zm40.09-267v5H188.36v-6l1,1,.53.53.22.22v6H59.88v-6L60.1,22l.53-.53,1-1Zm168.57-1.75v41L228.45,59V21.49H190.86l-1.76-1.75Zm-9.16,39-7.38-7.36h5.61l7.37,7.36Zm5.6,232.61-7.37,7.36h-5.61l7.38-7.36ZM177,320.74a4.17,4.17,0,0,0,.06-.71v-.3a3.47,3.47,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.47,3.47,0,0,1,.55,1.88h1.35a3.69,3.69,0,0,1,.54-1.88,4.58,4.58,0,0,0,7.59-3.42v-.31a3,3,0,0,1,.09-.73h4.05l-7.38,7.35Zm-117.43,0-7.38-7.35h4.07a3.84,3.84,0,0,1,.08.76v.25A4.56,4.56,0,0,0,64,317.85a3.57,3.57,0,0,1,.54,1.88H65.9a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.49,3.49,0,0,1,.56,1.9V320a4.49,4.49,0,0,0,.06.73ZM73,29.26a4.17,4.17,0,0,0-.06.71v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.54-1.88H64.49A3.64,3.64,0,0,1,64,32.15a4.57,4.57,0,0,0-7.6,3.41h0v.31a3.55,3.55,0,0,1-.08.73H52.2l7.38-7.35Zm117.42,0,7.38,7.35h-4.05a3.22,3.22,0,0,1-.09-.76V35.6a4.57,4.57,0,0,0-7.59-3.45,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.48,3.48,0,0,1-.55-1.9V30a4.49,4.49,0,0,0-.06-.73Zm29.8,261.39-1.82,1.82a4.37,4.37,0,0,0-.86-4.51,3.57,3.57,0,0,1,1.88-.54v-1.34a3.47,3.47,0,0,1-1.88-.55,4.43,4.43,0,0,0,0-6,3.57,3.57,0,0,1,1.91-.55h.77Zm-29.05,30.84,7.37-7.36v5.22l-7.37,7.36Zm.88-5.21a4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.48,3.48,0,0,1-.55-1.91v-.25a4.49,4.49,0,0,0-.06-.73h15.66a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88Zm-.71.78a3.67,3.67,0,0,1-4.58,0,3.67,3.67,0,0,1,4.58,0Zm-6,0a5.06,5.06,0,0,0-.49.88,4.32,4.32,0,0,0-.5-.89,4.18,4.18,0,0,0,.5-.87,5.1,5.1,0,0,0,.48.89Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.68,3.68,0,0,1,4.57,0Zm-6.63,1.18a4.17,4.17,0,0,0-.62-1.18,4,4,0,0,0,.62-1.17,4.69,4.69,0,0,0,.62,1.17,5.14,5.14,0,0,0-.63,1.18Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.66,4.66,0,0,0-3,1.14,3.57,3.57,0,0,1-.55-1.91v-.25a4.49,4.49,0,0,0-.06-.73h15.65a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.58,4.58,0,0,0-2.95-1.14Zm2.3,1.92a3.68,3.68,0,0,1-4.59,0,3.7,3.7,0,0,1,4.58,0Zm-6,0a5.06,5.06,0,0,0-.49.88,5.06,5.06,0,0,0-.49-.88,4.64,4.64,0,0,0,.49-.87,4.51,4.51,0,0,0,.46.87Zm-2.41,0a3.65,3.65,0,0,1-4.57,0,3.67,3.67,0,0,1,4.54,0Zm-6.62,1.18a4.75,4.75,0,0,0-.62-1.18,4.69,4.69,0,0,0,.62-1.17,4.69,4.69,0,0,0,.62,1.17,4.26,4.26,0,0,0-.65,1.18Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.47,3.47,0,0,1-.55-1.88H150a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.48,3.48,0,0,1-.55-1.91v-.25a4.49,4.49,0,0,0-.06-.73H158.5a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.63,4.63,0,0,0-3-1.14Zm2.29,1.92a3.68,3.68,0,0,1-4.59,0,3.69,3.69,0,0,1,4.56,0Zm-6,0a5.06,5.06,0,0,0-.49.88,4.25,4.25,0,0,0-.5-.88,4.18,4.18,0,0,0,.5-.87,4.78,4.78,0,0,0,.45.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.69,3.69,0,0,1,4.54,0Zm-6.63,1.18a4.69,4.69,0,0,0-.62-1.17,4.17,4.17,0,0,0,.62-1.18,4.69,4.69,0,0,0,.62,1.17,4.89,4.89,0,0,0-.66,1.18Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.61,4.61,0,0,0-3,1.14,3.48,3.48,0,0,1-.55-1.91v-.25a4.49,4.49,0,0,0-.06-.73H141.4a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.63,4.63,0,0,0-3-1.14Zm2.29,1.92a3.67,3.67,0,0,1-4.58,0,3.69,3.69,0,0,1,4.54,0Zm-6,0a5.06,5.06,0,0,0-.49.88,5.06,5.06,0,0,0-.49-.88,4.64,4.64,0,0,0,.49-.87,4.87,4.87,0,0,0,.4.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.68,3.68,0,0,1,4.53,0ZM125,318.24a4.69,4.69,0,0,0-.62-1.17,4.75,4.75,0,0,0,.62-1.18,4,4,0,0,0,.62,1.17A4.17,4.17,0,0,0,125,318.24Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.47,3.47,0,0,1-.55-1.88h-1.34a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.58,3.58,0,0,1-.56-1.91v-.25a4.49,4.49,0,0,0-.06-.73h15.66a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.61,4.61,0,0,0-3-1.14Zm2.29,1.92a3.68,3.68,0,0,1-4.59,0,3.7,3.7,0,0,1,4.64,0Zm-6,0a4.21,4.21,0,0,0-.49.88,4.25,4.25,0,0,0-.5-.88,4.18,4.18,0,0,0,.5-.87,3.94,3.94,0,0,0,.54.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0A3.67,3.67,0,0,1,114.54,317.06Zm-6.63,1.18a4.75,4.75,0,0,0-.62-1.18,4.69,4.69,0,0,0,.62-1.17,4.69,4.69,0,0,0,.62,1.17A4.75,4.75,0,0,0,107.91,318.24Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.57,3.57,0,0,1-.54-1.88H98.69a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.61,4.61,0,0,0-3,1.14,3.48,3.48,0,0,1-.55-1.91v-.25c0-.24,0-.49-.06-.73h15.65a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.61,4.61,0,0,0-3-1.14Zm2.29,1.92a3.67,3.67,0,0,1-4.58,0A3.67,3.67,0,0,1,105.86,317.06Zm-6,0a5.06,5.06,0,0,0-.49.88,5.06,5.06,0,0,0-.49-.88,4.64,4.64,0,0,0,.49-.87,4.59,4.59,0,0,0,.48.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.68,3.68,0,0,1,4.57,0Zm-6.62,1.18a4.75,4.75,0,0,0-.62-1.18,4.69,4.69,0,0,0,.62-1.17,4.35,4.35,0,0,0,.61,1.17,4.75,4.75,0,0,0-.62,1.18Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.47,3.47,0,0,1-.55-1.88H81.59a3.55,3.55,0,0,1-.54,1.88,4.5,4.5,0,0,0-6,0,3.49,3.49,0,0,1-.56-1.91v-.25a4.49,4.49,0,0,0-.06-.73H90.1a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.62,4.62,0,0,0-3-1.14Zm2.29,1.92a3.68,3.68,0,0,1-4.59,0,3.7,3.7,0,0,1,4.58,0Zm-6,0a4.21,4.21,0,0,0-.49.88,4.25,4.25,0,0,0-.5-.88,4.18,4.18,0,0,0,.5-.87,4.06,4.06,0,0,0,.47.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.67,3.67,0,0,1,4.56,0Zm-6.63,1.18a4.75,4.75,0,0,0-.62-1.18,4.69,4.69,0,0,0,.62-1.17,4.69,4.69,0,0,0,.62,1.17,4.5,4.5,0,0,0-.64,1.18Zm-4.34-3.1a4.61,4.61,0,0,0-3,1.14,3.57,3.57,0,0,1-.54-1.88H64.5a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.55-1.91v-.25c0-.24,0-.49-.06-.73H73a4.14,4.14,0,0,0-.06.7v.31a3.47,3.47,0,0,1-.55,1.88,4.62,4.62,0,0,0-3-1.14Zm2.29,1.92a3.67,3.67,0,0,1-4.58,0,3.67,3.67,0,0,1,4.56,0Zm-6,0a5.15,5.15,0,0,0-.49.89,4.25,4.25,0,0,0-.5-.88,4.25,4.25,0,0,0,.5-.88,4.83,4.83,0,0,0,.46.87Zm-2.41,0a3.67,3.67,0,0,1-4.58,0,3.67,3.67,0,0,1,4.55,0Zm-4.42,9.64-7.37-7.36v-5.22l7.37,7.36Zm0-298.2-7.37,7.36V30.65l7.37-7.36ZM58,33.72a4.5,4.5,0,0,0,6,0,3.47,3.47,0,0,1,.55,1.88H65.9a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0A3.57,3.57,0,0,1,73,35.63v.25a4.49,4.49,0,0,0,.06.73H57.35c0-.23,0-.47,0-.7V35.6A3.44,3.44,0,0,1,58,33.72Zm.7-.78a3.67,3.67,0,0,1,4.58,0,3.66,3.66,0,0,1-4.61,0Zm6,0a4.25,4.25,0,0,0,.5-.88,5.15,5.15,0,0,0,.49.89,4.64,4.64,0,0,0-.49.87,4.45,4.45,0,0,0-.53-.89Zm2.42,0a3.67,3.67,0,0,1,4.58,0,3.68,3.68,0,0,1-4.61,0Zm6.63-1.18a4.75,4.75,0,0,0,.62,1.18,4.69,4.69,0,0,0-.62,1.17,4.69,4.69,0,0,0-.62-1.17,4.66,4.66,0,0,0,.59-1.18Zm4.34,3.1a4.61,4.61,0,0,0,3-1.14,3.55,3.55,0,0,1,.54,1.88H83a3.69,3.69,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9v.26a4.49,4.49,0,0,0,.06.73H74.44a4.14,4.14,0,0,0,.06-.7V35.6a3.48,3.48,0,0,1,.56-1.88,4.61,4.61,0,0,0,3,1.14ZM75.8,32.94a3.67,3.67,0,0,1,4.58,0,3.71,3.71,0,0,1-4.61,0Zm6,0a4.25,4.25,0,0,0,.5-.88,4.21,4.21,0,0,0,.49.88,4.14,4.14,0,0,0-.49.87,4.31,4.31,0,0,0-.53-.87Zm2.41,0a3.68,3.68,0,0,1,4.59,0,3.7,3.7,0,0,1-4.62,0Zm6.64-1.18a4.41,4.41,0,0,0,.61,1.18,4.35,4.35,0,0,0-.61,1.17,4.69,4.69,0,0,0-.62-1.17,4.83,4.83,0,0,0,.59-1.18Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88H100a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9v.26a4.49,4.49,0,0,0,.06.73H91.54a4.09,4.09,0,0,0,0-.7V35.6a3.47,3.47,0,0,1,.55-1.88,4.62,4.62,0,0,0,3.07,1.14Zm-2.3-1.92a3.67,3.67,0,0,1,4.58,0,3.71,3.71,0,0,1-4.61,0Zm6,0a5.06,5.06,0,0,0,.49-.88,5.06,5.06,0,0,0,.49.88,4.64,4.64,0,0,0-.49.87,4.72,4.72,0,0,0-.51-.87Zm2.41,0a3.67,3.67,0,0,1,4.58,0,3.67,3.67,0,0,1-4.6,0Zm6.63-1.18a4.75,4.75,0,0,0,.62,1.18,4.69,4.69,0,0,0-.62,1.17,4.69,4.69,0,0,0-.62-1.17,4.38,4.38,0,0,0,.6-1.18Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.34a3.65,3.65,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.48,3.48,0,0,1,.55,1.91v.25a4.49,4.49,0,0,0,.06.73H108.63a4.17,4.17,0,0,0,.06-.71v-.3a3.47,3.47,0,0,1,.55-1.88,4.62,4.62,0,0,0,3,1.14ZM110,32.94a3.67,3.67,0,0,1,4.58,0A3.67,3.67,0,0,1,110,32.94Zm6,0a4.25,4.25,0,0,0,.5-.88,4.21,4.21,0,0,0,.49.88,4.14,4.14,0,0,0-.49.87A4.18,4.18,0,0,0,116,32.94Zm2.41,0a3.68,3.68,0,0,1,4.59,0,3.71,3.71,0,0,1-4.63,0ZM125,31.76a4.17,4.17,0,0,0,.62,1.18,4,4,0,0,0-.62,1.17,4.69,4.69,0,0,0-.62-1.17A4.75,4.75,0,0,0,125,31.76Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.35a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.48,3.48,0,0,1,.55,1.91v.25a4.49,4.49,0,0,0,.06.73H125.73a4.17,4.17,0,0,0,.06-.71v-.3a3.47,3.47,0,0,1,.55-1.88,4.62,4.62,0,0,0,3,1.14ZM127,32.94a3.67,3.67,0,0,1,4.58,0,3.68,3.68,0,0,1-4.57,0Zm6,0a5.06,5.06,0,0,0,.49-.88,5.06,5.06,0,0,0,.49.88,4.64,4.64,0,0,0-.49.87,4.55,4.55,0,0,0-.47-.87Zm2.41,0a3.67,3.67,0,0,1,4.58,0,3.67,3.67,0,0,1-4.56,0Zm6.63-1.18a4.75,4.75,0,0,0,.62,1.18,4.69,4.69,0,0,0-.62,1.17,4.69,4.69,0,0,0-.62-1.17,4.5,4.5,0,0,0,.64-1.18Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14A3.5,3.5,0,0,1,150,35.6h1.34a3.65,3.65,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.57,3.57,0,0,1,.56,1.9v.26a4.49,4.49,0,0,0,.06.73H142.82a4.14,4.14,0,0,0,.06-.7V35.6a3.47,3.47,0,0,1,.55-1.88,4.62,4.62,0,0,0,3,1.14Zm-2.29-1.92a3.67,3.67,0,0,1,4.58,0,3.67,3.67,0,0,1-4.56,0Zm6,0a4.25,4.25,0,0,0,.5-.88,5.06,5.06,0,0,0,.49.88,4.64,4.64,0,0,0-.49.87,4.1,4.1,0,0,0-.48-.87Zm2.41,0a3.68,3.68,0,0,1,4.59,0,3.71,3.71,0,0,1-4.57,0Zm6.64-1.18a4.75,4.75,0,0,0,.62,1.18,4,4,0,0,0-.62,1.17,4.69,4.69,0,0,0-.62-1.17,4.82,4.82,0,0,0,.64-1.18Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.35a3.69,3.69,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9v.26a4.49,4.49,0,0,0,.06.73H159.92a4.14,4.14,0,0,0,.06-.7V35.6a3.47,3.47,0,0,1,.55-1.88,4.62,4.62,0,0,0,3,1.14Zm-2.29-1.92a3.63,3.63,0,0,1,4.57,0,3.68,3.68,0,0,1-4.55,0Zm6,0a5.06,5.06,0,0,0,.49-.88,5.06,5.06,0,0,0,.49.88,4.64,4.64,0,0,0-.49.87,4.55,4.55,0,0,0-.47-.87Zm2.41,0a3.68,3.68,0,0,1,4.59,0,3.71,3.71,0,0,1-4.57,0Zm6.63-1.18a4.75,4.75,0,0,0,.62,1.18,4.69,4.69,0,0,0-.62,1.17,4,4,0,0,0-.62-1.17,4.5,4.5,0,0,0,.64-1.18Zm4.34,3.1a4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.35a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.75,3.75,0,0,1,.55,1.9v.26a4.49,4.49,0,0,0,.06.73H177a4.17,4.17,0,0,0,.06-.71v-.3a3.47,3.47,0,0,1,.55-1.88,4.61,4.61,0,0,0,3,1.14Zm-2.29-1.92a3.67,3.67,0,0,1,4.58,0,3.69,3.69,0,0,1-4.56,0Zm6,0a4.6,4.6,0,0,0,.5-.89,5.06,5.06,0,0,0,.49.88,5.06,5.06,0,0,0-.49.88,4.1,4.1,0,0,0-.48-.87Zm2.42,0a3.67,3.67,0,0,1,4.58,0,3.67,3.67,0,0,1-4.56,0Zm4.41-9.64,7.37,7.36v5.22l-7.37-7.36ZM219,49.55l-1.76-1.75V32.7H202.1L200.34,31H219Zm-6.13,22.71a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.65,3.65,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11Zm4.79,3.66a3.46,3.46,0,0,1-.87,2.29,3.45,3.45,0,0,1-.88-2.29,3.52,3.52,0,0,1,.88-2.29,3.55,3.55,0,0,1,.84,2.29Zm-.87,10.7a3.45,3.45,0,0,1,0-4.6,3.4,3.4,0,0,1,0,4.6Zm0-6a5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.85,4.85,0,0,0-.9.48Zm-3.92,8.71a4.92,4.92,0,0,0,.93.11h.32A3.4,3.4,0,0,1,216,90a4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.88.54v1.35a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11Zm0,17a4.22,4.22,0,0,0,.93.11h.31A3.47,3.47,0,0,1,216,107a4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11Zm4.79,20.72a3.51,3.51,0,0,1-.87,2.29,3.45,3.45,0,0,1-.88-2.29,3.54,3.54,0,0,1,.88-2.3,3.55,3.55,0,0,1,.84,2.29Zm2.59,80.78-.49,0h-.31a3.47,3.47,0,0,1-1.88-.55,4.45,4.45,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54V199.4a3.56,3.56,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.77Zm-2.59-63.73a3.51,3.51,0,0,1-.87,2.29,3.43,3.43,0,0,1,0-4.58,3.53,3.53,0,0,1,.84,2.28Zm-.87,56.42a4.21,4.21,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.32,4.32,0,0,0-.9.48Zm0-2.4a3.45,3.45,0,0,1-.88-2.29,3.54,3.54,0,0,1,.88-2.3,3.41,3.41,0,0,1,0,4.58Zm0-6a4.61,4.61,0,0,0-1.69-.76,4.34,4.34,0,0,0,1.68-.76,4.61,4.61,0,0,0,1.69.76,4.45,4.45,0,0,0-1.71.75Zm-3.92-34.63a4.83,4.83,0,0,0,.93.12h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.88.54v1.35a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11Zm0,17.34a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.34A3.61,3.61,0,0,1,216,184a4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11Zm3.92,14.36a3.45,3.45,0,0,1,0-4.6,3.39,3.39,0,0,1,0,4.59Zm0-6a5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.81,4.81,0,0,0-.9.47Zm0-2.4a3.42,3.42,0,0,1,0-4.58,3.59,3.59,0,0,1,.87,2.3,3.49,3.49,0,0,1-.9,2.26Zm0-6a5,5,0,0,0-1.69-.76,4.47,4.47,0,0,0,1.68-.75,4.76,4.76,0,0,0,1.69.75,4.73,4.73,0,0,0-1.71.74Zm0-2.93a3.44,3.44,0,0,1,0-4.59,3.52,3.52,0,0,1,.88,2.29,3.58,3.58,0,0,1-.91,2.28Zm0-6a5.06,5.06,0,0,0-.88-.49,5.06,5.06,0,0,0,.88-.49,4.64,4.64,0,0,0,.87.49,5.09,5.09,0,0,0-.9.46Zm0-2.39a3.44,3.44,0,0,1,0-4.59,3.59,3.59,0,0,1,.87,2.3,3.49,3.49,0,0,1-.9,2.26Zm0-6a4.41,4.41,0,0,0-1.18-.61,4.69,4.69,0,0,0,1.17-.62,4.75,4.75,0,0,0,1.18.62,4.41,4.41,0,0,0-1.2.57Zm0-2.65a3.52,3.52,0,0,1-.88-2.29,3.59,3.59,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59Zm0-6a5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,5,5,0,0,0-.9.45Zm-1.94-4.69a4.55,4.55,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55V149a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11V140.48a4.22,4.22,0,0,0,.93.11h.31a3.55,3.55,0,0,1,1.88.54,4.62,4.62,0,0,0-1.14,3Zm-.76,63.66h-.25a4.79,4.79,0,0,0-1,.11V192.21a4.92,4.92,0,0,0,.93.11h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.56,3.56,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.5Zm1.82-3.53a3.48,3.48,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59,3.47,3.47,0,0,1-.9-2.33Zm4.34-13.75h-.8a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3,3.65,3.65,0,0,1,1.88-.55v-1.34a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.77Zm0-17.34h-.79a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.35a3.57,3.57,0,0,1-1.88-.54,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.91-.55h.77Zm0-17.05h-.8a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3,3.65,3.65,0,0,1,1.88-.55v-1.34a3.47,3.47,0,0,1-1.88-.55,4.43,4.43,0,0,0,0-6,3.58,3.58,0,0,1,1.91-.56h.77Zm-3.46-15.7a4.75,4.75,0,0,0-1.18-.62,4.35,4.35,0,0,0,1.17-.61,4.41,4.41,0,0,0,1.18.61,4.75,4.75,0,0,0-1.2.58Zm0-2.65a3.44,3.44,0,0,1,0-4.59,3.52,3.52,0,0,1,.88,2.29,3.56,3.56,0,0,1-.91,2.26Zm0-6a5.06,5.06,0,0,0-.88-.49,4.21,4.21,0,0,0,.88-.49,4.18,4.18,0,0,0,.87.5,4.14,4.14,0,0,0-.9.43Zm-1.94-4.68a4.6,4.6,0,0,0,1.15,3,3.57,3.57,0,0,1-1.88.54V132a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11V123.41l.94.13h.31a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3Zm-2,82.45a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.35a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.21,4.21,0,0,0-1,.12Zm1.25,24.82v1a3.67,3.67,0,0,1,1.9.59,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a5.57,5.57,0,0,0-1,.11V226.88a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55Zm0,17.34v1.05a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11V244.22a4.92,4.92,0,0,0,.93.11h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55Zm0,17.34v1a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.48,3.48,0,0,1-1.91.55h-.25a4.21,4.21,0,0,0-1,.12V261.55a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55Zm-1.25,9.85a4.22,4.22,0,0,0,.93.11h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34A3.67,3.67,0,0,1,216,288a4.66,4.66,0,0,0-1.14,3,4.54,4.54,0,0,0,1.16,3,3.53,3.53,0,0,1-1.92.56h-.25a4.79,4.79,0,0,0-1,.11Zm3.92,14.35a3.44,3.44,0,0,1,0-4.59A3.44,3.44,0,0,1,216.77,293.29Zm0-6a4.14,4.14,0,0,0-.87-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.17,4.17,0,0,0-.9.44Zm0-2.4a3.45,3.45,0,0,1-.88-2.29,3.58,3.58,0,0,1,.87-2.29,3.43,3.43,0,0,1,0,4.58Zm0-6a4.78,4.78,0,0,0-1.69-.76,4.59,4.59,0,0,0,1.69-.75,4.55,4.55,0,0,0,1.68.75,5,5,0,0,0-1.69.71Zm0-2.93a3.44,3.44,0,0,1,0-4.59,3.35,3.35,0,0,1,0,4.54Zm0-6a5.06,5.06,0,0,0-.88-.49,5.06,5.06,0,0,0,.88-.49,4.64,4.64,0,0,0,.87.49,4.78,4.78,0,0,0-.88.43Zm0-2.4a3.44,3.44,0,0,1-.88-2.28,3.59,3.59,0,0,1,.87-2.3,3.43,3.43,0,0,1,0,4.58Zm0-6a5,5,0,0,0-1.69-.76,4.59,4.59,0,0,0,1.69-.75,4.82,4.82,0,0,0,1.68.76,4.72,4.72,0,0,0-1.69.69Zm0-2.93a3.44,3.44,0,0,1,0-4.59A3.44,3.44,0,0,1,216.77,258.63Zm0-6a4.21,4.21,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.22,4.22,0,0,0-.88.43Zm0-2.4a3.45,3.45,0,0,1-.88-2.29,3.59,3.59,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59Zm0-6a4.61,4.61,0,0,0-1.69-.76,4.78,4.78,0,0,0,1.69-.76,4.34,4.34,0,0,0,1.68.76,4.34,4.34,0,0,0-1.69.7Zm0-2.94a3.52,3.52,0,0,1-.88-2.29,3.59,3.59,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59Zm0-6a5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.78,4.78,0,0,0-.88.43Zm0-2.4a3.43,3.43,0,0,1,0-4.58,3.58,3.58,0,0,1,.87,2.29,3.49,3.49,0,0,1-.88,2.23Zm0-6a4.78,4.78,0,0,0-1.69-.76,4.47,4.47,0,0,0,1.68-.75,4.76,4.76,0,0,0,1.69.75,4.74,4.74,0,0,0-1.69.7Zm0-2.93a3.44,3.44,0,0,1,0-4.59,3.52,3.52,0,0,1,.88,2.29,3.56,3.56,0,0,1-.89,2.24Zm0-6a5.06,5.06,0,0,0-.88-.49,5.06,5.06,0,0,0,.88-.49,4.64,4.64,0,0,0,.87.49,4.74,4.74,0,0,0-.88.42Zm0-2.39a3.44,3.44,0,0,1,0-4.59,3.59,3.59,0,0,1,.87,2.3,3.49,3.49,0,0,1-.88,2.22Zm0-6a4.76,4.76,0,0,0-1.69-.75,4.74,4.74,0,0,0,1.68-.76,4.78,4.78,0,0,0,1.69.76,4.68,4.68,0,0,0-1.69.67Zm3.46-70.41h-.79a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.35a3.57,3.57,0,0,1-1.88-.54,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.91-.55h.26a4.34,4.34,0,0,0,.51,0Zm-3.46-15.7a4.17,4.17,0,0,0-1.18-.62,4.75,4.75,0,0,0,1.18-.62,4.69,4.69,0,0,0,1.17.62,4.21,4.21,0,0,0-1.18.54Zm0-2.66a3.52,3.52,0,0,1-.88-2.29,3.59,3.59,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59Zm0-6a5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,5.43,5.43,0,0,0-.88.41Zm0-2.4a3.43,3.43,0,0,1,0-4.58,3.58,3.58,0,0,1,.87,2.29,3.52,3.52,0,0,1-.88,2.21Zm0-6a4.75,4.75,0,0,0-1.18-.62,4.35,4.35,0,0,0,1.17-.61,4.41,4.41,0,0,0,1.18.61,4.67,4.67,0,0,0-1.18.54Zm0-2.65a3.44,3.44,0,0,1,0-4.59,3.52,3.52,0,0,1,.88,2.29,3.56,3.56,0,0,1-.89,2.22Zm0-6a4.21,4.21,0,0,0-.88-.49,5.11,5.11,0,0,0,.88-.5,4.18,4.18,0,0,0,.87.5,4.14,4.14,0,0,0-.88.41Zm0-2.4a3.45,3.45,0,0,1-.88-2.29,3.54,3.54,0,0,1,.88-2.3,3.59,3.59,0,0,1,.87,2.3,3.52,3.52,0,0,1-.88,2.21Zm0-6a4.75,4.75,0,0,0-1.18-.62,4.69,4.69,0,0,0,1.17-.62,4.75,4.75,0,0,0,1.18.62,4.21,4.21,0,0,0-1.18.54ZM220.23,88h-.8a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3,3.65,3.65,0,0,1,1.88-.55V79.45a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.26a4.34,4.34,0,0,0,.51,0Zm-3.46-15.7a4.77,4.77,0,0,0-1.23-.63,4.28,4.28,0,0,0,1.22-.63,4.62,4.62,0,0,0,1.23.63,4.68,4.68,0,0,0-1.23.55Zm0-2.68a3.52,3.52,0,0,1-.88-2.29,3.48,3.48,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59Zm0-6a4.21,4.21,0,0,0-.88-.49,4.18,4.18,0,0,0,.87-.5,4.25,4.25,0,0,0,.88.5,4.7,4.7,0,0,0-.88.41Zm0-2.4a3.43,3.43,0,0,1,0-4.58,3.58,3.58,0,0,1,.87,2.29,3.48,3.48,0,0,1-.89,2.21Zm-1.93-2.28a4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.25a4.79,4.79,0,0,0-1,.11V55.17a7.32,7.32,0,0,0,.94.12h.31a3.48,3.48,0,0,1,1.88.56,4.61,4.61,0,0,0-1.14,3Zm-3-8.56V299.72h6.43l-1.75,1.75H210V48.54h6.44l1.75,1.75ZM50.4,312.33v6l-1.75-1.75v-6h152.7v6l-1.75,1.75v-6ZM31,300.47l1.76,1.75V317.3H47.9l1.76,1.75H31ZM33.31,73.63a3.52,3.52,0,0,1,.88,2.29,3.45,3.45,0,0,1-.88,2.29,3.46,3.46,0,0,1-.87-2.29A3.58,3.58,0,0,1,33.31,73.63ZM36,63.42V62.37a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.46,3.46,0,0,1,36,55.3h.25a4.31,4.31,0,0,0,.88-.09V70.9l-.85-.11H36a3.47,3.47,0,0,1-1.88-.55,4.45,4.45,0,0,0,0-6A3.68,3.68,0,0,1,36,63.71ZM32.44,273.61a3.56,3.56,0,0,1,.87-2.29,3.44,3.44,0,0,1,0,4.59A3.59,3.59,0,0,1,32.44,273.61Zm.87-28a3.54,3.54,0,0,1,.88,2.3,3.45,3.45,0,0,1-.88,2.29,3.51,3.51,0,0,1-.87-2.29,3.56,3.56,0,0,1,.87-2.33ZM36,235.12v-1.05a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.67,3.67,0,0,1,36,227h.25a4.31,4.31,0,0,0,.88-.09v15.68a6,6,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3A3.65,3.65,0,0,1,36,235.4Zm0-17.34v-1.05a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.48,3.48,0,0,1,1.91-.55h.25a4.32,4.32,0,0,0,.88-.1v15.69a4,4,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6A3.57,3.57,0,0,1,36,218Zm-3.54-13.51a3.48,3.48,0,0,1,.87-2.3,3.44,3.44,0,0,1,0,4.59,3.53,3.53,0,0,1-.89-2.29Zm-2.67-80.78a5.29,5.29,0,0,0,.56.05h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.88.54V132a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85ZM36,114.61v-1a3.49,3.49,0,0,1-1.9-.61,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.43,3.43,0,0,1,1.9-.5h.25a4.31,4.31,0,0,0,.88-.09v15.68a6,6,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3A3.65,3.65,0,0,1,36,114.9Zm0-17.06v-1A3.56,3.56,0,0,1,34.1,96a4.49,4.49,0,0,0,0-6,3.49,3.49,0,0,1,1.9-.56h.25a4.32,4.32,0,0,0,.88-.1V105a4,4,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.61,3.61,0,0,1,1.9-.51Zm-3.54,89.38a3.59,3.59,0,0,1,.87-2.3,3.45,3.45,0,0,1,0,4.6,3.55,3.55,0,0,1-.89-2.3Zm.87-56.14a5.11,5.11,0,0,0,.88.5,4.1,4.1,0,0,0-.87.48,5.06,5.06,0,0,0-.88-.49,4,4,0,0,0,.85-.49Zm0,2.4a3.44,3.44,0,0,1,0,4.59A3.46,3.46,0,0,1,33.33,133.19Zm0,6a4.41,4.41,0,0,0,1.18.61,4.69,4.69,0,0,0-1.17.62,4.75,4.75,0,0,0-1.18-.62,4.21,4.21,0,0,0,1.15-.6ZM36,165.77v-1.05a3.57,3.57,0,0,1-1.88-.54,4.49,4.49,0,0,0,0-6,3.48,3.48,0,0,1,1.91-.55h.25a4.32,4.32,0,0,0,.88-.1v15.69a4,4,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6A3.57,3.57,0,0,1,36,166Zm0-17.05v-1.05a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.67,3.67,0,0,1,36,140.6h.25a4.31,4.31,0,0,0,.88-.09v15.68a6,6,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3A3.65,3.65,0,0,1,36,149Zm-2.67-6.87a3.52,3.52,0,0,1,.88,2.29,3.45,3.45,0,0,1-.88,2.29,3.45,3.45,0,0,1,0-4.58Zm0,6a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.56,4.56,0,0,0,.85-.51Zm0,2.4a3.43,3.43,0,0,1,0,4.59A3.46,3.46,0,0,1,33.33,150.25Zm0,6a4.75,4.75,0,0,0,1.18.62,4.35,4.35,0,0,0-1.17.61,4.41,4.41,0,0,0-1.18-.61,4.56,4.56,0,0,0,1.15-.62Zm0,2.65a3.43,3.43,0,0,1,0,4.59A3.46,3.46,0,0,1,33.33,158.9Zm0,6a5.06,5.06,0,0,0,.88.49,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.8,4.8,0,0,0,.85-.49Zm0,2.4a3.44,3.44,0,0,1,0,4.59,3.59,3.59,0,0,1-.87-2.3,3.51,3.51,0,0,1,.85-2.29Zm0,6a4.76,4.76,0,0,0,1.69.75,4.82,4.82,0,0,0-1.68.76,5,5,0,0,0-1.69-.76,4.6,4.6,0,0,0,1.66-.74Zm0,2.93a3.54,3.54,0,0,1,.88,2.3,3.44,3.44,0,0,1-.88,2.28,3.47,3.47,0,0,1,0-4.57Zm0,6a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4,4,0,0,0,.85-.5Zm1.94,4.7a4.5,4.5,0,0,0-1.15-3A3.59,3.59,0,0,1,36,183.4v-1.34a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.57,3.57,0,0,1,36,175h.25a4.31,4.31,0,0,0,.88-.09v15.68a4,4,0,0,0-.85-.09H36a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.13-3ZM36,123.55h.25a4.32,4.32,0,0,0,.88-.1v15.69a4,4,0,0,0-.84-.09h0L36,139a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6A3.61,3.61,0,0,1,36,132v-1.35a3.57,3.57,0,0,1-1.88-.54,4.49,4.49,0,0,0,0-6A3.48,3.48,0,0,1,36,123.55Zm-1.82,3.54a3.45,3.45,0,0,1-.88,2.29,3.51,3.51,0,0,1-.87-2.29,3.59,3.59,0,0,1,.87-2.3,3.53,3.53,0,0,1,.89,2.3Zm-4.42,13.46h.87a3.55,3.55,0,0,1,1.88.54,4.6,4.6,0,0,0-1.15,3,4.55,4.55,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55V149a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm0,17a5.29,5.29,0,0,0,.56,0h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.88.54V166a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm0,17.34a5.23,5.23,0,0,0,.56,0h.31a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.34a3.65,3.65,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.26a3.92,3.92,0,0,0-.59,0Zm3.54,15.7a4.61,4.61,0,0,0,1.69.76,4.34,4.34,0,0,0-1.68.76,4.61,4.61,0,0,0-1.69-.76,4.51,4.51,0,0,0,1.69-.71Zm0,2.93a3.54,3.54,0,0,1,.88,2.3,3.45,3.45,0,0,1-.88,2.29,3.38,3.38,0,0,1,0-4.54Zm0,6a4.25,4.25,0,0,0,.88.5,4.14,4.14,0,0,0-.87.49,4.21,4.21,0,0,0-.88-.49,4.06,4.06,0,0,0,.88-.45Zm1.94,4.7a4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.88-.54V199.4a3.56,3.56,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6A3.57,3.57,0,0,1,36,192.3h.25a4.31,4.31,0,0,0,.88-.09V207.9c-.29,0-.58-.08-.85-.1H36a3.47,3.47,0,0,1-1.88-.55,4.61,4.61,0,0,0,1.16-3ZM36,244.34h.25a4.31,4.31,0,0,0,.88-.09v15.68a4,4,0,0,0-.84-.09H36a3.47,3.47,0,0,1-1.88-.55,4.45,4.45,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.34a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6A3.53,3.53,0,0,1,36,244.34Zm-2.7,7.24a4.25,4.25,0,0,0,.88.5,4.14,4.14,0,0,0-.87.49,4.21,4.21,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5Zm0,2.4a3.44,3.44,0,0,1,0,4.59,3.46,3.46,0,0,1,0-4.59Zm0,6a5,5,0,0,0,1.69.76,4.55,4.55,0,0,0-1.68.75,5,5,0,0,0-1.69-.76,4.72,4.72,0,0,0,1.69-.73Zm0,2.93a3.54,3.54,0,0,1,.88,2.3,3.44,3.44,0,0,1-.88,2.28,3.48,3.48,0,0,1-.87-2.28,3.52,3.52,0,0,1,.88-2.29Zm0,6a5.06,5.06,0,0,0,.88.49,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,5,5,0,0,0,.88-.48Zm1.94,4.69a4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.88-.54v-1.35a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.25a4.31,4.31,0,0,0,.88-.09v15.69a4,4,0,0,0-.84-.1H36a3.47,3.47,0,0,1-1.88-.55,4.63,4.63,0,0,0,1.13-2.95ZM36,72.39h.25a4.31,4.31,0,0,0,.88-.09V88l-.85-.11H36a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3A3.65,3.65,0,0,1,36,80.79V79.45a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.57,3.57,0,0,1,36,72.39Zm-2.7,7.23a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.25,4.25,0,0,0,.88-.5Zm0,2.4a3.45,3.45,0,0,1,0,4.6A3.48,3.48,0,0,1,33.3,82Zm0,6a4.75,4.75,0,0,0,1.18.62,4.69,4.69,0,0,0-1.17.62,4.75,4.75,0,0,0-1.18-.62A4.82,4.82,0,0,0,33.31,88Zm0,2.65a3.54,3.54,0,0,1,.88,2.3,3.45,3.45,0,0,1-.88,2.29A3.49,3.49,0,0,1,32.44,93a3.53,3.53,0,0,1,.87-2.32Zm0,6a5.11,5.11,0,0,0,.88.5,4.14,4.14,0,0,0-.87.49,4.21,4.21,0,0,0-.88-.49,4.72,4.72,0,0,0,.88-.49Zm0,2.4a3.44,3.44,0,0,1,0,4.59A3.46,3.46,0,0,1,33.3,99.07Zm0,6a4.41,4.41,0,0,0,1.18.61,4.69,4.69,0,0,0-1.17.62,4.75,4.75,0,0,0-1.18-.62,4.35,4.35,0,0,0,1.18-.59Zm0,2.65a3.52,3.52,0,0,1,.88,2.29,3.45,3.45,0,0,1-.88,2.29A3.45,3.45,0,0,1,33.3,107.72Zm0,6a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.21,4.21,0,0,0,.88-.49Zm0,2.4a3.43,3.43,0,0,1,0,4.59A3.46,3.46,0,0,1,33.3,116.12Zm0,6a4.75,4.75,0,0,0,1.18.62,4.69,4.69,0,0,0-1.17.62,4.17,4.17,0,0,0-1.18-.62,4.69,4.69,0,0,0,1.18-.6Zm-3.54,70.13h.88a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.56,3.56,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85ZM33.31,208a4.78,4.78,0,0,0,1.69.76,4.55,4.55,0,0,0-1.68.75,4.76,4.76,0,0,0-1.69-.75A4.82,4.82,0,0,0,33.31,208Zm0,2.93a3.43,3.43,0,0,1,0,4.59A3.46,3.46,0,0,1,33.31,210.93Zm0,6a5.06,5.06,0,0,0,.88.49,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.72,4.72,0,0,0,.87-.51Zm0,2.4a3.44,3.44,0,0,1,0,4.59,3.59,3.59,0,0,1-.87-2.3,3.51,3.51,0,0,1,.87-2.31Zm0,6a4.76,4.76,0,0,0,1.69.75,4.82,4.82,0,0,0-1.68.76,4.78,4.78,0,0,0-1.69-.76,4.66,4.66,0,0,0,1.68-.76Zm0,2.93a3.52,3.52,0,0,1,.88,2.29,3.47,3.47,0,0,1-.88,2.29,3.45,3.45,0,0,1,0-4.58Zm0,6a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.26,4.26,0,0,0,.87-.52Zm0,2.4a3.43,3.43,0,0,1,0,4.59A3.46,3.46,0,0,1,33.31,236.66Zm0,6a4.61,4.61,0,0,0,1.69.76,4.34,4.34,0,0,0-1.68.76,4.61,4.61,0,0,0-1.69-.76,4.51,4.51,0,0,0,1.68-.77Zm-3.54,1.63a3.53,3.53,0,0,0,.56.05h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.56,3.56,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm0,17.34h.87a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.35a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm3.54,15.7a4.61,4.61,0,0,0,1.69.76,4.82,4.82,0,0,0-1.68.76,4.78,4.78,0,0,0-1.69-.76,4.51,4.51,0,0,0,1.68-.77Zm0,2.94a3.52,3.52,0,0,1,.88,2.29,3.45,3.45,0,0,1-.88,2.29,3.45,3.45,0,0,1,0-4.58Zm0,6a4.25,4.25,0,0,0,.88.5,4.64,4.64,0,0,0-.87.49,4.21,4.21,0,0,0-.88-.49,4.26,4.26,0,0,0,.87-.52Zm0,2.4a3.44,3.44,0,0,1,0,4.59,3.58,3.58,0,0,1-.87-2.29,3.47,3.47,0,0,1,.88-2.32ZM35.24,291a4.61,4.61,0,0,0-1.14-3,3.63,3.63,0,0,1,1.87-.54v-1.34a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3A3.49,3.49,0,0,1,36,279h.25a4.31,4.31,0,0,0,.88-.09V294.6a6,6,0,0,0-.85-.1H36a3.48,3.48,0,0,1-1.88-.56,4.6,4.6,0,0,0,1.13-3Zm3,8.78V50.29H31.78l1.75-1.75H40V301.47H33.53l-1.75-1.75Zm161.4-262v-6l1.75,1.75v6H48.65v-6L50.4,31.7v6Zm5.16,274.53,1.59,1.59h-1.48v-.52a6.25,6.25,0,0,0-.15-1.14Zm-6.1-5.12H51.34A6.16,6.16,0,0,0,47,308.9l-.75-.75A7.27,7.27,0,0,1,51.34,306H198.66a7.16,7.16,0,0,1,4.93,1.93l-.76.76a6.14,6.14,0,0,0-4.17-1.61ZM45.24,37.82h0l-1.61-1.6h1.51v.52A6.57,6.57,0,0,0,45.24,37.82Zm6.1,5.1H198.66a6.21,6.21,0,0,0,4.3-1.74l.74.74a7.23,7.23,0,0,1-5,2H51.34A7.2,7.2,0,0,1,46.41,42l.75-.76A6.13,6.13,0,0,0,51.34,42.92ZM214.78,309.73l-1.08,1.07-1,1.05-.06.06a3.84,3.84,0,0,0-1-1.54l.31-.31.71-.1,1-.14,1-.14Zm-11.23-.23.75-.75,1.43-1.44a3.88,3.88,0,0,0,1,1.55l-.31.31-1.63.22-1.16.16h0Zm6.61-.62.39.38.35.35-.5.5-.36.36h0l-.36.36-.5.5-.35-.35-.38-.39-.27-.26-.39-.39-.35-.35.5-.49.36-.36h0l.37-.37.49-.49.35.35.39.38Zm-5.11,1,1.33.18.2.19a3.7,3.7,0,0,0-.85,1.44h0l-2-2Zm8.65-.47-1-.14-.71-.1-.2-.2a3.73,3.73,0,0,0,.85-1.43l.06.06,1,1,.88.88ZM209,305l-.25,1.89-.31.31a4,4,0,0,0-1.55-1l1.58-1.58.61-.6h0Zm-1.92,8a3.48,3.48,0,0,0,.69-.29,4,4,0,0,0,.75-.55l.2.2v.35l.15,1.05L209,315l-1.23-1.23Zm2.33.76.15-1.05.05-.35.31-.31a3.71,3.71,0,0,0,.86.66,3.48,3.48,0,0,0,.69.29l-.76.76-1.44,1.43v-.05Zm1.37-8.06.46.46a4,4,0,0,0-1.44.85l-.19-.2-.23-1.66-.13-1ZM203.54,40.28l.47-.47,1.72-1.72h0a3.74,3.74,0,0,0,.94,1.5l-.31.31-1.33.18-1.34.18h-.12Zm11.24.22-1.08,1.08-1,1.05-.06.06a3.84,3.84,0,0,0-1-1.54l.31-.31.71-.1,1-.14,1-.14Zm-5.62-1.84.35.35.39.38.26.27.39.38.35.35-.5.5-.36.36h0l-.36.36-.5.5-.35-.35-.38-.39-.27-.26-.39-.39-.35-.35.5-.49.36-.36h0l.37-.36Zm-4.41,2,1.63.22.2.19a3.73,3.73,0,0,0-.85,1.43l-1.33-1.32-.66-.66ZM208.52,43l.2.2.25,1.89.1.74-.5-.5-1.49-1.49A3.8,3.8,0,0,0,208.52,43Zm.71,3,.15-1.11.23-1.67.31-.31a3.77,3.77,0,0,0,1.55,1l-.37.37L209.27,46Zm4.47-5.76-1-.15L212,40l-.2-.2a3.73,3.73,0,0,0,.85-1.43l.06.06,1,1,.88.88ZM211.24,37a4.48,4.48,0,0,0-.68.29,4,4,0,0,0-.75.55l-.2-.19-.05-.36-.15-1L209.25,35l1.22,1.23Zm-2.33-.76-.14,1-.05.36-.31.31a4.1,4.1,0,0,0-.88-.67,4,4,0,0,0-.67-.29l.76-.76,1.43-1.42h0Zm-6.5,11.28v255H47.59v-255ZM35.21,40.28l1.09-1.09,1.05-1h0a3.88,3.88,0,0,0,1,1.55l-.31.31-.7.09-1.05.15-1,.14Zm5.62-1.62.35.35.39.38.26.27.39.38.35.35-.5.5-.36.36h0l-.37.36-.49.5-.35-.35-.38-.39-.27-.26-.39-.39-.35-.35.5-.49.36-.36h0l.37-.36Zm2.47,2.49.31-.31,1.64-.23,1.15-.15h.05l-.75.75-1.44,1.44A3.9,3.9,0,0,0,43.3,41.15Zm1.65-1L43.61,40l-.2-.2a3.73,3.73,0,0,0,.85-1.43h0l2,2Zm-8.65.47,1.05.14.7.1.2.19a3.73,3.73,0,0,0-.85,1.43h0l-1.1-1.11-.89-.89Zm2.45,3.21A3.93,3.93,0,0,0,40.19,43l.2.2.22,1.67.13,1-1.51-1.51ZM40.9,46l.12-.89.25-1.89.32-.31a3.77,3.77,0,0,0,1.55,1l-1.6,1.59-.6.6Zm2-9a4.48,4.48,0,0,0-.68.29,4.6,4.6,0,0,0-.76.55l-.2-.19v-.36l-.15-1L40.92,35l1.22,1.23Zm-2.33-.76-.15,1v.36l-.31.31a4.1,4.1,0,0,0-.88-.67,4,4,0,0,0-.67-.29l.76-.76,1.43-1.42h0Zm5.87,273.52-.46.45-1.73,1.73h0a3.84,3.84,0,0,0-1-1.51l.31-.31,1.34-.18,1.34-.19h.2Zm-11.24-.23,1.09-1.09,1.05-1.05v-.05a3.88,3.88,0,0,0,1,1.55l-.31.31-.7.09-1,.15-1,.14Zm5.62,1.85-.35-.35-.38-.39-.27-.26-.39-.39-.35-.35.5-.49.36-.36h0l.37-.37.49-.49.35.35.39.38.26.27.39.38.35.35-.5.5-.36.36h0l-.37.36Zm.64-4.31-.2-.2L41,305l-.1-.74.5.5,1.49,1.48a3.91,3.91,0,0,0-1.42.76Zm-5.17,2.78,1.05.14.7.1.2.19a3.7,3.7,0,0,0-.85,1.44v-.05l-1-1.05-.89-.89Zm9-.43-1.64-.22-.2-.2a3.73,3.73,0,0,0,.85-1.43l1.33,1.33.66.66Zm-4.49-5.34-.15,1.12-.22,1.67-.31.31a4,4,0,0,0-1.55-1l.35-.35,1.8-1.83Zm-2,9a3.16,3.16,0,0,0,.68-.29,3.78,3.78,0,0,0,.76-.55l.2.2v.35l.15,1,.16,1.23-1.23-1.23Zm2.33.76.15-1v-.35l.32-.31a3.71,3.71,0,0,0,.86.66,3.48,3.48,0,0,0,.69.29l-.77.76L41,315.27v0ZM36.3,37.71v-1.5h1.5Zm0,5.14.12.13.93.92V44h.1l.79.79.42.42a6,6,0,0,0-1.4-.17h-1Zm5.31,4,.74-.74a7.2,7.2,0,0,1,2.17,5.14V298.79A7.16,7.16,0,0,1,42.23,304l-.74-.74a6.12,6.12,0,0,0,2-4.5V51.22a6.18,6.18,0,0,0-1.88-4.4ZM36.3,306.93V305h1a7,7,0,0,0,1.11-.11Zm0,5.14.12.13h0l1.6,1.59H36.3Zm8.92.37a5.69,5.69,0,0,0-.08.83v.52H43.86Zm168.48-.15v1.5h-1.5Zm0-5.13-.13-.13h0l-.92-.92V306h-.1l-1.21-1.21a6.43,6.43,0,0,0,1.38.17h1Zm-5.32-4-.75.74a7.2,7.2,0,0,1-2.16-5.14V51.22A7.19,7.19,0,0,1,207.76,46l.74.74a6.14,6.14,0,0,0-2,4.5V298.79a6.1,6.1,0,0,0,1.88,4.4ZM213.7,43.07v2h-1a5.78,5.78,0,0,0-1.1.11Zm0-5.13-.13-.13h0L212,36.21h1.74Zm-8.92-.39a5.56,5.56,0,0,0,.09-.82v-.52h1.26ZM31,31H49.66L47.9,32.7H32.79V47.8L31,49.55ZM219,319.05H200.34l1.76-1.75h15.11V302.22l1.76-1.76ZM199.29,29.9l-7.38-7.36h34.74l-7.37,7.36Zm-148.58,0h-20l-7.37-7.36H58.09ZM37.14,54.12a3.42,3.42,0,0,1-.9.12H36a4.83,4.83,0,0,0-1.19.18l2.35-2.34Zm-3.83,2.43a3.43,3.43,0,0,1,0,4.58,3.45,3.45,0,0,1-.88-2.29A3.52,3.52,0,0,1,33.31,56.55Zm0,6a4.18,4.18,0,0,0,.87.5,4.14,4.14,0,0,0-.87.49,5.06,5.06,0,0,0-.88-.49,4.89,4.89,0,0,0,.89-.51Zm0,2.4a3.44,3.44,0,0,1,0,4.59A3.46,3.46,0,0,1,33.31,65Zm0,6a4.62,4.62,0,0,0,1.23.63,4.56,4.56,0,0,0-1.22.63,4.77,4.77,0,0,0-1.23-.63A4.56,4.56,0,0,0,33.31,71Zm-3.54,1.38a5.23,5.23,0,0,0,.56,0h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.65,3.65,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.26a5.81,5.81,0,0,0-.59,0Zm0,17a3.53,3.53,0,0,0,.56,0h.32a3.47,3.47,0,0,1,1.88.55,4.49,4.49,0,0,0,0,6,3.57,3.57,0,0,1-1.88.54v1.35a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm0,17.06a5.23,5.23,0,0,0,.56,0h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.26a5.81,5.81,0,0,0-.59,0Zm0,103.17h.87a3.47,3.47,0,0,1,1.88.55,4.6,4.6,0,0,0-1.15,3,4.5,4.5,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55V218a3.57,3.57,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85Zm0,17.34h.87a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.26a5.81,5.81,0,0,0-.59,0Zm0,52a5.23,5.23,0,0,0,.56,0h.31a3.47,3.47,0,0,1,1.88.55,4.43,4.43,0,0,0,0,6,3.47,3.47,0,0,1-1.88.55v1.34a3.57,3.57,0,0,1,1.88.54,4.6,4.6,0,0,0-1.15,3,4.42,4.42,0,0,0,.3,1.52l-1.91-1.9ZM36,295.54h.31a3.28,3.28,0,0,1,.88.12v2.26l-2.65-2.65A4.54,4.54,0,0,0,36,295.54ZM30.72,320.1h20l7.38,7.36H23.35Zm168.57,0h20l7.37,7.36H191.91Zm13.55-24.41a3.77,3.77,0,0,1,1-.14h.26a4.78,4.78,0,0,0,1.5-.26L212.84,298Zm7.38-18.49h-.8a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.35a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.77Zm0-17.33h-.79a3.47,3.47,0,0,1-1.88-.55,4.45,4.45,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.34a3.56,3.56,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.91-.55h.77Zm0-17.34h-.8a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3,3.65,3.65,0,0,1,1.88-.55v-1.34a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.58,3.58,0,0,1,1.91-.56h.26a4.34,4.34,0,0,0,.51,0Zm0-17.34h-.79a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54v-1.35a3.47,3.47,0,0,1-1.88-.55,4.5,4.5,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.77Zm0-103.17h-.8a3.47,3.47,0,0,1-1.88-.55,4.6,4.6,0,0,0,1.15-3,4.5,4.5,0,0,0-1.15-3,3.65,3.65,0,0,1,1.88-.55v-1.34a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.6,4.6,0,0,0-1.15-3,3.57,3.57,0,0,1,1.91-.55h.77Zm0-17h-.79a3.47,3.47,0,0,1-1.88-.55,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.88-.54V96.5a3.57,3.57,0,0,1-1.88-.54,4.49,4.49,0,0,0,0-6,3.57,3.57,0,0,1,1.91-.55h.26a4.34,4.34,0,0,0,.51,0Zm0-34.14h-.8a3.47,3.47,0,0,1-1.88-.55,4.45,4.45,0,0,0,0-6,3.69,3.69,0,0,1,1.88-.54V62.37a3.47,3.47,0,0,1-1.88-.55,4.55,4.55,0,0,0,1.15-3,4.83,4.83,0,0,0-.18-1.19l1.71,1.71Zm-6.1-16.58h-.31a3.72,3.72,0,0,1-1-.14V52l2.44,2.43a4.37,4.37,0,0,0-1.13-.18ZM175.51,30v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.66,4.66,0,0,0-3,1.14,3.56,3.56,0,0,1-.55-1.9V30a4.49,4.49,0,0,0-.06-.73h15.65A4.48,4.48,0,0,0,175.51,30Zm-17.09,0v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.56,3.56,0,0,1-.55-1.88H150a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.48,3.48,0,0,1-.55-1.9V30a4.49,4.49,0,0,0-.06-.73H158.5A4.17,4.17,0,0,0,158.42,30Zm-17.1,0v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.54-1.88h-1.35a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.66,4.66,0,0,0-3,1.14,3.48,3.48,0,0,1-.55-1.9V30a4.49,4.49,0,0,0-.06-.73h15.65a4.48,4.48,0,0,0-.05.73Zm-17.09,0v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.56,3.56,0,0,1-.55-1.88h-1.34a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.57,3.57,0,0,1-.56-1.9V30a4.49,4.49,0,0,0-.06-.73h15.66A4.48,4.48,0,0,0,124.23,30Zm-17.1,0v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0A3.57,3.57,0,0,1,100,30.3H98.69a3.47,3.47,0,0,1-.55,1.88,4.54,4.54,0,0,0-3-1.14,4.61,4.61,0,0,0-3,1.14,3.48,3.48,0,0,1-.55-1.9V30c0-.24,0-.49-.06-.73h15.65A4.48,4.48,0,0,0,107.13,30ZM90,30v.3a3.47,3.47,0,0,1-.55,1.88,4.5,4.5,0,0,0-6,0,3.56,3.56,0,0,1-.55-1.88H81.59a3.55,3.55,0,0,1-.54,1.88,4.5,4.5,0,0,0-6,0,3.49,3.49,0,0,1-.56-1.9V30a4.49,4.49,0,0,0-.06-.73H90.1A4.42,4.42,0,0,0,90,30ZM22.6,23.29,30,30.65v20L22.6,58Zm8.12,28.05H36.4L29,58.7H23.35Zm-.95,8.1,1.79-1.79a4.83,4.83,0,0,0-.18,1.19,4.55,4.55,0,0,0,1.15,3,3.47,3.47,0,0,1-1.88.55v1.34a3.69,3.69,0,0,1,1.88.54,4.45,4.45,0,0,0,0,6,3.57,3.57,0,0,1-1.91.55h-.85ZM29,291.31l7.38,7.36H30.72l-7.37-7.36Zm1,8.1v19.94l-7.38,7.36V292.06ZM74.5,320v-.3a3.48,3.48,0,0,1,.56-1.88,4.5,4.5,0,0,0,6,0,3.57,3.57,0,0,1,.54,1.88H83a3.69,3.69,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9V320a4.49,4.49,0,0,0,.06.73H74.44A4.17,4.17,0,0,0,74.5,320Zm17.09,0v-.3a3.47,3.47,0,0,1,.55-1.88,4.61,4.61,0,0,0,3,1.14,4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88H100a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9V320a4.49,4.49,0,0,0,.06.73H91.54A4.48,4.48,0,0,0,91.59,320Zm17.1,0v-.3a3.47,3.47,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.47,3.47,0,0,1,.55,1.88h1.34a3.47,3.47,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9V320a4.49,4.49,0,0,0,.06.73H108.63A4.17,4.17,0,0,0,108.69,320Zm17.1,0v-.3a3.47,3.47,0,0,1,.55-1.88,4.61,4.61,0,0,0,3,1.14,4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.35a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9V320a4.49,4.49,0,0,0,.06.73H125.73A4.49,4.49,0,0,0,125.79,320Zm17.09,0v-.3a3.47,3.47,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.47,3.47,0,0,1,.55,1.88h1.34a3.47,3.47,0,0,1,.55-1.88,4.5,4.5,0,0,0,6,0,3.57,3.57,0,0,1,.56,1.9V320a4.49,4.49,0,0,0,.06.73H142.82a4.49,4.49,0,0,0,.06-.73Zm17.1,0v-.3a3.47,3.47,0,0,1,.55-1.88,4.61,4.61,0,0,0,3,1.14,4.54,4.54,0,0,0,3-1.14,3.47,3.47,0,0,1,.55,1.88h1.35a3.57,3.57,0,0,1,.54-1.88,4.5,4.5,0,0,0,6,0,3.56,3.56,0,0,1,.55,1.9V320a4.49,4.49,0,0,0,.06.73H159.92A4.41,4.41,0,0,0,160,320Zm67.42,6.68h0l-7.4-7.33V299.41l7.38-7.35h0ZM227.4,58,220,50.6v-20l7.38-7.36h0V58ZM59.14,21.49H21.55V59l-1.76,1.75v-41H60.9Zm169.31,268-.53.52-.22.22h-6.43V59.75h6.43l.22.22.53.52,1,1H223v227h6.43Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.39,172.25a8.06,8.06,0,0,1,.26-1H83.56V105.74a41,41,0,0,1,4.09-17.9,41.86,41.86,0,0,1,3-5.19c.74-1.1,1.54-2.16,2.39-3.19a40.72,40.72,0,0,1,4.11-4.3c1-.89,2-1.74,3.07-2.53s2.17-1.54,3.31-2.23c.57-.35,1.15-.68,1.73-1,1.18-.63,2.38-1.22,3.62-1.74A41.3,41.3,0,0,1,125,64.41h2.12a42,42,0,0,1,4.18.42,38.24,38.24,0,0,1,4,.83c1.28.34,2.62.75,3.89,1.21a42.47,42.47,0,0,1,19.61,15c.61.84,1.18,1.71,1.72,2.6a41,41,0,0,1,5.94,21.31v65.47H138.89c.09.34.19.68.26,1h28.32V105.74a42.13,42.13,0,0,0-9.71-26.94,43,43,0,0,0-12.53-10.31c-.61-.33-1.22-.64-1.84-.94a42.38,42.38,0,0,0-36.79,0c-.62.3-1.23.61-1.83.94A42.9,42.9,0,0,0,92.23,78.8a42.13,42.13,0,0,0-9.71,26.94v66.51Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.69,181.92v62.34a38,38,0,0,0,1,8.62c.21.93.46,1.84.74,2.73.19.6.39,1.19.6,1.78a38.47,38.47,0,0,0,4.22,8.22c.69,1,1.43,2,2.21,2.95a35.4,35.4,0,0,0,2.48,2.71c.54.54,1.09,1.07,1.67,1.57a35.63,35.63,0,0,0,3.62,2.84c.63.44,1.27.86,1.93,1.25a31.63,31.63,0,0,0,3.26,1.77c1.12.54,2.26,1,3.43,1.45s2.37.8,3.59,1.12a38.72,38.72,0,0,0,19.13,0c1.22-.32,2.42-.69,3.59-1.12s2.32-.91,3.44-1.45,2.2-1.13,3.25-1.77a38.42,38.42,0,0,0,7.23-5.66c.86-.86,1.69-1.77,2.47-2.71s1.52-1.93,2.21-2.95a38.47,38.47,0,0,0,4.22-8.22c.21-.59.42-1.18.6-1.78q.42-1.34.75-2.73a38,38,0,0,0,1-8.62V181.92H137.6c-.15.26-.3.51-.46.76a8.28,8.28,0,0,1-.76,1,14.19,14.19,0,0,1-3.88,3.4h25.58v57.13a32.68,32.68,0,0,1-5.66,18.44c-.59.88-1.23,1.73-1.9,2.55a33.86,33.86,0,0,1-4.49,4.47,31.23,31.23,0,0,1-2.55,1.9,33,33,0,0,1-37,0,31.23,31.23,0,0,1-2.55-1.9,33.2,33.2,0,0,1-4.48-4.47c-.68-.82-1.31-1.67-1.91-2.55a32.69,32.69,0,0,1-4.81-11,33.32,33.32,0,0,1-.85-7.45V187.13H118a14.38,14.38,0,0,1-3.89-3.4l-.75-1a5.13,5.13,0,0,1-.46-.76Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.18,270.76,49.39,301.47h75.08v-5.23A52.17,52.17,0,0,1,80.18,270.76Zm-.24,3.64a54.18,54.18,0,0,0,7.17,8.6,29.5,29.5,0,0,0-16.93,1.14Zm42.32,24.1v.73H55L61.23,293a26.81,26.81,0,0,1,33.69-3.56,54.64,54.64,0,0,0,27.34,9.06Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,244.26V219.63H48.65v81.1l31-30.92A51.45,51.45,0,0,1,72.88,244.26ZM51,295.23V221.91H70.66v22.37a54.14,54.14,0,0,0,3.51,19.17L73.9,263a5.83,5.83,0,0,0-.43,9.84ZM72,268a4.76,4.76,0,0,1,2.33-4.1,55.44,55.44,0,0,0,2.49,5.5l-3,3,.3-.43A4.82,4.82,0,0,1,72,268Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,296.24v5.23h75.09l-30.8-30.72A52.14,52.14,0,0,1,125.52,296.24Zm69.5,3H127.73v-.73a54.56,54.56,0,0,0,27.34-9.07A26.81,26.81,0,0,1,188.76,293ZM179.81,284a30,30,0,0,0-10.36-1.87,29.68,29.68,0,0,0-6.57.74,54.18,54.18,0,0,0,7.17-8.6Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.47,53.76V48.54H49.39L80.18,79.25A52.17,52.17,0,0,1,124.47,53.76Zm-69.5-3h67.29v.74a54.64,54.64,0,0,0-27.34,9.06A26.82,26.82,0,0,1,61.23,57Zm15.2,15.1a29.92,29.92,0,0,0,10.38,1.88A29.52,29.52,0,0,0,87.11,67a54.26,54.26,0,0,0-7.17,8.61Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.82,79.26l30.79-30.72H125.53v5.22A52.15,52.15,0,0,1,169.82,79.26Zm.24-3.76a54.24,54.24,0,0,0-7.18-8.6,29.68,29.68,0,0,0,6.57.74,30.1,30.1,0,0,0,10.37-1.88Zm-42.33-24v-.74H195L188.76,57a26.82,26.82,0,0,1-33.69,3.55,54.52,54.52,0,0,0-27.34-9Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,105.74A51.5,51.5,0,0,1,79.63,80.2l-31-30.92v81.1H72.88Zm4-25.15a50.32,50.32,0,0,0-2.49,5.5A4.77,4.77,0,0,1,74.1,78l-.3-.43Zm-6.2,47.51H51V54.78L73.47,77.2A5.84,5.84,0,0,0,73.9,87l.27-.47a54.1,54.1,0,0,0-3.51,19.17Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88,181.33v-5.8H69l.53-.53-.52-.52h3.87v-43H48.65v43h4l-.52.52.53.53h-4v43.05H72.88ZM53.62,175l.52-.52,2.28-2.28,2.28-2.27.1-.1,1-1,1.07-1.07,1.07,1.07,1,1,.09.1,2.29,2.27,2.28,2.28.4.52-.53.53-2.29,2.28L63,180.08h0l-.08.08-1,1-1.06,1.05-1.06-1.05-1-1-.08-.08h0l-2.28-2.27-2.28-2.28Zm.71-33.56a5,5,0,0,0,4.42-4.4H60.3v29.81l-1.6,1.59a5,5,0,0,0-4.37-4Zm0-1V137h3.38a3.94,3.94,0,0,1-3.38,3.41ZM62.91,137a5,5,0,0,0,4.42,4.4v11h-6V137ZM63,168.4l-1.6-1.59V153.48h6v11a5,5,0,0,0-4.36,4Zm4.37-2.94v3.38H64a4,4,0,0,1,3.33-3.34Zm0-25.09A4,4,0,0,1,64,137h3.38Zm-13,25.09a4,4,0,0,1,3.38,3.38H54.33Zm13,32.29h-6v-14.6l1.6-1.59a5,5,0,0,0,4.37,4ZM57.71,181.1a4,4,0,0,1-3.38,3.36V181.1Zm6.24,0h3.38v3.36A4,4,0,0,1,64,181.14ZM54.33,213v-3.4a3.93,3.93,0,0,1,3.38,3.4Zm4.42,0a5,5,0,0,0-4.42-4.41v-23a5,5,0,0,0,4.37-4l1.6,1.59V213Zm2.61-14.14h6v9.73A5,5,0,0,0,62.91,213H61.36ZM64,213a3.93,3.93,0,0,1,3.38-3.37V213ZM51,172.2V133.71H70.66V172.2H66.73l-2.29-2.27h3.94V136H53.28v33.94h3.93l-2.28,2.27Zm19.66,44.1H51V177.81h3.94l2.28,2.27H53.28V214h15.1V180.09H64.44l2.27-2.27h4Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.11,105.74v24.64h24.24V49.28l-31,30.92A51.61,51.61,0,0,1,177.11,105.74Zm21.88-51V128.1H179.33V105.74a54,54,0,0,0-3.42-18.9l.24.53a5.86,5.86,0,0,0,.63-10.43ZM178.62,82a4.81,4.81,0,0,1-2.87,4.41,53.89,53.89,0,0,0-2.62-5.8l3.26-3.26-.25.45A4.8,4.8,0,0,1,178.62,82Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.11,174.48H181l-.52.52.53.53h-3.88v43.05h24.24V175.53h-4l.53-.53-.52-.52h4v-43H177.11ZM182.73,137h3.38a3.94,3.94,0,0,1-3.38,3.37Zm4.42,0h1.49v15.39h-6v-11A5,5,0,0,0,187.15,137Zm4.16,0a5,5,0,0,0,4.35,4.39v23a5,5,0,0,0-4.31,4l-1.66-1.65V137Zm5.06,38-.53.53-2.28,2.28-2.28,2.27h0l-1,1-1.06,1-1.06-1-.9-.9-.15-.15h0l-2.27-2.27-2.29-2.28L182,175l.52-.52,2.28-2.28,2.29-2.27.16-.17.89-.88,1.07-1.07,1.07,1.07,1,1h0l2.28,2.27,2.28,2.28Zm-.71,9.49a3.94,3.94,0,0,1-3.31-3.35h3.31ZM182.73,213v-3.4a3.93,3.93,0,0,1,3.38,3.37Zm-.06-27.43a5,5,0,0,0,4.43-3.92l1.54,1.53v14.64h-6Zm3.44-4.4a3.94,3.94,0,0,1-3.38,3.36v-3.36Zm1,31.84a5,5,0,0,0-4.48-4.42v-9.72h6V213Zm2.54-29.83,1.66-1.65a5,5,0,0,0,4.31,4v23a5,5,0,0,0-4.35,4.41h-1.62Zm2.7,29.82a3.94,3.94,0,0,1,3.31-3.35V213Zm3.31-44.09h-3.31a3.94,3.94,0,0,1,3.31-3.36Zm0-28.49a3.94,3.94,0,0,1-3.31-3.35h3.31Zm-13,13.09h6v13.37l-1.54,1.53a5,5,0,0,0-4.43-3.91Zm.06,12a4,4,0,0,1,3.38,3.38h-3.38ZM199,177.81V216.3H179.33V177.81h3.95l2.27,2.27h-3.94V214h15.17v-5.51h-.07v-22.9h.07v-5.51h-4l2.28-2.27Zm-19.66-44.1H199V172.2h-3.93l-2.28-2.27h4v-5.51h-.07V141.49h.07V136H181.61v33.94h3.94l-2.29,2.27h-3.93Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.11,244.26a51.56,51.56,0,0,1-6.75,25.55l31,30.92v-81.1H177.11Zm-4,25.17a53.17,53.17,0,0,0,2.62-5.81,4.82,4.82,0,0,1,.39,8.62l.25.44Zm6.2-47.52H199v73.32l-22.21-22.16a5.86,5.86,0,0,0-.63-10.43l-.24.53a53.91,53.91,0,0,0,3.42-18.89Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.38,166.28a12.57,12.57,0,0,1,.75,1.05c.16.24.32.49.46.75H163.3V105.74a38.52,38.52,0,0,0-1-8.62q-.33-1.38-.75-2.73a38,38,0,0,0-4.82-10c-.69-1-1.43-2-2.21-2.94-.39-.47-.79-.93-1.2-1.39a39.16,39.16,0,0,0-8.5-7c-1-.64-2.14-1.23-3.25-1.77-.56-.26-1.13-.52-1.7-.76a38.33,38.33,0,0,0-29.79,0c-.57.24-1.14.5-1.69.76-1.12.54-2.21,1.13-3.26,1.77-.68.41-1.34.85-2,1.3S101.67,75.45,101,76a38.73,38.73,0,0,0-4.3,4c-.42.46-.82.92-1.21,1.39-.78.94-1.52,1.93-2.21,2.94a38.35,38.35,0,0,0-4,7.74c-.29.74-.56,1.49-.8,2.26s-.53,1.81-.74,2.73a38,38,0,0,0-1,8.62V168H113c.15-.26.3-.51.46-.75a12.7,12.7,0,0,1,.76-1.05,14.38,14.38,0,0,1,3.89-3.4H91.91V105.74A32.78,32.78,0,0,1,97,88.16c.38-.61.78-1.2,1.21-1.78.15-.22.31-.43.47-.64.41-.53.83-1,1.26-1.54a33.3,33.3,0,0,1,3.36-3.36c.61-.53,1.24-1,1.89-1.54.85-.63,1.73-1.23,2.64-1.78a33.15,33.15,0,0,1,34.29,0c.91.55,1.79,1.15,2.64,1.78A34.26,34.26,0,0,1,149,83.05a32.83,32.83,0,0,1,9.08,22.69v57.14h-25.6A14.11,14.11,0,0,1,136.38,166.28Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,160.89a14.14,14.14,0,0,1,5.06.94H157V105.74a32.06,32.06,0,0,0-41.56-30.52,31.07,31.07,0,0,0-2.94,1.07,33.76,33.76,0,0,0-4.15,2.12,32.26,32.26,0,0,0-4.93,3.68,33.31,33.31,0,0,0-3.18,3.33,32,32,0,0,0-2.68,3.76,32.8,32.8,0,0,0-2.12,4.13c-.21.48-.4,1-.58,1.45a31.75,31.75,0,0,0-1.94,11v56.09h27.25A14.16,14.16,0,0,1,125.27,160.89ZM99.55,88.16a31,31,0,0,1,42-8.56A30.46,30.46,0,0,1,146,83a30.8,30.8,0,0,1,9.86,20.1H94.12a30.71,30.71,0,0,1,1.95-8.5c.35-.89.73-1.76,1.15-2.61A33.14,33.14,0,0,1,99.55,88.16ZM94,105.74v-1.56h62v56.61H94Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.46,101.06h57.07l-.11-.62a28.74,28.74,0,0,0-8.13-15.23c-.44-.44-.89-.85-1.35-1.25A27.71,27.71,0,0,0,141,81.73c-.51-.34-1-.67-1.57-1a29.48,29.48,0,0,0-4.48-2.1,27.89,27.89,0,0,0-4.84-1.3,28.92,28.92,0,0,0-33.55,23.11ZM125,78a27.94,27.94,0,0,1,13.72,3.6,28.69,28.69,0,0,1,3.85,2.62,27.76,27.76,0,0,1,9.7,15.85H97.72A27.86,27.86,0,0,1,125,78Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,98.31A26.21,26.21,0,0,0,147,90.49c-.41-.58-.84-1.15-1.29-1.7a27.1,27.1,0,0,0-3-3.06c-.53-.47-1.09-.92-1.65-1.35a27.45,27.45,0,0,0-5.53-3.2,26.68,26.68,0,0,0-21.17,0,27.45,27.45,0,0,0-5.53,3.2q-.84.65-1.65,1.35a27.1,27.1,0,0,0-3,3.06,26.55,26.55,0,0,0-5,9.52L99,99h52ZM145,89.5h-5.59a19.6,19.6,0,0,0-2.37-2l2.71-2.86a26,26,0,0,1,4.06,3.49C144.17,88.59,144.57,89,145,89.5Zm-19.43,8.44V96.37h.07a21.44,21.44,0,0,0,4-.49c.44-.1.88-.22,1.32-.35a18.1,18.1,0,0,0,2.56-1c.42-.18.84-.39,1.25-.6s.81-.45,1.2-.7l4.53,4.67Zm2-4.84a17.48,17.48,0,0,1-7.4-.52c-.39-.12-.78-.24-1.17-.39a17,17,0,0,1-3.3-1.65h2.11a15.36,15.36,0,0,0,1.72.74,14.51,14.51,0,0,0,1.59.47,15.87,15.87,0,0,0,4,.48,17,17,0,0,0,4.2-.53c.45-.12.9-.26,1.34-.42a15.36,15.36,0,0,0,1.72-.74h2.11a17.34,17.34,0,0,1-6.88,2.56Zm6.88-3.6h-2.11a15.3,15.3,0,0,0-1.72-.73,16.49,16.49,0,0,0-11.09,0,15.3,15.3,0,0,0-1.72.73H115.7a18.88,18.88,0,0,1,2.83-1.45,16,16,0,0,1,1.64-.58,17.48,17.48,0,0,1,7.4-.52c.61.09,1.22.21,1.82.36a17.07,17.07,0,0,1,5,2.19Zm-7.23.52a2.07,2.07,0,0,0-.29-1A15.77,15.77,0,0,1,131,90a13,13,0,0,1-1.49.5,16.11,16.11,0,0,1-2.57.55,2.08,2.08,0,0,0,.21-1.07Zm-4.28,0a2.06,2.06,0,0,0,.28,1,15.38,15.38,0,0,1-4.06-1,14.19,14.19,0,0,1,2-.66,16,16,0,0,1,2.07-.38,2.07,2.07,0,0,0-.37,1Zm9.45-2.79a17.65,17.65,0,0,0-3.55-1.12,18.72,18.72,0,0,0-7.53,0,17.65,17.65,0,0,0-3.55,1.12,18.86,18.86,0,0,0-3.88,2.27h-1.62a19.55,19.55,0,0,1,25.63,0h-1.62a18.31,18.31,0,0,0-4-2.27ZM133,81.3a28.15,28.15,0,0,1,2.68,1.06,26,26,0,0,1,3.21,1.72l-.15.16-2.54,2.69A20.53,20.53,0,0,0,127,83.76c-.47,0-.93-.07-1.39-.08V80.05a10.69,10.69,0,0,1,1.79.1,27.87,27.87,0,0,1,3.51.56c.63.17,1.34.37,2,.59Zm-15.35-.16a25.55,25.55,0,0,1,6.89-1.09v3.63a7.82,7.82,0,0,0-1.36.08A21.07,21.07,0,0,0,117.87,85a20.61,20.61,0,0,0-3.74,1.84L111.36,84c.48-.31,1-.59,1.47-.86a24.77,24.77,0,0,1,4.75-2ZM109,85.64c.48-.38,1-.75,1.49-1.09l2.7,2.85a20.47,20.47,0,0,0-2.55,2.1H105A26.09,26.09,0,0,1,109,85.64Zm-8.3,11.57a25.71,25.71,0,0,1,2.37-5c.36-.58.75-1.15,1.16-1.71h6.41a19.45,19.45,0,0,0,2.77,2.27l-5,5.13h-8a5.51,5.51,0,0,0,.28-.69Zm9.19.73,4.42-4.56A20.46,20.46,0,0,0,118,95.14c.52.19,1,.36,1.59.5a21.05,21.05,0,0,0,4.92.73v1.57Zm10-3.28c-.56-.15-1.11-.33-1.65-.53a17.54,17.54,0,0,1-3.16-1.49,19.37,19.37,0,0,1-2.91-2.1h1.62a18.26,18.26,0,0,0,7.43,3.4,18.72,18.72,0,0,0,7.53,0,18.26,18.26,0,0,0,7.43-3.4h1.62a18.61,18.61,0,0,1-2.39,1.76,17.42,17.42,0,0,1-2.07,1.16,18.92,18.92,0,0,1-3.25,1.2A19.82,19.82,0,0,1,119.89,94.66Zm22,3.28-5.09-5.26a20.61,20.61,0,0,0,2-1.6c.2-.18.4-.35.59-.54h6.41a25.42,25.42,0,0,1,3.79,7.4Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.88,158.6h58.23V106.37H95.88Zm57.19-51.19v50.15H96.93V107.41Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,156.52h0V108.45H98v48.07Zm-53-1v-46h25.46v1H100.05v43.91h24.42v1H99Zm35.13-32.9-4.24-4.23v-6.78h4.24Zm5.28-11v16.23l-4.24-4.23V111.57h3.47l.78.05Zm1,31.65,4.32-2.09V151.4a10.22,10.22,0,0,1-4.24,1.82v-9.95Zm-1.74,10.12H135.2v-7.61l4.24-2v9.62a7,7,0,0,0-.79,0Zm-8.75,0v-5l2.85-1.39,1.39-.67v7.11Zm-4.38,0v-2.93l1.62-.79,1.71-.83v4.55Zm5.15-20.16,4.76-2.3,1,1.42-4.85,2.35Zm-2.33-4.94,2.46-1.19,2.32-1.12,1.28,1.27-5.27,2.55a4.61,4.61,0,0,0-.32-.8,4.19,4.19,0,0,0-.49-.7Zm-.09-7.17-1.84.89-.89.43v-4Zm-2.73,2.47,3.51-1.69,1.26,1.25-4.77,2.31Zm3.29,1.43,2.26-1.09,1.27,1.27-2.6,1.26Zm11.79,8.42L136,135.69l-1-1.46,2.92-1.42,1.42-.69Zm-2.11-2.11-.56.28-.6.29-1-1.43.85-.41Zm-2.06-2.05-3.69,1.8-1-1.36,3.48-1.69Zm-7.62,3.7a4.37,4.37,0,0,0,.51-2v-.12l1.43-.69,1,1.36Zm2,6.36,7.55-3.66,1,1.5L131.5,141Zm14-1.7-7.31,3.54-.89-1.55,6.86-3.32Zm-2.12-2.11-1.65.8-.81.39-1-1.5,2.09-1Zm-14.55-8.3-.61.29a4.3,4.3,0,0,0-2-.79v-.11l2.35-1.14.92,1.44Zm2.44,7.93-1.93.93-.44-1.67,1.51-.73Zm-1.35,3.11-.31-1.15,5-2.44,1,1.46-9.5,4.6v-2l1-.5Zm1.32,3.14-5,2.45v-2l4.34-2.1Zm6,.23-11,5.35v-2l10.16-4.93Zm-11,7.66v-1.16l10.84-5.25,10.23-5-2.12-2.11h0l-2.1-2.1h0l-4.16-4.15h0l-8.26-8.1h0l-4.34-4.33-.17-.17v-1.48l.17.18,22.67,22.62-11.09,5.37Zm17.84,4.09a12.56,12.56,0,0,0,1.52-.85,12.71,12.71,0,0,0,1.36-1.06l1.92,1.91Zm3.62-2.65a11.58,11.58,0,0,0,1.92-2.88v4.79Zm1.91-7.57a10.28,10.28,0,0,1-.84,4.06,12.53,12.53,0,0,1-.79,1.44,9.93,9.93,0,0,1-.82,1.11c-.22.26-.45.5-.69.74v-9.86l1.53-.74,1.62-.78v4Zm-3.14-9V114.45a9.58,9.58,0,0,1,.69.73,9.94,9.94,0,0,1,1.15,1.65,10.06,10.06,0,0,1,1.3,5h0v15.52ZM149,117.1a11.4,11.4,0,0,0-1.92-2.88l1.92-1.91h0Zm-2.66-3.61a11.63,11.63,0,0,0-1.36-1.07,12.56,12.56,0,0,0-1.52-.85h4.8Zm-1.53.08v19.55l-4.24-4.23V111.75a11.29,11.29,0,0,1,1.15.27,10.28,10.28,0,0,1,3,1.55Zm-15.86,3.74L125.52,114v-2.41h3.33Zm-4.38,21.47v2l-10.93-5.3,1-1.5,6.57,3.18-.06.24-.24.91h2.69Zm0,3.13v2l-8.74-4.24,1-1.5Zm0,3.12v2l-3.5-1.7.37-.58.59-.93Zm0,3.12v1.16l-22.84-11.06,22.84-22.79v1.47l-4.5,4.5h0l-8.18,8.16h0l-4.16,4.15h0l-2.1,2.1h0L103.4,138Zm0,5.25h-3.33v-4.55l3.33,1.62Zm-8.62,0v-7.11l4.24,2.06v5.05Zm-4.51,0h-.77v-9.62l4.24,2v7.61Zm-10.24-.74v-4.79a11.58,11.58,0,0,0,1.92,2.88Zm10.2-41.08h3.51v12l-4.24,4.23V111.62a6.74,6.74,0,0,1,.68,0Zm4.55,11v-11h4.24v6.78Zm5.8,5.72c-.11.14-.19.29-.28.43a3.69,3.69,0,0,0-.51,1.08l-1.89-.92.91-1.44Zm-1,2.58V131a3.77,3.77,0,0,0,.14,1,4.45,4.45,0,0,0,.37,1l-7.62-3.7,1.25-1.25Zm-15.5,6.77,1.34-1.33,4.25,2.06-1,1.51Zm5.57,2.7.59-.93.37-.58,9.27,4.49-1,1.51Zm5-2.68-.94,1.5-7.49-3.63.65-.66.66-.66Zm-6.34-4.22,1.33-1.33,2.83,1.37-1,1.51Zm8.72-.8-.92,1.45-5.69-2.76,1.28-1.27ZM119,127l-.57.91-.34.53-2.43-1.17,1.28-1.27Zm2-5.08.77.37-.83,1.46-1.2-.58Zm.88,2.29.83-1.47,1.8.87v1.87Zm-.1-3.07,2.73-2.73v4Zm2.73-7.15-3.33,3.33v-5.74h3.33Zm-15,14.92-4.24,4.23V113.57a10,10,0,0,1,3.09-1.55,11.29,11.29,0,0,1,1.15-.27Zm-3.74-16.85a11.41,11.41,0,0,0-2,1.44l-1.91-1.92h4.8A7.4,7.4,0,0,0,105.79,112.05ZM103,114.22a11.58,11.58,0,0,0-1.92,2.88v-4.79Zm-1.92,7.57a10.14,10.14,0,0,1,3.14-7.34v19.72l-3.14,3.14Zm3.14,18.88v9.86c-.24-.24-.47-.48-.69-.74a10.73,10.73,0,0,1-1.6-2.55,10.12,10.12,0,0,1-.85-4.06h0v-4Zm-2.4,12.73,1.91-1.91a12.83,12.83,0,0,0,1.37,1.06,12.56,12.56,0,0,0,1.52.85Zm3.45-2V141.18l4.31,2.09h-.07v9.95a10.08,10.08,0,0,1-4.22-1.82Zm16-15.3-3.19-1.54.91-1.45,2.72,1.32Zm1.12-8.57-4.8-2.32,1.27-1.27,5.55,2.69v.11a4.94,4.94,0,0,0-1.07.27,4.15,4.15,0,0,0-.89.52Zm2,9.71H122l.18-.67.44-1.68.27-1v-.22l-.24-.21a3.28,3.28,0,0,1-1-2,2.73,2.73,0,0,1-.05-.4,3.06,3.06,0,0,1,.09-.74,3.3,3.3,0,0,1,.81-1.49,2.32,2.32,0,0,1,.44-.39,3.3,3.3,0,0,1,.51-.31,4.48,4.48,0,0,1,.62-.2c.1,0,.19-.07.29-.09a2.26,2.26,0,0,1,.52,0h0a4.51,4.51,0,0,1,.52,0,3.22,3.22,0,0,1,.91.29,3.12,3.12,0,0,1,1,.7,3.16,3.16,0,0,1,.81,1.49,3.06,3.06,0,0,1,.09.74v.4a3.26,3.26,0,0,1-1.06,2l-.24.21.06.22.27,1,.44,1.68.17.67h-3.44ZM151,155.48H125.52v-1h24.42V110.53H125.52v-1H151Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.52,136.2h1l-.22-.84-.27-1-.27-1,.08-.07.63-.57A2.21,2.21,0,0,0,127,132a2.31,2.31,0,0,0,.25-1,1.13,1.13,0,0,0,0-.26,2.16,2.16,0,0,0-.1-.44,1.71,1.71,0,0,0-.17-.39,2.36,2.36,0,0,0-.57-.65,2.11,2.11,0,0,0-.4-.26,2.18,2.18,0,0,0-.45-.16,2.25,2.25,0,0,0-.52-.07h0a3.47,3.47,0,0,0-.45.06h-.07a2.25,2.25,0,0,0-1.34,1,1.29,1.29,0,0,0-.17.33,2.15,2.15,0,0,0-.18.61,1.13,1.13,0,0,0,0,.26,2.17,2.17,0,0,0,.24,1,2.38,2.38,0,0,0,.51.67l.71.63-.27,1-.27,1v.17l-.18.67h2.06Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.45,275.62a43,43,0,0,0,8.32,5.9c.6.32,1.21.64,1.83.93a41.53,41.53,0,0,0,7.79,2.85,42.56,42.56,0,0,0,21.21,0,41.53,41.53,0,0,0,7.79-2.85c.62-.29,1.23-.61,1.84-.93a42.73,42.73,0,0,0,12.53-10.32,42.13,42.13,0,0,0,9.71-26.94v-66.5H139.15c-.07.35-.17.7-.26,1h27.54v65.46a41.12,41.12,0,0,1-10.17,27.08c-.64.74-1.29,1.45-2,2.14-.53.53-1.08,1-1.64,1.54-.82.73-1.66,1.43-2.54,2.09-.26.21-.53.4-.8.6-.73.53-1.47,1-2.23,1.51a41.42,41.42,0,0,1-63.51-35V178.8h28.09c-.1-.34-.19-.69-.26-1H82.52v66.5a42.13,42.13,0,0,0,9.71,26.94A42.58,42.58,0,0,0,96.45,275.62Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93,188.17h0v56.09a31.75,31.75,0,0,0,1.94,11c.18.49.37,1,.58,1.45a32.29,32.29,0,0,0,2.12,4.14,32.27,32.27,0,0,0,10.79,10.75,31.18,31.18,0,0,0,4.15,2.12,30.39,30.39,0,0,0,2.94,1.08A32.07,32.07,0,0,0,157,244.26V188.17H130.35a14,14,0,0,1-10.17,0Zm62.65,60.9a30.74,30.74,0,0,1-4.6,12c-.39.59-.79,1.17-1.22,1.74-.56.75-1.16,1.48-1.79,2.17a31,31,0,0,1-41.87,3.82A31.3,31.3,0,0,1,102,265c-.63-.69-1.23-1.42-1.79-2.17-.43-.57-.83-1.15-1.22-1.74a30.6,30.6,0,0,1-4.86-14.18h61.75c-.07.7-.16,1.44-.27,2.16Zm.38-59.86v56.57H94V189.21Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,256.8a28.18,28.18,0,0,0,2.54,4.26c.49.67,1,1.32,1.53,1.94a28.82,28.82,0,0,0,46.3-3.19,29.78,29.78,0,0,0,1.72-3,28.87,28.87,0,0,0,2.38-7.24l.11-.62H96.46l.12.62A28.37,28.37,0,0,0,99,256.8Zm53.27-6.8a27.1,27.1,0,0,1-1.13,3.83c-.18.5-.37,1-.58,1.47a27.87,27.87,0,0,1-1.84,3.56,25.71,25.71,0,0,1-2,2.86,26.38,26.38,0,0,1-4.92,4.72,27.73,27.73,0,0,1-28.41,3.09c-.53-.24-1.06-.5-1.57-.78a27.16,27.16,0,0,1-3-1.85c-.47-.34-.94-.69-1.39-1.06-.6-.49-1.19-1-1.75-1.54a27.75,27.75,0,0,1-4.4-5.44c-.42-.67-.8-1.36-1.16-2.06q-.41-.8-.75-1.62a29.18,29.18,0,0,1-1.2-3.4c-.16-.59-.31-1.18-.43-1.78Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,271a26.93,26.93,0,0,0,25.77-19.33L151,251H99l.19.66A27,27,0,0,0,125,271Zm-21.94-13.27a17.55,17.55,0,0,1-1-1.8,26.18,26.18,0,0,1-1.6-3.88h7.7l5.1,5.25c-.46.32-.9.65-1.34,1a16.69,16.69,0,0,0-1.26,1.13h-6.41a13.38,13.38,0,0,1-1.19-1.68Zm32.63-1.13a20.66,20.66,0,0,0-10.17-3V252h14.59Zm2.12,2.84h-1.62a18.9,18.9,0,0,0-3.88-2.28,18.28,18.28,0,0,0-3.55-1.11,18.72,18.72,0,0,0-7.53,0,18.28,18.28,0,0,0-3.55,1.11,18.9,18.9,0,0,0-3.88,2.28h-1.62c.35-.3.7-.58,1.06-.85a19.06,19.06,0,0,1,3.4-2.07,19.56,19.56,0,0,1,21.17,2.94ZM125,256.73a17.28,17.28,0,0,1,4.9.7,15.45,15.45,0,0,1,2.3.85,16.25,16.25,0,0,1,2.17,1.18h-2.11a16.42,16.42,0,0,0-14.53,0h-2.1a17.56,17.56,0,0,1,3-1.51,13.3,13.3,0,0,1,1.5-.52,18.19,18.19,0,0,1,2.41-.53A18.49,18.49,0,0,1,125,256.73Zm1.85,4.29a2,2,0,0,0,0-2.08,15,15,0,0,1,4.06,1,14.19,14.19,0,0,1-2,.66,14.41,14.41,0,0,1-2.06.4Zm-3.92-1.59a2,2,0,0,0-.07.55,2,2,0,0,0,.28,1,15,15,0,0,1-4.06-1,15,15,0,0,1,4.06-1,1.85,1.85,0,0,0-.21.45Zm-5.2,1.07a15.36,15.36,0,0,0,1.72.74,15.74,15.74,0,0,0,1.59.47,16.84,16.84,0,0,0,4,.48,16.51,16.51,0,0,0,4.2-.54c.45-.12.9-.26,1.34-.41a15.36,15.36,0,0,0,1.72-.74h2.11a16.25,16.25,0,0,1-2.17,1.18,16.7,16.7,0,0,1-2.3.86,17.27,17.27,0,0,1-4.9.69,19,19,0,0,1-2.5-.17,18.15,18.15,0,0,1-2.41-.52,17.19,17.19,0,0,1-2.3-.86,16.14,16.14,0,0,1-2.16-1.18Zm6.74-6.86a7.65,7.65,0,0,0-1.35.08c-.45.08-.9.09-1.34.16a21.7,21.7,0,0,0-3.63.92l-.69.26a21,21,0,0,0-3.35,1.68l-4.53-4.67h14.89Zm-17,9.46c-.43-.4-.86-.82-1.27-1.25s-.81-.89-1.19-1.35h5.59a19.6,19.6,0,0,0,2.37,2l-2.71,2.86a25.9,25.9,0,0,1-2.76-2.26Zm15.18,6.76a25.79,25.79,0,0,1-3.5-.57,25.2,25.2,0,0,1-5-1.7c-.74-.34-1.46-.73-2.17-1.14-.29-.18-.59-.34-.88-.53l2.69-2.84a20.45,20.45,0,0,0,6.82,2.8,19.74,19.74,0,0,0,2.41.36c.46,0,.92.07,1.38.08V270c-.53-.06-1.13-.09-1.72-.14Zm-10.5-9.36h1.62a18.21,18.21,0,0,0,3.88,2.28,19,19,0,0,0,3.55,1.12,19.47,19.47,0,0,0,7.53,0,19,19,0,0,0,3.55-1.12,18.21,18.21,0,0,0,3.88-2.28h1.62a19.56,19.56,0,0,1-25.6,0Zm20.23,8.37a26,26,0,0,1-6.89,1.09v-3.64a7.76,7.76,0,0,0,1.36-.08,20.48,20.48,0,0,0,9.06-3.05l2.7,2.86c-.49.3-1,.59-1.48.86a27,27,0,0,1-4.72,2Zm10-5.69a24.64,24.64,0,0,1-2.26,1.82c-.21.15-.41.31-.63.46l-2.7-2.86a19.77,19.77,0,0,0,2.55-2.1H145a26.31,26.31,0,0,1-2.6,2.68Zm4.53-5.43c-.36.59-.75,1.16-1.16,1.71h-6.41c-.43-.42-.88-.83-1.34-1.2s-.94-.73-1.43-1.07l5-5.12h8a24.67,24.67,0,0,1-2.64,5.68Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.11,191.4H95.88v52.24h58.23ZM96.92,242.6V192.44h56.15V242.6Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,193.48h0v48.08h54V193.48Zm36.18,10.23-4.24-2.05v-5h4.24Zm5.28-7.06v9.62l-4.24-2.05v-7.61h3.47c.22,0,.47,0,.73,0Zm1,10.09h0v-10a10.2,10.2,0,0,1,3.28,1.2,9.35,9.35,0,0,1,1,.63v10.22l-4.31-2.09Zm-5.28,31.69V226.38l4.24-4.23v16.24h-4.24Zm-5.28,0v-6.78l2.12-2.11,2.12-2.12v11Zm-5.43-15.06-.77.38-1.58.76-.92-1.43.61-.3.64-.31a4.3,4.3,0,0,0,2,.79Zm0,1.16v1.87L121,228.1l-1.26-1.25,2.32-1.13Zm0,7.08-2.73-2.73,2.73-1.32Zm0,1.47v1.47l-22.84-22.79,11.75-5.7,11.09-5.37v1.16l-10.22,5-10.85,5.26h0l2.12,2.11h0l2.1,2.09h0l4.16,4.16h0l8.18,8.16h0Zm0,5.35h-3.33v-5.74l3.33,3.33Zm-8.62,0v-11l4.24,4.23v6.78Zm-4.51,0h-.77V222.15l4.24,4.23v12.05Zm-1.74-31.69-4.31,2.09V198.61a9.35,9.35,0,0,1,1-.63,10.2,10.2,0,0,1,3.28-1.2v10Zm-5.85-8.22-1.91-1.91h4.79A11.28,11.28,0,0,0,103.75,198.52Zm-.74.74a11.19,11.19,0,0,0-1.37,1.9,9.54,9.54,0,0,0-.55,1v-4.8Zm-1.91,7.57a10.08,10.08,0,0,1,1.3-5,10.58,10.58,0,0,1,1.15-1.65c.22-.25.45-.5.69-.73v9.85l-1.62.79-1.53.74v-4Zm3.14,9v19.72c-.24-.23-.47-.48-.69-.73a10,10,0,0,1-1.6-2.56,10.12,10.12,0,0,1-.85-4.06h0V212.7Zm-3.15,21.86v-4.8a11.58,11.58,0,0,0,1.92,2.88l-1,1Zm.74.73,1.92-1.91a11.16,11.16,0,0,0,2.89,1.91Zm4.42-1.37a9.35,9.35,0,0,1-1-.63V216.88l4.24,4.23v17.15a10.2,10.2,0,0,1-3.28-1.2Zm5.09-40.45h3.47v7.61l-4.24,2v-9.62c.25,0,.51,0,.77,0Zm4.51,7.1v-7.1h4.24v5Zm9.67,27.87Zm2-9.11,4.79,2.33L131,226.06l-5.55-2.7v-.1a5,5,0,0,0,1.08-.27,4.38,4.38,0,0,0,1-.52Zm1.11-8.57,3.19,1.55-.91,1.44-2.72-1.31Zm12.72,1.88-7.12-3.45.58-.92.36-.58,7.5,3.64Zm2.1-2.09-4.25-2.06,1-1.52,4.63,2.24Zm-4.24-4-1,1.52-9.27-4.5,1-1.51Zm1.36,6.91-1.33,1.32-2.82-1.36,1-1.51Zm-15.08,9.84v-1.87l2.63,1.28-.83,1.46Zm3.57-.14,1.2.59L129,228.1l-.77-.37Zm2.88-4.69,2.43,1.17-.64.64-.64.64-2.06-1Zm6.52-2.91L137.18,220l-5.33-2.58.92-1.44Zm-2.06,2.05L135.18,222l-5.87-2.83v-.12a4.37,4.37,0,0,0-.51-2Zm-6.32,1.85-1.77-.86a4.16,4.16,0,0,0,.47-.71,4.51,4.51,0,0,0,.32-.79l1.9.91-.34.54Zm-4.59,5,2.73,1.32-2.56,2.55v-2.65h-.17Zm0,5.52,4.51-4.5h0l8.18-8.16h0l4.16-4.16h0l2.1-2.09h0l1.06-1.06,1.06-1h0l-21.07-10.21v-1.16l22.84,11.07-22.84,22.79ZM129,204.7l-1,1.51L125.52,205v-2Zm5.24,5.67-1,1.5-7.79-3.77v-2Zm2.19,4.18-.37.58-.58.93-6.57-3.18.3-1.16h-2.68l-1-.5v-2Zm-10.93-1.79h2.36l-.18.68-.43,1.67-.27,1v.17h0l.24.21a3.28,3.28,0,0,1,1,2,2.73,2.73,0,0,1,.05.4,3,3,0,0,1-.09.73,3.43,3.43,0,0,1-.81,1.5,3.31,3.31,0,0,1-.44.39,2.62,2.62,0,0,1-.51.3,3.22,3.22,0,0,1-.91.29,2.31,2.31,0,0,1-.52.06h0a2.33,2.33,0,0,1-.53-.06,3.22,3.22,0,0,1-.91-.29,3.13,3.13,0,0,1-1.81-2.19,3,3,0,0,1-.09-.73,2.73,2.73,0,0,1,0-.4,3.28,3.28,0,0,1,1-2l.11-.1.13-.11h0l-.06-.21-.27-1-.43-1.67-.18-.68h3.41Zm-20.34-.41,7.3-3.53.89,1.54-6.86,3.33Zm13.74,13.72-1.27-1.27,2.6-1.27.93,1.44Zm-9.53-9.51,4.63-2.24,1,1.46-4.34,2.1Zm9.93.2-4.76,2.31-1-1.43,4.85-2.35Zm1.86.26a4.48,4.48,0,0,0-.38,1,4.22,4.22,0,0,0-.13,1v.12l-1,.46-.47.23-1-1.36Zm-9.54-2.71-1-1.49,7.8-3.78.71,1.62Zm-.14,4.35,1.16-.56,1,1.43-.84.41Zm2.06,2.05,3.7-1.79,1,1.36L114.81,222Zm3.31,3.31-1.28-1.28,5.27-2.54a4.51,4.51,0,0,0,.32.79,4.16,4.16,0,0,0,.47.71Zm2.54-9.19,1.92-.93.44,1.68-1.51.73Zm4-3.11h-2.68l.3,1.16-5,2.44-1-1.46,9.5-4.6v2Zm-4-3.14,5-2.45v2l-4.33,2.1Zm5-3.6-3.32,1.61-6.84,3.32-.88-1.55,11-5.35Zm-14.72,8.3,1,1.49-2.09,1-1.32-1.31Zm14.72-13.74-3.33,1.61v-4.54h3.33Zm1,38.89V236l3.33-3.33v5.74Zm14.94-17.32,4.24-4.23v19.55a5.25,5.25,0,0,1-.58.38,9.64,9.64,0,0,1-1.41.77,10.43,10.43,0,0,1-2.25.68Zm2.89,17.32c.24-.11.45-.25.67-.37a11.29,11.29,0,0,0,2.22-1.54l1.92,1.91Zm3.63-2.65c.17-.18.31-.4.46-.59a10.94,10.94,0,0,0,1.45-2.29v4.8Zm1.91-7.57h0a10.08,10.08,0,0,1-1.5,5.29,10.37,10.37,0,0,1-.95,1.33c-.22.25-.45.5-.69.73V215.84l3.14-3.14Zm0-21.38h0v4l-3.14-1.53v-9.85a10.19,10.19,0,0,1,3.14,7.35ZM147,199.26l1.91-1.92v4.8A11.28,11.28,0,0,0,147,199.26Zm-.74-.74a11.28,11.28,0,0,0-2.88-1.91h4.79Zm-17.39,2.63-3.33-1.61v-2.93h3.33ZM99,240.51v-46h25.46v1H100.05v43.9h24.42v1H99Zm52,0H125.52v-1h24.42v-43.9H125.52v-1H151Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,213.8h-1.54l.22.85.27,1,.27,1-.71.64a2.17,2.17,0,0,0-.73,1.93,2.07,2.07,0,0,0,.1.43,2.3,2.3,0,0,0,.74,1,2.06,2.06,0,0,0,.4.25,2.2,2.2,0,0,0,.45.17,2.33,2.33,0,0,0,.53.06h0a2.24,2.24,0,0,0,.52-.06A2,2,0,0,0,126,221a2.14,2.14,0,0,0,.41-.25,2.29,2.29,0,0,0,.55-.65,2.87,2.87,0,0,0,.18-.4,2.07,2.07,0,0,0,.1-.43V219a2.21,2.21,0,0,0-.75-1.67l-.71-.64.27-1,.27-1,.22-.85H125Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.92,177.81l1.91,1.91,1.91-1.91L65,175.53l.54-.53-.52-.52-2.28-2.28-1.93-1.92L58.9,172.2l-2.28,2.28-.52.52.54.53Zm2.35-5.61,2.28,2.28.52.52-.54.53-2.28,2.28-.42.42-.42-.42-2.28-2.28-.54-.53.52-.52,2.28-2.28.44-.43Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.09,172.2l-1.93-1.92-1.92,1.92L185,174.48l-.52.52.54.53,2.28,2.28,1.91,1.91,1.91-1.91,2.29-2.28.53-.53-.52-.52Zm1.31,2.8-.53.53-2.29,2.28-.42.42-.42-.42-2.28-2.28-.54-.53.52-.52,2.29-2.28.43-.43.44.43,2.28,2.28Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.51,53.05H145.64l2.26,1a57.89,57.89,0,0,1,6.88,3.63,27.74,27.74,0,0,0,14.64,4.2A27.1,27.1,0,0,0,188.61,54Zm-39,1.05H160.8L159,58.66a26.75,26.75,0,0,1-3.61-1.86c-1.61-1-3.24-1.88-4.9-2.7Zm11.42,0h7.39l-2.79,6.55a26.51,26.51,0,0,1-6.57-1.6Zm5.69,6.67,2.85-6.67h8.39L175,60.22a26.43,26.43,0,0,1-7.42.55Zm8.85-.91,3.63-5.76H187a25.9,25.9,0,0,1-10.53,5.76Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.65,58.68a57.24,57.24,0,0,1,8.41-4.62l2.26-1H60.48l2.36,2.36a25,25,0,0,0,17.53,7.26A23.86,23.86,0,0,0,93.65,58.68Zm5.84-4.58a58.38,58.38,0,0,0-6.42,3.7,20.54,20.54,0,0,1-1.92,1.13L89.23,54.1Zm-11.39,0,2.11,5.32a22.78,22.78,0,0,1-6.4,1.94l-3.1-7.26Zm-8.53,0,3.15,7.39a22.41,22.41,0,0,1-7.12-.37l-4.42-7Zm-16,.57L63,54.1h6.91l4.19,6.65a24,24,0,0,1-10.51-6.08Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.78,292.31A56.88,56.88,0,0,1,147.9,296l-2.26,1h43.87l-.9-.89A27.35,27.35,0,0,0,154.78,292.31Zm-4.31,3.59q2.5-1.23,4.86-2.69a26.81,26.81,0,0,1,3.61-1.87l1.82,4.56Zm11.42,0-2-4.95a26.06,26.06,0,0,1,6.57-1.59l2.79,6.54Zm8.54,0-2.85-6.66a26.51,26.51,0,0,1,7.38.54l3.86,6.12Zm16.49,0h-6.86l-3.63-5.76A26,26,0,0,1,186.92,295.9Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.48,297h43.84l-2.26-1a57.24,57.24,0,0,1-8.41-4.62,23.84,23.84,0,0,0-13.28-4,25,25,0,0,0-17.53,7.27Zm39-1.05H89.23l1.92-4.82a20.44,20.44,0,0,1,1.92,1.12,55,55,0,0,0,6.42,3.65Zm-11.39,0H80.71l3.1-7.26a22.8,22.8,0,0,1,6.4,1.95Zm-5.38-7.38L79.56,296H71.18l4.42-7a23.92,23.92,0,0,1,4.77-.5,23.06,23.06,0,0,1,2.35.07Zm-19.13,6.82a23.94,23.94,0,0,1,10.53-6.08L69.92,296H63Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.28,60.28v65.55h15.1V105.74c0-1.56.07-3.14.2-4.69a50.21,50.21,0,0,0-14.4-39.87Zm1,26.18a5.59,5.59,0,0,1,3.79,1.22c1.4,1.2,2.11,3.21,2.11,6h0v31.1H54.33ZM67.53,101c-.14,1.58-.2,3.19-.2,4.78v19h-6v-6.9c.07-4.89.63-16,4.19-19.63a3.22,3.22,0,0,1,2.2-1.09C67.68,98.41,67.63,99.68,67.53,101Zm-2.79-3.5c-1.74,1.76-2.74,5-3.44,8.5V72.26a49.38,49.38,0,0,1,6.39,23.83A4.37,4.37,0,0,0,64.74,97.5ZM54.33,62.84a48.64,48.64,0,0,1,5.91,7.65V88.71a6.12,6.12,0,0,0-1.44-1.83,6.54,6.54,0,0,0-4.47-1.47Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,105.74v20.09h15.1V60.28l-.9.9a49.33,49.33,0,0,0-7.06,8.91h-.05v.08A50.67,50.67,0,0,0,181.41,101C181.55,102.61,181.61,104.18,181.61,105.74Zm.85-4.78a51.92,51.92,0,0,1,.09-9.33,3.39,3.39,0,0,1,2,1.08c3,3,3.84,11.16,4.1,16.64v15.42h-6v-19a46.84,46.84,0,0,0-.19-4.77Zm13.2,23.81h-5.9v-10h.09c0-.26.06-2.55-.09-5.62v-21h.1c0-2.78.71-4.79,2.11-6a5.59,5.59,0,0,1,3.69-1.22Zm0-44.89a6.59,6.59,0,0,0-4.37,1.47,6.35,6.35,0,0,0-1.53,2V70.47a48.42,48.42,0,0,1,5.9-7.63Zm-7-7.63V100c-.66-3.3-1.71-6.31-3.34-8a4.47,4.47,0,0,0-2.7-1.38,49,49,0,0,1,6.08-18.37Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.38,244.28V224.19H53.28v65.54l.9-.89A50.23,50.23,0,0,0,68.58,249C68.45,247.41,68.38,245.84,68.38,244.28Zm-.85,4.78c.1,1.27.15,2.54.16,3.81a3.35,3.35,0,0,1-2.2-1.09c-3.56-3.64-4.12-14.75-4.19-19.63v-6.91h6v19C67.33,245.86,67.39,247.47,67.53,249.06Zm-13.2-23.82h5.91v31.11h0c0,2.77-.71,4.79-2.11,6a5.65,5.65,0,0,1-3.79,1.23Zm0,39.37h.22a6.62,6.62,0,0,0,4.25-1.47,6.38,6.38,0,0,0,1.44-1.83v18.22a48.1,48.1,0,0,1-5.91,7.64Zm7,13.14v-33.7c.66,3.48,1.72,6.71,3.44,8.46a4.36,4.36,0,0,0,3,1.41,49.36,49.36,0,0,1-6.47,23.83Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.7,279.92h.05a49.4,49.4,0,0,0,7.06,8.92l.9.89V224.19h-15.1v20.09c0,1.55-.06,3.13-.2,4.69a50.64,50.64,0,0,0,7.29,30.87Zm7,7.25a47.39,47.39,0,0,1-5.9-7.63V266.66a6.24,6.24,0,0,0,1.53,2,6.64,6.64,0,0,0,4.26,1.47h.11Zm0-18.08a5.64,5.64,0,0,1-3.68-1.22c-1.41-1.2-2.12-3.21-2.12-6h-.1v-21c.15-3.08.1-5.37.09-5.63h-.09v-10h5.9Zm-13.2-20c.14-1.59.21-3.2.21-4.78v-19h6v15.42c-.26,5.48-1.15,13.63-4.1,16.65a3.32,3.32,0,0,1-2,1.07,52.59,52.59,0,0,1-.15-9.39Zm.2,10.36a4.34,4.34,0,0,0,2.7-1.38c1.63-1.67,2.68-4.69,3.34-8v27.72a49.21,49.21,0,0,1-6.08-18.37Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.94,
    y1: 22.25,
    x2: 183.06,
    y2: 22.25,
    style: {
      fill: "none",
      stroke: "#524c4b",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.94,
    y1: 327.75,
    x2: 183.06,
    y2: 327.75,
    style: {
      fill: "none",
      stroke: "#524c4b",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.58,
    y1: 65.71,
    x2: 227.58,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#524c4b",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.42,
    y1: 65.71,
    x2: 22.42,
    y2: 284.31,
    style: {
      fill: "none",
      stroke: "#524c4b",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,187.5A12.5,12.5,0,1,1,137.79,175,12.5,12.5,0,0,1,125.27,187.5Zm0-24.24A11.75,11.75,0,1,0,137,175v0A11.78,11.78,0,0,0,125.27,163.26Z",
    style: {
      fill: "#524c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,54.8A51.1,51.1,0,0,0,81,80h0l-.19.19a50.49,50.49,0,0,0-6.87,25.48V244.26a51.06,51.06,0,0,0,102.12,0V105.74A51.07,51.07,0,0,0,125,54.8Zm44.56,119.53H139.39v1.35h30.17v68.58a44.57,44.57,0,0,1-89.13,0V175.68h30.72v-1.35H80.43V105.74a44.57,44.57,0,0,1,89.13,0Z",
    style: {
      fill: "#141e2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.23,292.06h0A48,48,0,0,1,77.34,244h0l-.47-137.88a48,48,0,0,1,47.88-48.12h0a48,48,0,0,1,47.89,48.11h0l.47,137.88a48,48,0,0,1-47.88,48.12Z",
    style: {
      fill: "none",
      stroke: "#ed2c2a",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.75,312.83h41.1A4.14,4.14,0,0,1,150,317h0a4.14,4.14,0,0,1-4.14,4.14h-41.1a4.14,4.14,0,0,1-4.14-4.14h0A4.14,4.14,0,0,1,104.75,312.83Z",
    style: {
      fill: "#524c4b",
      stroke: "#141e2e",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75,28.79h41.1A4.14,4.14,0,0,1,150,32.93h0a4.14,4.14,0,0,1-4.14,4.14h-41.1a4.14,4.14,0,0,1-4.14-4.14h0A4.14,4.14,0,0,1,104.75,28.79Z",
    style: {
      fill: "#524c4b",
      stroke: "#141e2e",
      strokeMiterlimit: 10,
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(130.03 34.91)",
    style: {
      isolation: "isolate",
      fontSize: "6.550346851348877px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "5000"), /*#__PURE__*/React.createElement("text", {
    id: "topNumber",
    transform: "translate(104.81 34.91)",
    style: {
      isolation: "isolate",
      fontSize: "6.550346851348877px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "5000"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(122.84 34.41)",
    style: {
      isolation: "isolate",
      fontSize: "4.204105377197266px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "OF"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(120.87 314.89) rotate(180)",
    style: {
      isolation: "isolate",
      fontSize: "6.550346851348877px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "5000"), /*#__PURE__*/React.createElement("text", {
    id: "bottomNumber",
    transform: "translate(146.09 314.89) rotate(180)",
    style: {
      isolation: "isolate",
      fontSize: "6.550346851348877px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "5000"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(128.06 315.4) rotate(180)",
    style: {
      isolation: "isolate",
      fontSize: "4.204105377197266px",
      fill: "#141e2e",
      fontFamily: "Courier-Bold, Courier",
      fontWeight: 700
    }
  }, "OF")), /*#__PURE__*/React.createElement("path", {
    d: "M134.62,175l-1.37.65a4,4,0,0,0-1.44,6.12h0l0,0a4,4,0,0,0-6.07,1.42l-.66,1.41-.66-1.39a4,4,0,0,0-6.09-1.42h0a4,4,0,0,0-1.44-6.12l-1.37-.65,1.37-.65a4,4,0,0,0,1.44-6.12h0a4,4,0,0,0,6.09-1.42l.66-1.39.66,1.41a4,4,0,0,0,6.07,1.42l0,0h0a4,4,0,0,0,1.44,6.12Z",
    style: {
      fill: "#ed2c2a",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,178c-.4-1-.84-2-1.3-3,.46-1,.9-2,1.3-3,.9-.36,1.79-.74,2.68-1.16,1,.47,2,.91,3,1.33.37,1,.79,1.91,1.23,2.85-.44.94-.84,1.89-1.23,2.86-1,.4-2,.85-3,1.32C124,178.76,123.13,178.38,122.23,178Z",
    style: {
      fill: "#ed2c2a",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.04,
    y1: 165.42,
    x2: 125.04,
    y2: 170.82,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.89,
    y1: 179.18,
    x2: 124.89,
    y2: 184.58,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.55,
    y1: 175.07,
    x2: 129.14,
    y2: 175.07,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.79,
    y1: 174.93,
    x2: 115.38,
    y2: 174.93,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.69,
    y1: 181.83,
    x2: 127.87,
    y2: 178,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.06,
    y1: 172,
    x2: 118.24,
    y2: 168.17,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.14,
    y1: 181.73,
    x2: 121.96,
    y2: 177.91,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.97,
    y1: 172.09,
    x2: 131.79,
    y2: 168.27,
    style: {
      fill: "none",
      stroke: "#141e2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.82e7ad4902cc030b0b92b6219cab39db.svg";
export { ForwardRef as ReactComponent };